//NOTE: atheneumAPI.js must run before this script

/**
Forms setup and rendering
 */
var requestedContacts = false;
var contactsLoaded = false;

var pollingForRemoteConsentNotif = false;
var pollingForCertificate = false;
var remoteConsentNotifInterval = 10000;
var prevNotifInterval = 47000;

var signatureContentType = "image/jpeg"
var globalImageBuffer = {};
var attendeeList = [];
var attendeeListCloned = [];
var meetingAttendeeTimeOut;

window.dateHasChange = false;

var atheneumInstance = SalesToolkit;

async function updateWhenContactsReady(callbacks, showProgress = false){
	
	if(!atheneumInstance.Contacts.contactsLoaded){
		setTimeout(function(){
			updateWhenContactsReady(callbacks, showProgress);
		}, 1000);

		return;
	}

	let totalContacts = await atheneumInstance.Contacts.getTotalNumberOfContacts();

	if (showProgress &&  totalContacts == 0) {

		let percentageDisplay = document.getElementById(
			"salestoolkit-initial-contacts-sync-progress-percentage"
		  );

		  if(percentageDisplay)
		  percentageDisplay.innerHTML =  0 + "%";
		  
		 let contactsProgressBar = document.getElementById(
			"salestoolkit-initial-contacts-sync-progress-bar"
		  );

		  if(contactsProgressBar)
			contactsProgressBar.style.width = 0 + "%";
		 let contactsProgressText = document.getElementById("salestoolkit-initial-contacts-sync-progress-text");
		 if(contactsProgressText)
			contactsProgressText.innerHTML = atheneumInstance.Translation.get('initiatingContactSync', 'Starting Contacts Sync')
		$('#salestoolkit-initial-contacts-sync-modal').modal('show');

		callbacks.progress = function(progress, json){
		
			percentageDisplay.innerHTML = Math.floor(progress.percentage) + "%";
		   	contactsProgressBar.style.width = progress.percentage + "%";
			   contactsProgressText.innerHTML =
			   atheneumInstance.Translation.getFormatted(
				 "initialContactSyncCollectionData",
				 "Synced {0} of {1} collections",
				 [progress.syncedContacts, progress.totalContacts]
			   );
			
		};
	}

	if (totalContacts > 0 && SalesToolkit.Theme.getBooleanProperty('onlyLoadContactsOnForm', false) && window.location.href.indexOf('viewForm') < 0) {
		return;
	}

	atheneumInstance.Contacts.update(callbacks);
}

if (atheneumInstance.Theme.getBooleanProperty('autoLoadContacts', true)) {
	if(atheneumInstance.Contacts)
		atheneumInstance.Contacts.__preferLiveQueryToCache = false;
	requestedContacts = true;
	contactsLoaded = false;
}

var initialise = async function () {

	if (atheneumInstance.Theme.getBooleanProperty('badgeScanAllowed', false)) {
		atheneumInstance.Badges.pollForLatestScannedBadge();
	}
	if (atheneumInstance.Theme.getBooleanProperty('autoLoadContacts', true)) {
		if(atheneumInstance.Contacts)
			atheneumInstance.Contacts.__preferLiveQueryToCache = false;
		requestedContacts = true;
		contactsLoaded = false;

		if(atheneumInstance.Theme.getBooleanProperty('delayContactsLoading', false)){

			let locations = (window.location.href.indexOf('viewForm') < 0 && window.location.href.indexOf('contacts') < 0 && window.location.href.indexOf('meetings') < 0);
			if(atheneumInstance.Theme.getBooleanProperty('includeCartInContactsNeeded', false)){
				locations = (window.location.href.indexOf('viewForm') < 0 && window.location.href.indexOf('contacts') < 0 && window.location.href.indexOf('meetings') < 0 && window.location.href.indexOf('cart') < 0 && !(window.location.href.indexOf('index.html') >= 0 && !document.body.classList.contains('module-cart')));
			}

			if(atheneumInstance.Theme.getBooleanProperty('showLoadingContactsPopup', false) && !locations && typeof vPopup !== 'undefined'){
				var popup = vPopup.create({
					title: atheneumInstance.Translation.getOrGetThemeKey('loadingCachedContactsTitle', 'Loading Contacts'),
					message: atheneumInstance.Translation.getOrGetThemeKey('loadingCachedContactsMessage', 'Please wait...'),
					buttons: [
					]
				});

			}

			if(atheneumInstance.Theme.getBooleanProperty('showLoadingContactsFormWheel', false))
				$('#form-holder').activity(true);

			setTimeout(function(){
				
				let atheneumContacts = atheneumInstance.Contacts;
				const promise = Promise.resolve(atheneumContacts.loadFromStorage()).then(async (value) => {
					let numContacts = await atheneumContacts.getTotalNumberOfContacts();
					atheneumContacts.totalNumberOfContacts = numContacts;
					atheneumContacts.caching = numContacts == 0;
					atheneumContacts.contactsLoaded = true;

					if(typeof popup !== 'undefined')
						$(popup).remove();
					$('#form-holder').activity(false);
					
					updateWhenContactsReady({
						success: async function () {
							if (requestedContacts) {
								contactsLoaded = true;
								if (window.location.href.indexOf('contacts.html') >= 0) {
									await showContactsScreen();
								}
							}
			
							$('#salestoolkit-initial-contacts-sync-modal').modal('hide');

							// if(atheneumInstance.Theme.getBooleanProperty('deleteOrphanedContacts', true)){
							// 	await atheneumInstance.Contacts.deleteOrphanedContacts();
							// }
						}
					}, atheneumInstance.Theme.getBooleanProperty('showInitialContactsSync', false));
				}); // promise: always a promise
			}, 0);
		}else{
			updateWhenContactsReady({
				success: async function () {
					if (requestedContacts) {
						contactsLoaded = true;
						if (window.location.href.indexOf('contacts.html') >= 0) {
							await showContactsScreen();
						}
					}
	
					$('#salestoolkit-initial-contacts-sync-modal').modal('hide');

					// if(atheneumInstance.Theme.getBooleanProperty('deleteOrphanedContacts', true)){
					// 	await atheneumInstance.Contacts.deleteOrphanedContacts();
					// }
				}
			}, atheneumInstance.Theme.getBooleanProperty('showInitialContactsSync', false));
		}

		
	}else{
		atheneumInstance.Contacts.__preferLiveQueryToCache = true;
	}

	if(ignoreUpdate){
		return;
	}
	let formCount = Object.values(atheneumInstance.Forms.formList).length;
	atheneumInstance.Forms.update({
		success: async function () {
			if (requestedContacts) {
				contactsLoaded = true;
			}

			let postUpdateFormCount = Object.values(atheneumInstance.Forms.formList).length;

			if(typeof collectionBrowser !== 'undefined' && formCount !== postUpdateFormCount){
				collectionBrowser.refresh();
			}

			if(typeof addFormsToSideMenu === 'function'){
				addFormsToSideMenu();
			}

			// if(atheneumInstance.Theme.getBooleanProperty('deleteOrphanedContacts', true)){
			// 	await atheneumInstance.Contacts.deleteOrphanedContacts();
			// }
		}
	});

}

$(async function() {
	await initialise();
  });



function formatDate(date) {
	var dateString = '-';
	if (date != null && date instanceof Date) {
		var day = date.getDate();
		if (day < 10) {
			day = '0' + day;
		}
		var month = date.getMonth() + 1;
		if (month < 10) {
			month = '0' + month;
		}
		dateString = day + '/' + month + '/' + date.getFullYear();
	}
	else if ($.isNumeric(date)) {
		return formatDate(new Date(date));
	}
	return dateString;
}

function formatDateTime(datetime) {
	var dateString = '-';
	if (datetime != null && datetime instanceof Date && datetime.getTime() === datetime.getTime()) {
		var day = datetime.getDate();
		if (day < 10) {
			day = '0' + day;
		}
		var month = datetime.getMonth() + 1;
		if (month < 10) {
			month = '0' + month;
		}
		var hours = datetime.getHours();
		if (hours < 10) {
			hours = '0' + hours;
		}
		var mins = datetime.getMinutes();
		if (mins < 10) {
			mins = '0' + mins;
		}
		dateString = day + '/' + month + '/' + datetime.getFullYear() + ' ' + hours + ':' + mins;// + ' ' + (datetime.getHours() < 12 ? 'am' : 'pm');
	}else if(datetime != null && datetime instanceof Date && datetime.getTime() !== datetime.getTime()){
		return '';
	}
	else if ($.isNumeric(datetime)) {
		return formatDateTime(new Date(datetime));
	}
	return dateString;
}

function supportsWhatsApp() {
	var userAgent = navigator.userAgent || navigator.vendor || window.opera;
	if (/android/i.test(userAgent)) {
		return true;
	} else if (/iPhone/i.test(userAgent)) {
		return true;
	}

	if (SalesToolkit.CrossPlatform.enabled) {
		return true;
	}

	return false;
}

function hideShareLinkPopup() {
	$('#shareLinkPopup').hide();
}

var goToMeetingAfterShareLinkPopup = false;
function showShareLinkPopup(link, email, formType, subject, goToMeetings) {

	var whatsAppLink = 'https://web.whatsapp.com/send?text=';
	if (supportsWhatsApp()) {
		whatsAppLink = 'whatsapp://send?text=';
	}
	var shareLinkPopupEmailSubject = ((!subject || /^\s*$/.test(subject)) ? atheneumInstance.Theme.getStringProperty('shareLinkPopupEmailSubject', '') : subject);

	$('#whatsapp-link').attr('href', whatsAppLink + encodeURI(link));
	$('#downloadInput').val(link);
	$('.qrCode img').attr('src', 'https://trustrack.atheneum.co/dms/public/barcode.png?type=QR_CODE&width=230&height=230&margin=0&content=' + encodeURI(link));
	var shareLinkPopupEmailBody = atheneumInstance.Theme.getStringProperty('shareLinkPopupEmailBody', '{link}');
	if (shareLinkPopupEmailBody.indexOf('{link}') != -1) {
		shareLinkPopupEmailBody = shareLinkPopupEmailBody.replace('{link}', encodeURI(link));
	}

	$('#sms-link').attr('href', 'sms:?&body='+shareLinkPopupEmailBody);
	
	if (formType === 'CREATE_MEETING') {
		let subjectText = (shareLinkPopupEmailSubject === '')? '' : '&subject=' + encodeURI(shareLinkPopupEmailSubject);
		$('#email-link').attr('href', 'mailto:?bcc=' + encodeURI(email) + subjectText + '&body=' + encodeURI(shareLinkPopupEmailBody));
	} else {
		let subjectText = (shareLinkPopupEmailSubject === '')? '?' : '?subject=' + encodeURI(shareLinkPopupEmailSubject) + '&';
		$('#email-link').attr('href', 'mailto:' + encodeURI(email) + subjectText + 'body=' + encodeURI(shareLinkPopupEmailBody));
	}

	if (goToMeetings)
		goToMeetingAfterShareLinkPopup = true;
	else
		goToMeetingAfterShareLinkPopup = false;

	$('#form-holder').activity(false);
	$('#shareLinkPopup').modal('show');
}

function closedShareLinkPopup() {
	if (goToMeetingAfterShareLinkPopup)
		showMeetingsScreen();
}

/**
 * 
 * @param {FormRef} form
 * @param {boolean} download
 * @param {boolean} cart
 */
function renderForm(form, download, cart, formElement, cartSkipEmail, ignorePasswords = false, asRemote = false) {

	if(typeof window.form === 'undefined')
		window.form = form;
	var $form = $(formElement);
	$form.html('');

	window.$formElement = $form;

	var formProperties = form.properties || {};

	var formTitle = formProperties['titleHTML'] || atheneumInstance.Translation.get(form.title, form.title);
	if ((formTitle == undefined) && form.type == atheneumInstance.Forms.Types.VEND) {
		formTitle = atheneumInstance.Translation.getOrGetThemeKey('shareingTitle', 'Sharing')
	}

	$form.data('type', form.type);
	$form.attr("data-contact-maxSubmissionsPerContact", form.maxSubmissionsPerContact);
	$form.attr("data-contact-includeOtherFormSubmissionsInCount", form.includeOtherFormSubmissionsInCount);
	$form.attr("data-contact-requireConsent", form.requireConsent);
	$form.attr("data-contact-requireContact", form.requireContact);
	$form.displayContactSuggestions = form.displayContactSuggestions;
	$form.displayConsentStatusInSuggestions = form.displayConsentStatusInSuggestions;
	$form.displaySubmissionStatusInSuggestions = form.displaySubmissionStatusInSuggestions;

	if(typeof $form.displayContactSuggestions === 'undefined')
		$form.displayContactSuggestions = SalesToolkit.Theme.getBooleanProperty('displayContactSuggestionsDefault', true);

	if(typeof $form.displayConsentStatusInSuggestions === 'undefined')
		$form.displayConsentStatusInSuggestions = SalesToolkit.Theme.getBooleanProperty('displayConsentStatusInSuggestionsDefault', true);
	
	if(typeof $form.displaySubmissionStatusInSuggestions === 'undefined')
		$form.displaySubmissionStatusInSuggestions = SalesToolkit.Theme.getBooleanProperty('displaySubmissionStatusInSuggestionsDefault', false);

	if (cart){
		$form.data('assetIds', atheneumInstance.Cart.assetIds);
		if(!$form.displayContactSuggestions)
			$form.displayContactSuggestions = SalesToolkit.Theme.getBooleanProperty('displayContactSuggestionsCartOverride', false);

		if(!$form.displayConsentStatusInSuggestions)
			$form.displayConsentStatusInSuggestions = SalesToolkit.Theme.getBooleanProperty('displayConsentStatusInSuggestionsCartOverride', false);
		
		if(!$form.displaySubmissionStatusInSuggestions)
			$form.displaySubmissionStatusInSuggestions = SalesToolkit.Theme.getBooleanProperty('displaySubmissionStatusInSuggestionsCartOverride', false);
	}
		

	if ((form.type == atheneumInstance.Forms.Types.REMOTE_CONSENT) || (form.type == atheneumInstance.Forms.Types.CREATE_MEETING) || (form.type == atheneumInstance.Forms.Types.REMOTE)) {
		//share popup
		$('.whatsapp-btn').css('display', atheneumInstance.Theme.getBooleanProperty('rcSharePopupPlatfWhatsApp', false) ? '' : 'none');
		$('.wechat-btn').css('display', atheneumInstance.Theme.getBooleanProperty('rcSharePopupPlatfWeChat', false) ? '' : 'none');
		$('.qrCode').css('display', atheneumInstance.Theme.getBooleanProperty('rcSharePopupPlatfWeChat', false) || atheneumInstance.Theme.getBooleanProperty('rcsharePopupPlatfQrCode', false) ? '' : 'none');
		$('.email-btn').css('display', atheneumInstance.Theme.getBooleanProperty('rcSharePopupPlatfEmail', false) ? '' : 'none');
		$('.sms-btn').css('display', atheneumInstance.Theme.getBooleanProperty('rcSharePopupPlatfSMS', false) ? '' : 'none');
	} else {
		$('.whatsapp-btn').css('display', atheneumInstance.Theme.getBooleanProperty('sharePopupPlatfWhatsApp', false) ? '' : 'none');
		$('.wechat-btn').css('display', atheneumInstance.Theme.getBooleanProperty('sharePopupPlatfWeChat', false) ? '' : 'none');
		$('.qrCode').css('display', atheneumInstance.Theme.getBooleanProperty('sharePopupPlatfWeChat', false) || atheneumInstance.Theme.getBooleanProperty('sharePopupPlatfQrCode', false) ? '' : 'none');
		$('.email-btn').css('display', atheneumInstance.Theme.getBooleanProperty('sharePopupPlatfEmail', false) ? '' : 'none');
		$('.sms-btn').css('display', atheneumInstance.Theme.getBooleanProperty('sharePopupPlatfSMS', false) ? '' : 'none');
	}

	// populate the form
	if (form.fields) {
		if (form.id != null) {
			$form.append('<input type="email" name="email" class="ignore autofill-preventer" autocomplete="off" />');
		}
		if (form.id != null && $('input[name="hidden-form-id"]').length == 0)
			$form.append('<input type="hidden" class="ignore" name="hidden-form-id" value="' + form.id + '" />');
		if ($('input[name="CONTACT_ID"]').length == 0)
			$form.append('<input type="hidden" class="ignore" name="CONTACT_ID" value="" />');

			
		//Not using columns anymore, using field properties to determine width
		for (var f = 0; f < form.fields.length; f++) {
			if (form.fields[f].type == "EMAIL" && cart && cartSkipEmail)
				continue;

			if ($('input[name="' + form.fields[f].name + '"]').length > 0) {
				var fieldID = $('input[name="' + form.fields[f].name + '"]').attr('id');
				if (fieldID == form.fields[f].name) {
					//Should ignore
					continue;
				}
				//Otherwise it's a radio and will have same name
			}

			if(form.fields[f].type === 'PASSWORD' && ignorePasswords)
				continue;
			addFieldToForm($form, form.fields[f], false, asRemote);
		}

		clearForm($form);

		let formHistoryId = SalesToolkit.Pages.CurrentPage.getQueryParam("formHistoryId");
           
		// lock the email to the user if download
		if (form.type != atheneumInstance.Forms.Types.SELF_REGISTRATION && (download || atheneumInstance.Theme.getBooleanProperty('prepopulateShareFormWithReadOnlyUserProfileData', false))) {

			if (atheneumInstance.User.preferences.email) {
				$form.find('input[name="to"]')
					.attr('data-readonly-locked', 'true')
					.attr('readonly', 'readonly')
					.val(atheneumInstance.User.preferences.email || '')
					.attr('data-default-value', atheneumInstance.User.preferences.email || '')
					;
			}
			for (prefName in atheneumInstance.User.preferences) {
				if (!atheneumInstance.User.preferences.hasOwnProperty(prefName)) {
					continue;
				}
				var prefValue = atheneumInstance.User.preferences[prefName];
				var $field = $form.find(
					'input[name="' + prefName + '"]'
					+ ', select[name="' + prefName + '"]'
					+ ', textarea[name="' + prefName + '"]'
				);

				if ($field.length > 0) {
					setFieldValue($field, prefValue);
					$field
						.attr('data-readonly-locked', 'true')
						.attr('readonly', 'readonly')
						.val(prefValue || '')
						.attr('data-default-value', prefValue || '');
				}

			}

		}
		else if (form.type != atheneumInstance.Forms.Types.SELF_REGISTRATION && atheneumInstance.Theme.getBooleanProperty('prepopulateFormsWithSessionBadgeData', false)) {
			if (sessionBadgeData != null) {

				var sessionBadgeDataReadyOnly = atheneumInstance.Theme.getBooleanProperty('sessionBadgeDataPopulatedFieldsReadOnly', false);

				if (sessionBadgeData.email && !(sessionBadgeData.to)) {
					sessionBadgeData.to = sessionBadgeData.email;
				}
				if (sessionBadgeData.Email && !(sessionBadgeData.to)) {
					sessionBadgeData.to = sessionBadgeData.Email;
				}
				if (sessionBadgeData.EMAIL && !(sessionBadgeData.to)) {
					sessionBadgeData.to = sessionBadgeData.EMAIL;
				}
				if (sessionBadgeData.primaryEmail && !(sessionBadgeData.to)) {
					sessionBadgeData.to = sessionBadgeData.primaryEmail;
				}
				if (sessionBadgeData.PrimaryEmail && !(sessionBadgeData.to)) {
					sessionBadgeData.to = sessionBadgeData.PrimaryEmail;
				}
				if (sessionBadgeData['primary-email'] && !(sessionBadgeData.to)) {
					sessionBadgeData.to = sessionBadgeData['primary-email'];
				}

				var $badgeIdField = $form.find('input[data-type="BADGE"]');
				var badgeIdFieldName = $badgeIdField.attr('name');
				if ($badgeIdField.length > 0) {
					setFieldValue($badgeIdField, sessionBadgeId || '');
					$badgeIdField.attr('data-default-value', badgeFieldValue || '');

					if (sessionBadgeDataReadyOnly) {
						$badgeIdField.attr('data-readonly-locked', 'true');
						$badgeIdField.attr('readonly', 'readonly');
					}
				}

				for (var badgeField in sessionBadgeData) {
					if (!sessionBadgeData.hasOwnProperty(badgeField)) {
						continue;
					}

					var badgeFieldValue = sessionBadgeData[badgeField];
					var $field = $form.find(
						'input[name="' + badgeField + '"]'
						+ ', select[name="' + badgeField + '"]'
						+ ', textarea[name="' + badgeField + '"]'
					);

					if ($field.length > 0) {
						setFieldValue($field, badgeFieldValue || '');
						$field.attr('data-default-value', badgeFieldValue || '');

						if (sessionBadgeDataReadyOnly) {
							$field.attr('data-readonly-locked', 'true');
							$field.attr('readonly', 'readonly');
						}
					}
				}
			}
		}else if(typeof atheneumInstance.Forms.userDetails === 'object'){
			
			if(atheneumInstance.Forms.userDetails.hasOwnProperty('CONTACT_ID')){
				setTimeout(async ()=>{
					let contact = await atheneumInstance.Contacts.getById(atheneumInstance.Forms.userDetails["CONTACT_ID"]);
					if (contact instanceof Array) {
						contact = contact[0];
					}
					if (contact) {
						populateFormWithContact($form, contact, true);
					}

					populateFormWithBadgeData($form, atheneumInstance.Forms.userDetails);
					dependenciesSetup( $form, form );
				}, 0)
			}else{
				populateFormWithBadgeData($form, atheneumInstance.Forms.userDetails);
				dependenciesSetup( $form, form );
			}
			
			return;
		}else if(typeof formHistoryId === 'string' && formHistoryId.length > 0 && typeof SalesToolkit.Summary.shares !== 'undefined' && SalesToolkit.Summary.shares.filter(x=> x.id === formHistoryId).length > 0){
			setTimeout(async ()=> {
				await loadFromHistory();
				dependenciesSetup($form, form);
			}, 0);
			return;
		}


		dependenciesSetup( $form, form );

	}else{
		clearForm($form);
	}

	if (form.type == atheneumInstance.Forms.Types.CREATE_MEETING) {

		if (atheneumInstance.Theme.getBooleanProperty('hideAdHocParticipantsCheckBox', false)) {
			$form.find('input[name="allowAdHocParticipants"]').parent().hide();
		}

		//share popup
		$('.whatsapp-btn').css('display', atheneumInstance.Theme.getBooleanProperty('rcSharePopupPlatfWhatsApp', false) ? '' : 'none');
		$('.wechat-btn').css('display', atheneumInstance.Theme.getBooleanProperty('rcSharePopupPlatfWeChat', false) ? '' : 'none');
		$('.qrCode').css('display', atheneumInstance.Theme.getBooleanProperty('rcSharePopupPlatfWeChat', false) || atheneumInstance.Theme.getBooleanProperty('rcsharePopupPlatfQrCode', false) ? '' : 'none');
		$('.email-btn').css('display', atheneumInstance.Theme.getBooleanProperty('rcSharePopupPlatfEmail', false) ? '' : 'none');
		$('.sms-btn').css('display', atheneumInstance.Theme.getBooleanProperty('rcSharePopupPlatfSMS', false) ? '' : 'none');

		var buttonHTML = '<button class="btn salestoolkit-blue btn-primary" '
			+ ' type="button"'
			+ ' onclick="showAttendeePopup();"'
			+ '>'+SalesToolkit.Translation.get('addAttendee', 'Add attendee')+'</button>';
		if (buttonHTML) {
			let $section = (currentSection == null) ? $form : ($('#' + currentSection).length == 0) ? $form : $('#' + currentSection);

			$section.append('<div class="share-form-buttons">' + buttonHTML + '</div>');
		}

		var remoteConsentForm = atheneumInstance.Forms.getFormsAssociatedWithCollectionOfType(null, 'REMOTE_CONSENT')[0];
		$attendeeForm = $('#addAttendeeForm');
		

		$attendeeForm.find('.atheneum-form-field').remove();
		if (remoteConsentForm) {
			$attendeeForm.displayContactSuggestions = remoteConsentForm.displayContactSuggestions;
			$attendeeForm.displayConsentStatusInSuggestions = remoteConsentForm.displayConsentStatusInSuggestions;
			$attendeeForm.displaySubmissionStatusInSuggestions = remoteConsentForm.displaySubmissionStatusInSuggestions;

			for (var f = 0; f < remoteConsentForm.fields.length; f++) {
				//TODO only add required fields? or should it be all
				if (remoteConsentForm.fields[f].visibleForMeetingParticipants || remoteConsentForm.fields[f].requiredForMeetingParticipants)
					addFieldToForm($attendeeForm, remoteConsentForm.fields[f], true);
			}
			//if we can't find a form of REMOTE_CONSENT type, then we use default fields
		} else {
			$attendeeForm.displayContactSuggestions = true;
			$attendeeForm.displayConsentStatusInSuggestions = true;
			$attendeeForm.displaySubmissionStatusInSuggestions = false;
			addFieldToForm($attendeeForm, {
				defaultValue: "",
				label: "Email*",
				name: "email",
				order: 0,
				profilePerm: "HIDDEN",
				required: true,
				translations: [],
				type: "EMAIL",
				unique: false,
				visible: true
			}, true);
			addFieldToForm($attendeeForm, {
				defaultValue: "",
				label: "First name*",
				name: "firstName",
				order: 1,
				profilePerm: "HIDDEN",
				required: true,
				translations: [],
				type: "TEXT",
				unique: false,
				visible: true
			}, true);
			addFieldToForm($attendeeForm, {
				defaultValue: "",
				label: "Last name*",
				name: "lastName",
				order: 2,
				profilePerm: "HIDDEN",
				required: true,
				translations: [],
				type: "TEXT",
				unique: false,
				visible: true
			}, true);
		}

		showAttendeeTable();
	}


	if (formProperties['formTopLabel']) {
		$('.form-top-text').remove();
		$form.prepend('<div class="form-top-text">' + formProperties['formTopLabel'] + '</div>');
	}
	if (formProperties['formBottomLabel']) {
		$('.form-bottom-text').remove();
		$form.append('<div class="form-bottom-text">' + formProperties['formBottomLabel'] + '</div>');
	}

	$form.on('input change', 'input.previously-invalid, select.previously-invalid, textarea.previously-invalid', function () {
		validateForm($('#form-holder'), true);
	});
}

async function loadFromHistory(){
	if(!SalesToolkit.Contacts.contactsLoaded){
		setTimeout(async function(){
			loadFromHistory();
		}, 1000);
	}else{
		let formHistoryId = SalesToolkit.Pages.CurrentPage.getQueryParam("formHistoryId");
        let formHistory = SalesToolkit.Summary.shares.filter(x=> x.id === formHistoryId)[0];
		if(formHistory){
			window.formHistoryId = formHistoryId;

			let data = formHistory.fields || {};
			if(data.hasOwnProperty("CONTACT_ID")){
				let contact = SalesToolkit.Contacts.getById(data.CONTACT_ID);
				if(contact && SalesToolkit.Theme.getBooleanProperty('loadCartContactsFromHistory', true)){
						(window.$formElement, contact, true);
					return;
				}
			}

			populateFromObj(data,  window.$formElement);
		}
	}
}

function shareLinkSubmit(form, formElement, callbacks, extraElement) {

	
	if (!validateForm(formElement)) {
		if (callbacks && callbacks.failure) {
			callbacks.failure('failed validation', null, -1086);
		}
		return;
	}

	if(!extraElement)
		extraElement = formElement;


	let addedEmailElementData = formElement.is(extraElement)? true : false;
	let formDataFirst = null;
	var callback = function (formData) {

		if(!addedEmailElementData)
		{
			formDataFirst = formData;
			addedEmailElementData = true;
			getFormData(extraElement, callback);
			return;
		}

		if(typeof formDataFirst == 'object'){
			 formData = {...formData, ...formDataFirst};
		}
		let formProperties = form.properties || { };

		if (form.type == atheneumInstance.Forms.Types.SHARE) {
			var cartData = {};
			var assetIds = atheneumInstance.Cart.assetIds;
			for (var a = 0; a < assetIds.length; a++) {
				var assetId = assetIds[a];
				var collectionId = atheneumInstance.Library.assets[assetId].containedBy;
				var assetsOfCollectionInCart = cartData[collectionId];
				if (assetsOfCollectionInCart == undefined) {
					assetsOfCollectionInCart = [];
					cartData[collectionId] = assetsOfCollectionInCart;
				}
				if (assetsOfCollectionInCart.indexOf(assetId) == -1) {
					assetsOfCollectionInCart[assetsOfCollectionInCart.length] = assetId;
				}
			}


			var cartDataArray = [];
			for (var c in cartData) {
				if (!cartData.hasOwnProperty(c)) {
					continue;
				}
				cartDataArray[cartDataArray.length] = { storyId: c, assetIds: cartData[c] }
			}
			formData.cart = cartDataArray;
		} else if (form.type == atheneumInstance.Forms.Types.CREATE_MEETING) {
			if (formProperties['allowAdHocMeetingWithoutParticipants'] === 'off' && attendeeList.length == 0 && (formData.attendeesCSVUpload == '' || formData.attendeesCSVUpload == null)) {
				vPopup.create({
					title: atheneumInstance.Translation.getOrGetThemeKey('errorTitleMeeting', 'Error'),
					message: atheneumInstance.Translation.getOrGetThemeKey('errorMeeting', 'At least one attendee required')
				});
				$('#form-holder').activity(false);
				return false;
			}
			formData.allowAdHocParticipants = $('#allowAdHocParticipants').is(':checked');

			if ((formData.attendeesCSVUpload == '' || formData.attendeesCSVUpload == null) && attendeeList.length != 0) {
				let tableRows = document.getElementById("attendeesTable").children;
				attendeeList.forEach(function (entry) {
					let i;
					for (i = 0; i < tableRows.length; i++) {
						if (entry['index'] == tableRows[i].id) {
							entry['order'] = i;
						}
					}
				});
				if (attendeeListCloned.length > 0) {
					formData.meetingId = attendeeListCloned[0].meetingId;
				}
				formData.participants = attendeeList.map(function (item) {
					delete item.index;
					delete item.meetingId;
					delete item.adHoc;
					return item;
				});
				formData.email = attendeeList.map(function (val) {
					return val.email;
				}).join(',');

				
			}

			if ((formData.attendeesCSVUpload == '' || formData.attendeesCSVUpload == null)){
				delete formData.attendeesCSVUpload;
			}

		}

		
		if (callbacks && callbacks.success) {
			var submitFormSuccessCallback = callbacks.success;
			callbacks.success = function (json) {
				if (form.type == atheneumInstance.Forms.Types.REMOTE_CONSENT || form.type == atheneumInstance.Forms.Types.REMOTE) {
					if (formData.shareLink) {
						showShareLinkPopup(json.link, formData.email || formData.to);
					}
				}

				if (form.type == atheneumInstance.Forms.Types.CREATE_MEETING) {
					if (formData.shareLink) {
						showShareLinkPopup(json.link, formData.email || formData.to, 'CREATE_MEETING', formData.name, true);
					} else {
						showMeetingsScreen();
                    }
				}

				submitFormSuccessCallback();
			}
		}
		
			$(formElement).activity(true);
		$(formElement).data('activity')?.css('z-index', '1');

			var whatsAppLink = 'https://web.whatsapp.com/send?text=';
			if (supportsWhatsApp()) {
				whatsAppLink = 'whatsapp://send?text=';
			}
			var shareLinkPopupEmailSubject = atheneumInstance.Theme.getStringProperty('shareLinkPopupEmailSubject', '');

			if(typeof window.formHistoryId === 'string' && form.allowSubmissionUpdates)
				formData.linkedSubmissionId = window.formHistoryId;
	
			if(typeof window.populatedImage !== 'undefined' && form.storeScannedImages){
				formData.linkedScanImage = window.populatedImage;
			}

			try{
				trackAppClick($('#salestoolkit-sharelink'), '#salestoolkit-sharelink', 'trackAppSHareLinData', atheneumInstance.Translation('trackAppSHareLinData', 'trackAppSHareLinData'), formData);
			}catch(err){

			}
		
			atheneumInstance.API.sharePortalLink(formData, {
				success: function (json) {
					$('#whatsapp-link').attr('href', whatsAppLink + encodeURI(json.link));
					$('#downloadInput').val(json.link);
					$('.qrCode img').attr('src', 'https://trustrack.atheneum.co/dms/public/barcode.png?type=QR_CODE&width=230&height=230&margin=0&content=' + encodeURI(json.link));
					var shareLinkPopupEmailBody = atheneumInstance.Theme.getStringProperty('shareLinkPopupEmailBody', '{link}');
					if (shareLinkPopupEmailBody.indexOf('{link}') != -1) {
						shareLinkPopupEmailBody = shareLinkPopupEmailBody.replace('{link}', encodeURI(json.link));
					}

					$('#sms-link').attr('href', 'sms:?&body='+shareLinkPopupEmailBody);
					
					if(shareLinkPopupEmailSubject === '')
						$('#email-link').attr('href', 'mailto:' + formData.to + '?body=' + shareLinkPopupEmailBody);
					else
						$('#email-link').attr('href', 'mailto:' + formData.to + '?subject=' + shareLinkPopupEmailSubject + '&body=' + shareLinkPopupEmailBody);

					$(formElement).activity(false);
					$('#shareLinkPopup').modal('show');
					// if remote consent requested, start polling for notifications every 10 seconds
					if ($(formElement).find('input[data-type=REMOTE_CONSENT]:checked').length >= 1) {
						pollingForRemoteConsentNotif = true;
						prevNotifInterval = atheneumInstance.UI.Notifications.pollInterval;
						// set polling interval to 10 secs
						atheneumInstance.UI.Notifications.setPollInterval(remoteConsentNotifInterval || 10000);
						// start polling (0 is the initial delay)
						atheneumInstance.UI.Notifications.startPolling(0, notificationPollCallback)
					}

					callbacks.success(json);
				},
				failure: function (reason, httpStatus, errorCode) {
					Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "atheneumInstance.API.sharePortalLink");
					$(formElement).activity(false);
					var errorCodeHex = undefined;
					if (typeof errorCode == 'number') {
						errorCodeHex = errorCode.toString(16);
						while (errorCodeHex.length < 8) {
							errorCodeHex = '0' + errorCodeHex;
						}
					}
					vPopup.create({
						title: atheneumInstance.Translation.getOrGetThemeKey('errorTitle', atheneumInstance.Translation.getOrGetThemeKey('error', 'Error')),
						message: atheneumInstance.Translation.getOrGetThemeKey('error' + errorCodeHex, atheneumInstance.API.ErrorCodes.getName(errorCode))
					});

					callbacks.failure(reason, httpStatus, errorCode);
				},
			});

		

	};

	getFormData(formElement, callback);
}

function submitForm(form, formElement, callbacks, shareLinkMode) {

	if (!validateForm(formElement, false, shareLinkMode)) {
		if (callbacks && callbacks.failure) {
			callbacks.failure('failed validation', null, -1086);
        }

		trackAppClick($(formElement), $(formElement).attr('id'), 'trackingSubmitFormValidationError', SalesToolkit.Translation.get('trackingSubmitFormValidationError', 'trackingSubmitFormValidationError'));
   
		return;
	}

	if (form.requireConsent && $(formElement).attr('data-contact-consented') !== 'true') {
		if (callbacks && callbacks.failure) {
			callbacks.failure('consent required', null, 134681600);
		}

		trackAppClick($(formElement), $(formElement).attr('id'), 'trackingSubmitFormLocalConsentError', SalesToolkit.Translation.get('trackingSubmitFormLocalConsentError', 'trackingSubmitFormLocalConsentError'));
   
		return;
	}

	
	
	$(formElement).data('assetIds', atheneumInstance.Cart.assetIds);

	var callback = function (formData) {

		let formProperties = form.properties || { };

		if (form.type === 'REMOTE' && !shareLinkMode) {
			for (let index = 0; index < form.fields.length; ++index) {
				const field = form.fields[index];
				if (field.requiredInRemoteForm && (!formData.hasOwnProperty(field.name) || formData[field.name] === '')) {
					if (callbacks && callbacks.failure) {
						let errorCode = -1088;
						if (atheneumInstance.Theme.getBooleanProperty('onlyCheckEmailRequiredForRemoteForms', true))
							errorCode = 134682376;
						callbacks.failure('remote validation failed', null, errorCode);
					}

					trackAppClick($(formElement), $(formElement).attr('id'), 'trackingSubmitFormRemoteValidationError', SalesToolkit.Translation.get('trackingSubmitFormRemoteValidationError', 'trackingSubmitFormRemoteValidationError'));
   
					return false;

					
                }
			}
		}

		if (form.type == atheneumInstance.Forms.Types.CREATE_MEETING) {
			if (formProperties['allowAdHocMeetingWithoutParticipants'] === 'off' && attendeeList.length == 0 && (formData.attendeesCSVUpload == '' || formData.attendeesCSVUpload == null)) {
				vPopup.create({
					title: atheneumInstance.Translation.getOrGetThemeKey('errorTitleMeeting', 'Error'),
					message: atheneumInstance.Translation.getOrGetThemeKey('errorMeeting', 'At least one attendee required')
				});
				$('#form-holder').activity(false);
				callbacks.failure('At least one attendee', null, -9999);
				return false;
			}

			if (!shareLinkMode && atheneumInstance.Theme.getBooleanProperty('disallowEmailSubmitEmptyAttendees', true) 
				&& attendeeList.length == 0 && (formData.attendeesCSVUpload == '' || formData.attendeesCSVUpload == null)) {
				vPopup.create({
					title: atheneumInstance.Translation.getOrGetThemeKey('errorTitleMeeting', 'Error'),
					message: atheneumInstance.Translation.getOrGetThemeKey('errorAttendeeShareLinkOnly', 'You can only share link if no attendees are added')
				});
				$('#form-holder').activity(false);
				callbacks.failure('email disallowed without attendees', null, -9999);
				return false;
			}

			formData.allowAdHocParticipants = $('#allowAdHocParticipants').is(':checked');
			if(typeof meetingId === 'string'){
				formData.meetingId = meetingId;
			}
			if ((formData.attendeesCSVUpload == '' || formData.attendeesCSVUpload == null) && attendeeList.length != 0) {
				let tableRows = document.getElementById("attendeesTable").children;
				attendeeList.forEach(function (entry) {
					let i;
					for (i = 0; i < tableRows.length; i++) {
						if (entry['index'] == tableRows[i].id) {
							entry['order'] = i;
						}
					}
				});
				if (attendeeListCloned.length > 0) {
					formData.meetingId = attendeeListCloned[0].meetingId;
				}
				formData.participants = attendeeList.map(function (item) {
					delete item.index;
					delete item.meetingId;
					delete item.adHoc;
					return item;
				});
				formData.email = attendeeList.map(function (val) {
					return val.email;
				}).join(',');
			}

			if ((formData.attendeesCSVUpload == '' || formData.attendeesCSVUpload == null)){
				delete formData.attendeesCSVUpload;
			}
		}

		if (callbacks && callbacks.success) {
			var submitFormSuccessCallback = callbacks.success;
			callbacks.success = function (json) {

				if(json && json.hasOwnProperty('sessionId')){
					atheneumInstance.Session.sessionId = json.sessionId;
					atheneumInstance.Session.saveToStorage();
				}

				if ($('#form-holder').data('type') == atheneumInstance.Forms.Types.REMOTE_CONSENT || $('#form-holder').data('type') == atheneumInstance.Forms.Types.REMOTE) {
					if (formData.shareLink) {
						showShareLinkPopup(json.link, formData.email || formData.to);
					}
				}

				if ($('#form-holder').data('type') == atheneumInstance.Forms.Types.CERTIFICATION) {
					pollingForCertificate = true;
					atheneumInstance.Library.timestamp = undefined;
					libraryUpdatePollIntervalTriggered();
				}

				
				if ($('#form-holder').data('type') == atheneumInstance.Forms.Types.CREATE_MEETING) {
					if (formData.shareLink) {
						showShareLinkPopup(json.link, formData.email || formData.to, 'CREATE_MEETING', formData.name, true);
						showMeetingAttendeesScreen(json.meetingId);
					} else {
						showMeetingsScreen();
					}
				}

				submitFormSuccessCallback(formData);
			}
		}

		if(callbacks && callbacks.failure){
			var submitFormFailureCallback = callbacks.failure;
			callbacks.failure = function (reason, httpstatus, errorCode, functionName, json){
				submitFormFailureCallback(reason, httpstatus, errorCode, formData, functionName, json);
			}
		}

		//TODO meetings if ($('#form-holder').data('type') == atheneumInstance.Forms.Types.CREATE_MEETING) {
		//	if (formData.shareLink) {
		//		showMeetingAttendeesScreen(json.meetingId);
		//	} else {
		//		showMeetingsScreen();
		//	}
		//} else {
		//	$('.backButton:visible').click();
		//}

		// if remote consent requested, start polling for notifications every 10 seconds
		if ($('#form-holder').data('type') == atheneumInstance.Forms.Types.REMOTE_CONSENT
			|| $('#form-holder').data('type') == atheneumInstance.Forms.Types.CREATE_MEETING
			|| $('#form-holder input[data-type=REMOTE_CONSENT]:checked').length >= 1) {
			pollingForRemoteConsentNotif = true;
			prevNotifInterval = atheneumInstance.UI.Notifications.pollInterval;
			// set polling interval to 10 secs
			atheneumInstance.UI.Notifications.setPollInterval(remoteConsentNotifInterval || 10000);
			// start polling (0 is the initial delay)
			atheneumInstance.UI.Notifications.startPolling(0, notificationPollCallback)
		}

		if ($('#form-holder').data('type') == atheneumInstance.Forms.Types.CERTIFICATION) {
			let iID = itemId || atheneumInstance.Pages.CurrentPage.getQueryParam("itemId") || false;
			let iType = itemType || atheneumInstance.Pages.CurrentPage.getQueryParam("itemType") || false;
			if (iID)
				formData.itemId = iID;
			if (iType)
				formData.itemType = iType;
		}



		if (shareLinkMode)
			formData.shareLink = true;
		
		var message = SalesToolkit.Translation.get('pleaseWait', "Please wait...");
		var title = SalesToolkit.Translation.get('submitting', "Submitting");
		if (form != undefined && form.properties != undefined) {
			message = SalesToolkit.Translation.get(form.properties.submitMessage, form.properties.submitMessage) || message;
			title = SalesToolkit.Translation.get(form.properties.submitTitle, form.properties.submitTitle) || title;
		}

		SalesToolkit.UI.Notifications.showCustomNotification("info", message, title);
		
		if(typeof window.formHistoryId === 'string' && form.allowSubmissionUpdates)
			formData.linkedSubmissionId = window.formHistoryId;

		if(typeof window.populatedImage !== 'undefined' && form.storeScannedImages){
			formData.linkedScanImage = window.populatedImage;
		}

		try{
			let trackObj = {};
			trackObj.formId = form.id;
			trackObj.data = formData;
			if(typeof atheneumInstance.Session.sessionId == 'string'){
				trackObj.sessionId = atheneumInstance.Session.sessionId;
			}
	
			trackAppClick($('#salestoolkit-submit'), '#salestoolkit-submit', 'trackingFormSubmitData', SalesToolkit.Translation.get('trackingFormSubmitData', 'trackingFormSubmitData'), trackObj);

		}catch(err){

		}
		
	
		atheneumInstance.Forms.submitForm(form, formData, atheneumInstance.Session.sessionId, callbacks);
	};

	getFormData(formElement, callback);
	
}

var libraryUpdatePollInterval = null;

function libraryUpdatePollIntervalTriggered() {
	var assetsBefore = {};
	var collectionsBefore = {};
	for (var collectionId in atheneumInstance.Library.collections) {
		collectionsBefore[collectionId] = atheneumInstance.Library.collections[collectionId];
	}
	for (var assetId in atheneumInstance.Library.assets) {
		assetsBefore[assetId] = atheneumInstance.Library.assets[assetId];
	}
	atheneumInstance.Library.timestamp = undefined;
	atheneumInstance.Library.update({
		success: function () {

			var collectionsAdded = [];
			var collectionsRemoved = [];
			var assetsAdded = [];
			var assetsRemoved = [];

			for (var collectionId in atheneumInstance.Library.collections) {
				if (collectionsBefore[collectionId] == undefined) {
					collectionsAdded.push(atheneumInstance.Library.collections[collectionId]);
				}
			}
			for (var assetId in atheneumInstance.Library.assets) {
				if (assetsBefore[assetId] == undefined) {
					assetsAdded.push(atheneumInstance.Library.assets[assetId]);
				}
			}
			for (var collectionId in collectionsBefore) {
				if (atheneumInstance.Library.collections[collectionId] == undefined) {
					collectionsRemoved.push(collectionsBefore[collectionId]);
				}
			}
			for (var assetId in assetsBefore) {
				if (atheneumInstance.Library.assets[assetId] == undefined) {
					assetsRemoved.push(assetsBefore[assetId]);
				}
			}

			postLibraryPollUpdateCallback(collectionsAdded, collectionsRemoved, assetsAdded, assetsRemoved);
		}
	});
}

function postLibraryPollUpdateCallback(collectionsAdded, collectionsRemoved, assetsAdded, assetsRemoved) {

	if (collectionsAdded.length > 0
		|| collectionsRemoved.length > 0
		|| assetsAdded.length > 0
		|| assetsRemoved.length > 0) {

		console.log(
			'Library Updated: '
			+ ((collectionsAdded.length > 0) ? (collectionsAdded.length + ' collections added. ') : (''))
			+ ((collectionsRemoved.length > 0) ? (collectionsRemoved.length + ' collections removed. ') : (''))
			+ ((assetsAdded.length > 0) ? (assetsAdded.length + ' assets added. ') : (''))
			+ ((assetsRemoved.length > 0) ? (assetsRemoved.length + ' assets removed. ') : (''))
		);
	}


	if (pollingForCertificate && assetsAdded.length > 0) {
		// new asset visible - most likely the certificate
		pollingForCertificate = false;
		if (atheneumInstance.Theme.getBooleanProperty('showCertificateReadyNotifications', false)) {
			atheneumInstance.UI.Notifications.showCustomNotification({
				title: atheneumInstance.Translation.getOrGetThemeKey('notificationCertificateReadyTitle', 'Certificate Ready'),
				message: atheneumInstance.Translation.getOrGetThemeKey('notificationCertificateReadyBody', 'Your certificate is now available to view: "{0}"').replace('{0}', assetsAdded[0].title),
				type: 'asset',
				subjectType: 'ASSET',
				subjectId: assetsAdded[0].id
			});
		}
	}
}


function notificationPollCallback() {

	var latestNotifications = atheneumInstance.UI.Notifications.history;

	if (atheneumInstance.User.username) {
		atheneumInstance.LocalStorage.set("atheneumNotificationHistoryForUser_" + atheneumInstance.User.username,
			JSON.stringify(atheneumInstance.UI.Notifications.history));
	}

	// atheneumInstance.UI.Notifications.renderList();
}

/**
 * resets all fields in the form back to their default values and retriggers the dependencies
 * @param {jQuery}  $htmlForm
 */
function clearForm($htmlForm) {
	
	window.populatedImage = undefined;
	window.formHistoryId = undefined;

	trackAppClick($htmlForm, $htmlForm.attr('id'), 'trackingFormClearConfirm', SalesToolkit.Translation.get('trackingFormClearConfirm', 'trackingFormClearConfirm'));
   
	$htmlForm.find('[data-default-value]').each(function () {
		var $this = $(this);
		var fieldType = $this.attr('data-type');
		var defaultValue = $this.attr('data-default-value');
		if (['RADIO', 'CHECKBOX', 'RADIO_MULTI', 'CONSENT_TYPE'].indexOf(fieldType) != -1) {
			if(fieldType == 'RADIO' || fieldType == 'CONSENT_TYPE'){
				$this.prop('checked', $this.val() == defaultValue);
			}
			else if (fieldType == 'CHECKBOX') {
				$this.prop('checked',Atheneum.Theme.TRUE_VALUES.contains($this.val()) == Atheneum.Theme.TRUE_VALUES.contains(defaultValue));
			}
			else if (fieldType == 'RADIO_MULTI') {
				$this.prop('checked', (defaultValue != '' && defaultValue.split(',').indexOf($this.val()) != -1));
			}
		}
		else {
			$this.val(defaultValue);
		}
		if (fieldType == 'SIGNATURE') {
			$this.parents('.atheneum-form-field').eq(0).signaturePad({
				penColour: colourString(SalesToolkit.Theme.getColourProperty('signatureColour', '#145394'))
			}).regenerate();
			$this.parents('.atheneum-form-field').eq(0).find('.signature-wrapper .clearButton a').click();
		}
	})


	$htmlForm.find('.failed, .invalid, .previously-invalid, .error').removeClass('failed invalid previously-invalid error');

	$('#attendeesTable .removeAttendeeButton').click();

	onFormUnselectContact($htmlForm);
	handleDependencies($htmlForm);
}


/**
 * Removes <code>&lt;script&gt;</code> and <code>&lt;script&gt;</code> tags from an html string.<br>
 * If the html string provided is <code>null</code> or <code>undefined</code>, returns the empty string.
 * @param {String} html
 * @returns {String}
 */
function sanitizeHTML(html) {

	if (html == null)
		return '';

	var fragmentUUID = uuid();
	var hasStyleSheet = false;

	// in some cases it is possible for usersubmitted html to contain script tags and iframes,
	// leaving them in could lead to anything from syntax errors to cross site scripting attacks,
	// hence the need for the hÌ¡ÌŸÍ™Ì¦Ì«Ì©ÌžÌ±ÍˆÌ•Í¢ÍœtÌ›Ò‰Í‡ÍŽÌ«Ì°Í‡Í‰Ì­Ì©ÌºÌ™Ì£ÌžÌ£Ì±Ì²Í•Ì«ÍˆÍ¢mÌ´ÌžÌžÌœÍ•ÍŽÌ£ÍŸlÌ´Í‰Ì¬ÌœÍˆÍˆÌ­ÍˆÌ°Ì¥Ì³Í™ÍŸ Ì¡ÍšÌªÌÍˆÌ»ÌªÌ­ÍÌŸÍ–ÍšÍ…pÌ·Ì Ì»ÌŸÍ•Í‡ÌœÌ²Ì³Ì¼Ì¹ÌœÌ­Í…aÌ¼Í•Í™Ì¤Ì–Ì²Ì—Ì¼ÍŽÍ¡Í…rÌ´Ì·Ì¸Ì¡Ì¦Í™Ì£ÍŽÌœÌ¼Ì²Í…Å›Ì¨Ì¡Ì¤Í“Í•ÌžÌ¹Í‡Ì ÌÌÄ¯ÍÍÍˆÍ•Ì¯Ì­Í–ÌÌžÌ¹Í–Í‰nÒ‰Ì§ÌºÌ¥ÌªÍŽÌ¯Í–Í–Í‡Ì˜Í‰Í…Í…gÌ¨Ì˜Ì¬Ì°Ì¼Ì°Ì Í¢ Ì¸Ì¸Ì€ÍžÒ‰Í‡Ì˜Í–ÌªÌ¼Ì³ÍŽÌ—Ì¦ÌžÌžÍ…rÌ–Ì®ÍÍ”Ì£Ì–Ì»ÌœÌ¬Ì³ÌœÍ”Ì­Ì«Ì€Í eÒ‰Ì¶Ì¶Í–Ì±Ì¦Ì²ÌŸÌ¤Ì¦Ì¹Ì°Ì©Ì©gÌ´Ò‰Ì˜Ì©Ì©ÌÌ•Í¢Ä™Ì¶Ì´Í–Ì©ÌºÌ ÌÌ»ÌŸÍŽÌÌxÒ‰Ì¨Ì¢ÌŸÍŽÌŸÌ¬Ì¹Í•Ì©ÍˆÍ - http://stackoverflow.com/questions/1732348#1732454

	var SCRIPT_REGEX = /(<\/script(?:\s+[^>]*)*\s*>)|(<script(?:\s+[^>]*)*\s*>((?!<\/script(?:\s+[^>]*)*\s*>)(?:(?!<\/script\s*>).)*)?)/gi;
	var IFRAME_REGEX = /(<\/iframe(?:\s+[^>]*)*\s*>)|(<iframe(?:\s+[^>]*)*\s*>((?!<\/iframe(?:\s+[^>]*)*\s*>)(?:(?!<\/iframe\s*>).)*)?)/gi;
	var STYLE_REGEX = /(<\/style(?:\s+[^>]*)*\s*>)|(<style(?:\s+[^>]*)*\s*>((?!<\/style(?:\s+[^>]*)*\s*>)(?:(?!<\/style\s*>).)*)?)/gi;

	html = html.replace(SCRIPT_REGEX, '');
	html = html.replace(IFRAME_REGEX, '');
	html = html.replace(STYLE_REGEX, function (match) {

		hasStyleSheet = true;
		try {
			var cssString = match.replace(/<\/style(?:\s+[^>]*)*\s*>/g, '').replace(/<style(?:\s+[^>]*)*\s*>/g, '');
			return cssString == '' ? '' : ('<style>' + window.css.scoped(cssString, fragmentUUID) + '</style>');
		}
		catch (e) {
			return '';
		}
	});

	// TODO - replace <html> tag with <span class="scope-UUID-html">
	var htmlRegex = /(?:<\/[Hh][Tt][Mm][Ll]\s*>)|(?:<[Hh][Tt][Mm][Ll](?:>|((?:\s+(?!class=)[^\s>]+(?:="[^"]*")?)*)(?:\s+(?:class="([^"]*)")?)?((?:\s+(?!class=)[^\s>]+(?:="[^"]*")?)*)\s*>))/;


	// TODO - replace <body> tag with <span class="scope-UUID-body">
	var bodyRegex = /(?:<\/[Bb][Oo][Dd][Yy]\s*>)|(?:<[Bb][Oo][Dd][Yy](?:>|((?:\s+(?!class=)[^\s>]+(?:="[^"]*")?)*)(?:\s+(?:class="([^"]*)")?)?((?:\s+(?!class=)[^\s>]+(?:="[^"]*")?)*)\s*>))/;


	if (hasStyleSheet) {
		html = '<span class="scope-' + fragmentUUID + '">' + html + '</span>';
	}
	return html;
}

function isFieldReadOnly(formId, fieldName) {
	var readonlyFields = atheneumInstance.Theme.getStringArrayProperty('readonlyFieldsForForm_' + formId, []);
	return (readonlyFields.indexOf(fieldName) != -1);
}

function isFieldReadOnlyWhenContactSelected(formId, fieldName) {
	var readonlyFields = atheneumInstance.Theme.getStringArrayProperty('readonlyFieldsWhenContactSelectedForForm_' + formId,
		atheneumInstance.Theme.getStringArrayProperty('readonlyFieldsForForm_' + formId, []));
	return (readonlyFields.indexOf(fieldName) != -1);
}

function getTranslatedOptionDescription(item){
	if(typeof item == 'undefined')
		return undefined;
	if(!item.hasOwnProperty('optionDescription'))
		return '';
	
	let userLanguage = SalesToolkit.User.getLanguage() || SalesToolkit.Language.getBrowserPreferred() || SalesToolkit.Language.getDefault();
    
	if(!item.hasOwnProperty('translations') || item.translations.findIndex(x=> x.languages.toString().toLowerCase().indexOf(userLanguage?.iso_code.toLowerCase()) >= 0) == -1){
		return item.optionDescription;
	}
	
	let index = item.translations.findIndex(x=> x.languages.toString().toLowerCase().indexOf(userLanguage?.iso_code.toLowerCase()) >= 0);
	
	if(index < 0)
		return item.optionDescription;

	return item.translations[index].optionDescription || item.optionDescription;

}

function getTranslatedLabel(item){
	if(typeof item == 'undefined')
		return undefined;
	if(!item.hasOwnProperty('label'))
		return '';
	
	let userLanguage = SalesToolkit.User.getLanguage() || SalesToolkit.Language.getBrowserPreferred() || SalesToolkit.Language.getDefault();
    
	if(!item.hasOwnProperty('translations') || item.translations.findIndex(x=> x.languages.toString().toLowerCase().indexOf(userLanguage?.iso_code.toLowerCase()) >= 0) == -1){
		return item.label;
	}
	
	let index = item.translations.findIndex(x=> x.languages.toString().toLowerCase().indexOf(userLanguage?.iso_code.toLowerCase()) >= 0);
	
	if(index < 0)
		return item.label;

	return item.translations[index].label || item.label;

}

function getTraslatedEditableLabel(item){
	if(!item.hasOwnProperty('editableLabel'))
		return '';
	
	let userLanguage = SalesToolkit.User.getLanguage() || SalesToolkit.Language.getBrowserPreferred() || SalesToolkit.Language.getDefault();
    
	if(!item.hasOwnProperty('translations') || item.translations.findIndex(x=> x.languages.toString().toLowerCase().indexOf(userLanguage?.iso_code.toLowerCase()) >= 0) == -1){
		return item.editableLabel;
	}
	
	let index = item.translations.findIndex(x=> x.languages.toString().toLowerCase().indexOf(userLanguage?.iso_code.toLowerCase()) >= 0);
	if(index < 0)
		return item.editableLabel;

	return item.translations[index].editableLabel || item.editableLabel;
}

var currentSection = null;
var currentRow = 0;
var currentSectionRow = 0;
/**
 * Appends the field to the end of the form.
 * @param {jQuery} $form 
 * @param {Field} field
 */
function addFieldToForm($form, field, ignoreSections = false, asRemote = false) {

	if (!field || !field.type)
		return;
		
	if(!field.properties) {
		field.properties = { };
	}

	//Desktop
	var propertyName = "desktop";
	var cssPropertyName = "Desktop";
	if (screen.width <= 1024) {
		//Tablet
		propertyName = "tablet";
		cssPropertyName = "Tablet";

		//Mobile
		if (screen.width <= 720) {
			propertyName = "mobile";
			cssPropertyName = "Mobile";
        }
			
	}

	if (field.type == "SECTION") {
		if (typeof form === 'undefined')
			form = {};

		let $section = $('<div id="' + field.name + '" class="form-section"><h2>' + getTranslatedLabel(field) + '</h2></div>');
		if(typeof form === 'undefined')
			form = {};
		let border = form?.properties?.sectionBorder || atheneumInstance.Theme.getStringProperty('formSectionBorder', '#000000 1px solid');
		
		let borderRadius = form?.properties?.sectionBorderRadius || atheneumInstance.Theme.getIntegerProperty('formSectionBorderRadius', 20);
		try{ borderRadius = parseInt(borderRadius); }catch(err){}
		
		let backgroundColour = form?.properties?.sectionBackgroundColour || atheneumInstance.Theme.getStringProperty('formSectionBackgroundColour', 'FFFFFF');
		backgroundColour = new Atheneum.Colour(backgroundColour);
		backgroundColour = colourString(backgroundColour);

		let padding = form?.properties?.sectionPadding || atheneumInstance.Theme.getStringProperty('formSectionPadding', '20px');
		let marginBotom = form?.properties?.sectionMarginBottom || atheneumInstance.Theme.getStringProperty('formSectionMarginBottom', '20px');

		let headerMargin = form?.properties?.sectionHeaderMargin || atheneumInstance.Theme.getStringProperty('formSectionHeaderMargin', '0 0 20px 0');

		let headerColour = form?.properties?.sectionHeaderColour || colourString(atheneumInstance.Theme.getStringProperty('formSectionHeaderColour', '000000'));
		headerColour = new Atheneum.Colour(headerColour);
		headerColour = colourString(headerColour);

		let headerFontSize = form?.properties?.sectionHeaderFontSize || atheneumInstance.Theme.getIntegerProperty('formSectionHeaderFontSize', 30);
		try{ headerFontSize = parseInt(headerFontSize); }catch(err){}

		let style = form?.properties?.sectionStyle || atheneumInstance.Theme.getStringProperty('formSectionStyle' + cssPropertyName, '');

		$section.attr('style', style);
		$section.css('border', border);
		$section.css('padding', padding);
		$section.css('background-color', backgroundColour);
		$section.css('border-radius', borderRadius);
		$section.css('margin-bottom', marginBotom);
		$section.find('h2').css('margin', headerMargin);
		$section.find('h2').css('font-size', headerFontSize);
		$section.find('h2').css('color', headerColour);

		currentSection = field.name;

		let clearSection = 'false';

		if (field.properties && Object.keys(field.properties).length > 0) {
			var widthPercentage = parseInt(field.properties[propertyName + "Width"] || "100");
			clearSection = field.properties[propertyName + "Clear"] || "true";

			let marginBetweenColumns = atheneumInstance.Theme.getIntegerProperty('formMarginBetweenColumns', 5);

			let fieldMarginRight = 0;
			if (widthPercentage != 100) {
				fieldMarginRight = marginBetweenColumns;
			}

			currentSectionRow += widthPercentage;

			if (currentSectionRow >= 100 || clearSection == 'true') {
				currentSectionRow = 0;
				fieldMarginRight = 0;
			}

			var marginBottom = parseFloat(field.properties[propertyName + "MarginBottom"] || "-1986");

			let fieldStyle = parseFloat(field.properties[propertyName + "Style"] || null);

			

			$section.css('margin-right', fieldMarginRight);
			if (marginBottom == "-1986")
				$section.css('margin-bottom', "1.25rem");
			else
				$section.css('margin-bottom', marginBottom + "px");
			$section.css('width', "calc(" + widthPercentage + "% - " + fieldMarginRight + "px)");

			if (fieldStyle && fieldStyle != null && fieldStyle.length > 0)
				$section.attr('style', fieldStyle);

		}  else {
			
			let maxWidth = (form?.properties?.hasOwnProperty('sectionMaxWidth'+cssPropertyName))? form.properties['sectionMaxWidth'+cssPropertyName] : atheneumInstance.Theme.getStringProperty('formSectionMaxWidth' + cssPropertyName, 'none');
			let marginRight = (form?.properties?.hasOwnProperty('sectionMarginRight'+cssPropertyName))? form.properties['sectionMarginRight'+cssPropertyName] : atheneumInstance.Theme.getStringProperty('formSectionMarginRight' + cssPropertyName, '0');
			if(/^\d+$/.test(marginRight)){
				marginRight += "%";
			}

			if(/^\d+$/.test(maxWidth)){
				maxWidth += "%";
			}

			$section.css('max-width', maxWidth);
			$section.css('margin-right', marginRight);

		}

		$form.append($section);
		if (clearSection == "true") {
			$form.append('<div class="form-clear"></div>');
		}

		currentRow = 0;

		return;
	}


	let $section = (currentSection == null) ? $form : ($('#' + currentSection).length == 0) ? $form : $('#' + currentSection);
	if(ignoreSections){
		$section = $form;
	}

	var $fieldToAppend = $('<div class="atheneum-form-field"></div>');
	if(asRemote){
		$fieldToAppend.addClass(field.requiredInRemoteForm ? 'required' : 'optional');
	}else{
		$fieldToAppend.addClass(field.required ? 'required' : 'optional');
	}
	
	
	let clear = 'false';
	
	if (field.properties && Object.keys(field.properties).length > 0) {
		var widthPercentage = parseInt(field.properties[propertyName + "Width"] || "100");
		clear = field.properties[propertyName + "Clear"] || "true";

		let marginBetweenColumns = atheneumInstance.Theme.getIntegerProperty('formMarginBetweenColumns', 5);

		let fieldMarginRight = 0;
		if (widthPercentage != 100) {
			fieldMarginRight = marginBetweenColumns;
		}

		currentRow += widthPercentage;
		if (currentRow >= 100 || clear == 'true') {
			currentRow = 0;
			fieldMarginRight = 0;
		}

		var marginBottom = parseFloat(field.properties[propertyName + "MarginBottom"] || "-1986");

		let fieldStyle = field.properties[propertyName + "Style"] || '';

		$fieldToAppend.css('margin-right', fieldMarginRight);
		if (marginBottom == "-1986")
			$fieldToAppend.css('margin-bottom', "1.25rem");
		else
			$fieldToAppend.css('margin-bottom', marginBottom + "px");
		$fieldToAppend.css('width', "calc(" + widthPercentage + "% - " + fieldMarginRight + "px)");

		
		if (fieldStyle && fieldStyle != null && fieldStyle.length > 0)
			$fieldToAppend.attr('style', fieldStyle);
		
    }

	if (field.label != null) {
		var fieldLabel = getTranslatedLabel(field);
		var $label = $fieldToAppend.append('<label for="' + field.name + '"></label>').find('label');

		let useHtmlLabels = atheneumInstance.Theme.getBooleanProperty('formsUseHtmlLabels', false);
		if(typeof form !== 'undefined' && form.properties.hasOwnProperty('useHtmlLabels')){
			useHtmlLabels = form.properties.useHtmlLabels;
			useHtmlLabels = Atheneum.Theme.TRUE_VALUES.contains(useHtmlLabels);
		}

		if (useHtmlLabels) {
			if(asRemote){
				fieldLabel += ((field.requiredInRemoteForm && !fieldLabel.endsWith("*")) ? '*' : '');
			}
			$label.html(sanitizeHTML(fieldLabel));
		}
		else {
			if(asRemote){
				fieldLabel += ((field.requiredInRemoteForm && !getTranslatedLabel(field).endsWith("*")) ? '*' : '');
			}else{
				fieldLabel += ((field.required && !getTranslatedLabel(field).endsWith("*")) ? '*' : '');
			}
			$label.text(fieldLabel);
		}
	}

	if(asRemote && !field.visibleInRemoteForm){
		$fieldToAppend.hide();
	}else if (!field.visible)
		$fieldToAppend.hide();

	switch (field.type) {
		
		case 'LABEL':
			// not actually a field, but a label to display to the user
			$fieldToAppend = $fieldToAppend.find('label').addClass('atheneum-form-label');
			var labelBorderBottom = field.properties[propertyName + "LabelBorderBottom"] || '';
			if(labelBorderBottom) {
				$fieldToAppend.css('border-bottom', labelBorderBottom);
			}

			if (field.properties.hasOwnProperty('customAfterForm') && field.properties['customAfterForm'] == 'true') {
				$fieldToAppend.addClass('deleteMePlease');
				$fieldToAppend.hide();
				console.log("rendering form hide adjusted items called");
					
				
			}
				
			break;

		case 'HIDDEN':
			$fieldToAppend.append('<input type="hidden"/>');
			break;

		case 'TEXTBOX':
			// multiple line text entry
			$fieldToAppend.append('<textarea name="' + field.name + '"></textarea>');
			break;

		case 'NUMBER':
		case 'PHONE':
		case 'TEXT':
		case 'BADGE':
			// single line text entry
			$fieldToAppend.append('<input type="text" />');
			break;

		case 'PASSWORD':
			// single line password entry
			$fieldToAppend.append('<input type="password" />');
			$fieldToAppend.append('<div class="passwordVisibilityToggle" style="display: ' + (atheneumInstance.Theme.getBooleanProperty('enablePasswordVisibilityToggle', false) ? 'block' : 'none') + ';"></div>');

			break;

		case 'EMAIL':
			// single line text entry, where an email is expected
			var placeHolder = atheneumInstance.Translation.getOrGetThemeKey('exampleEmailPlaceholder', 'name@example.com');
			var html ='<div style="height:28px !important; max-height:initial;">'
				+ '<span style="position:absolute; height:28px; width:40px;" onclick="getContactForButton(this);" class="contact-button-background input-group-addon"><i class="contact-button-foreground fa fa-envelope"></i></span>'
				+ '<input style="height:28px; padding-left: 45px;" type="email" />'
				+ '</div>'
			$fieldToAppend.append(html);

			if(!field.required && field.properties?.hasOwnProperty('requiredForNonLink')){
				$fieldToAppend.data('requiredForNonLink', true);
			}
			
			break;
		case 'FILE':
			$fieldToAppend.append('<input title="' + SalesToolkit.Translation.get('chooseFile', 'Choose File') + '" name="' + field.name + '" ' + ((field.format) ? ('accept="' + field.format + '"') : '') + ' type="file" />');
			if(field.hasOwnProperty('templateURL') && field.templateURL.length > 0 && atheneumInstance.Theme.getBooleanProperty('formsFileFieldUseTemplate', true)){
				$fieldToAppend.append('<a href="'+field.templateURL+'?apikey='+atheneumInstance.User.apikey+'" target="_blank" download="DownloadTemplate.csv" style="display:block; padding-top:5px;">'+atheneumInstance.Translation.get('downloadTemplate', 'Download Template')+'</a>');
			}

			if(field.hasOwnProperty('max') || field.properties.hasOwnProperty('maxCount')){
				let $fileInput = $fieldToAppend.find('input');
				if(field.hasOwnProperty('max'))
					$fileInput.data('fieldMax', field.max);

				if(field.properties.hasOwnProperty('maxCount')){
					$fileInput.attr('multiple', true);
					$fileInput.data('maxCount', field.properties.maxCount);

				}

				$fileInput.on('change', function(){
					let verifiedFiles = new DataTransfer();
					let maxSize = typeof $(this).data('fieldMax') !== 'undefined' ? $fileInput.data('fieldMax') : -1;
					let maxCount = typeof $(this).data('maxCount') !== 'undefined' ? $fileInput.data('maxCount') : -1;

					let failedSize = false;
					let failedCount = false;

					let removedForSize = [];
					let removedForCount = [];
					
					for(let i = 0; i < this.files.length; i++){
						if(maxSize > 0 && this.files[i].size > maxSize) {
							failedSize = true;
							removedForSize.push(this.files[i].name);
							continue;
						 }

						 if(maxCount > 0 && verifiedFiles.items.length >= maxCount){
							failedCount = true;
							removedForCount.push(this.files[i].name);
							continue;;
						 }

						 verifiedFiles.items.add(this.files[i]);
					}

					this.files = verifiedFiles.files;

					if(failedSize){
						let notificationBody = atheneumInstance.Translation.getFormatted('inputFileSizeExceeded', 'File that exceed {0} are not allowed and have beeen removed.', [humanFileSize(maxSize, false, 2)]);
						atheneumInstance.UI.Notifications.showCustomNotification("info", notificationBody);

						if(SalesToolkit.Theme.getBooleanProperty('showFileNamesRemoved', true)){
							let notificationBody = atheneumInstance.Translation.getFormatted('inputFileSizeRemoved', 'The following files have been removed for exceeding the maximum size: {0}.', [removedForSize.toString()]);
							atheneumInstance.UI.Notifications.showCustomNotification("info", notificationBody);
						}
					}

					if(failedCount){
						let notificationBody = atheneumInstance.Translation.getFormatted('inputFileCountExceeded', 'You may only upload {0} files at a time.', [maxCount]);
						atheneumInstance.UI.Notifications.showCustomNotification("info", notificationBody);

						if(SalesToolkit.Theme.getBooleanProperty('showFileNamesRemoved', true)){
							let notificationBody = atheneumInstance.Translation.getFormatted('inputFileSizeRemoved', 'The following files have been removed for exceeding the maximum file count: {0}.', [removedForCount.toString()]);
							atheneumInstance.UI.Notifications.showCustomNotification("info", notificationBody);
						}
					}
				});
			}
			break;
		case 'COUNTRY':
			// dropdown select with a list of countries
			$fieldToAppend.append($('#formCountrySelectPrototype').clone().removeAttr('id').attr('id', field.name));

			var $select = $fieldToAppend.find('select');
			var useNativeNames = atheneumInstance.Theme.getBooleanProperty('useNativeCountryNames', true);

			if (countries) {	
				let countriesArr = Object.entries(countries);
			
				countriesArr.sort(function(a, b) {
					
					var keyA = a[1].native.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(),
					  keyB = b[1].native.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

					if(!useNativeNames){
						keyA = a[1].name;
						keyB = b[1].name;
					}
					
					// Compare the 2 dates
					if (keyA < keyB) return -1;
					if (keyA > keyB) return 1;
					return 0;
				  });
				  
				for (let i=0; i<countriesArr.length; i++) {
					let countryCode = countriesArr[i][0];
					let country = countriesArr[i][1];
					let countryName = (useNativeNames) ? country.native : country.name;

					if (countryName) {
						$select.append("<option value='" + countryCode.toLocaleLowerCase() + "'>"+countryName+"</option>")
					}
				}
            }
			
			break;

		case 'LANGUAGE':
			// dropdown select with a list of languages
			$fieldToAppend.append($('#formLanguageSelectPrototype').clone().removeAttr('id').attr('id', field.name));

			var $select = $fieldToAppend.find('select');
			var useNativeNames = atheneumInstance.Theme.getBooleanProperty('useNativeLanguageNames', true);

			if (languages) {
				for (var i = 0; i < languages.length; i++) {
					var language = languages[i];
					if (language) {
						var languageName = (useNativeNames) ? language.nativeName : language.name;

						if (languageName) {
							$select.append("<option value='" + language.code.toLocaleLowerCase() + "'>" + languageName + "</option>")
						}
					}
				}
			}
			break;

		case 'REMOTE_CONSENT':
		case 'CHECKBOX':
			$fieldToAppend.prepend('<input type="checkbox" />');
			if (field.optionDescription) {
				$fieldToAppend.before($fieldToAppend.find('label').addClass('atheneum-form-label').removeAttr('for'));
				var optionDescription = getTranslatedOptionDescription(field) + ((field.required && !getTranslatedOptionDescription(field).endsWith("*")) ? '*' : '');
				$fieldToAppend.append('<label for="' + field.name + '">' + optionDescription + '</label>');
			}
			else if (!(field.label)) {
				$fieldToAppend.append('<label for="' + field.name + '">&nbsp;</label>');
			}
			

			if(field.hasOwnProperty('properties') && (field.properties.hasOwnProperty('parentName') || field.properties.hasOwnProperty('isMasterCheckbox'))){
				let $checkBox = $fieldToAppend.find('input');

				if(field.properties.hasOwnProperty('parentName')){
					$checkBox[0].dataset.parentName = field.properties.parentName;
				}

				if(field.properties.hasOwnProperty('isMasterCheckbox') && field.properties.isMasterCheckbox == 'true'){
					$checkBox[0].dataset.isMaster = true;
				}

				$checkBox.on('change', function (){
					let $check = $(this);
					let isMaster = $check.data('isMaster') == true;
					let parentName = isMaster? $check.attr('name') : ($check.data('parentName') || "");
					let $master = isMaster? $(this) : $('input[name="'+parentName+'"]');
					let $children =  $("input[data-parent-name='" + parentName + "']"); 
					let isMasterChecked = false;

					if(isMaster){
						isMasterChecked = $master.prop('checked');
						$children.each(function(){
							$(this).prop('checked', isMasterChecked);
						});
					}else{
						
						$children.each(function(){
							isMasterChecked = isMasterChecked || $(this).prop('checked');
						});
					}

					
					$master.prop('checked', isMasterChecked);
				});
			}
			
			break;

		case 'SIGNATURE':
			$fieldToAppend.append($('#formSignaturePrototype').clone().removeAttr('id'));
			break;

		case 'SELECT':

			if(Atheneum.Theme.TRUE_VALUES.contains(field.properties.useAutoCompleteField) && typeof FilteredTextField){
				//TODO this should probably be field properties
				let options = {
					multiSelect: SalesToolkit.Theme.getBooleanProperty('allowfiltersTFMultiSelection', false),
					showResults: SalesToolkit.Theme.getBooleanProperty('filtersTFShowResults', true),
					maxItems: SalesToolkit.Theme.getIntegerProperty('filtersTFMaxItemsShown', 5),
					maxHeight: SalesToolkit.Theme.getIntegerProperty('filtersTFMaxHeight', (16 * 39 + 20)),
					backgroundImagePadding: SalesToolkit.Theme.getIntegerProperty('filterImagePadding', '24'),
					itemPaddingTopBottom: SalesToolkit.Theme.getIntegerProperty('filterTFItemPaddingTopBottom', '5'),
					buttonTopBottomPadding:  SalesToolkit.Theme.getIntegerProperty('filterTFButtonPaddingTopBottom', '5'),
					showClearAllButton: SalesToolkit.Theme.getBooleanProperty('filtersTFShowClearButton', true),
					hideEntriesWithZeroResults: false,
					localOnly: true,
					width: '100%',
				}
				
				let filteredTextField = new FilteredTextField($fieldToAppend[0], undefined, field, options);
				$fieldToAppend.data('filtered-textfield', filteredTextField.uid);
				break;
			}
			// dropdown select with a list of user defined options
			$fieldToAppend.append('<select></select>');
			if (!field.options)
				break;

			let useNativeSelectNames = atheneumInstance.Theme.getBooleanProperty('useNativeCountrySelectNames', false);
			var $select = $fieldToAppend.find('select');
			var options = field.options;

			options = options.filter(function (element) {
				let result = true;
				if(element.hasOwnProperty('startDate')){
					let startDate = new Date(element.startDate);
					startDate.setDate(startDate.getDate() + SalesToolkit.Theme.getIntegerProperty('optionStartDateOffset', 0));  
					let now = new Date();

					if(startDate > now)
						return false;
				}

				if(element.hasOwnProperty('expiryDate')){
					let endDate = new Date(element.expiryDate);
					endDate.setDate(endDate.getDate() + SalesToolkit.Theme.getIntegerProperty('optionEndDateOffset', 0));
					let now = new Date();

					if(now >= endDate)
						return false;
				}

				return true;
			});

			if (field.name == "country") {
				// country fields are encoded as select if only a subset are specified.

				// append the placeholder value
				$select.append('<option value="">' + atheneumInstance.Translation.getOrGetThemeKey('countrySelectLabel', 'Please select a country') + '</option>');

				// move the 'OTHER' and 'GLOBAL' options to the end of the list, (if present)
				var otherCountry = null;
				var globalCountry = null;
				options = [];
				for (c = 0; c < field.options.length; c++) {
					if (field.options[c].value == 'OTHER') {
						otherCountry = field.options[c];
					}
					else if (field.options[c].value == 'GLOBAL') {
						globalCountry = field.options[c];
					}
					else {
						options[options.length] = field.options[c];
					}
				}

				if(useNativeSelectNames && countries && atheneumInstance.Theme.getBooleanProperty('reorderCountrySelectToNative', false)){
					options.sort((a, b) => {
						let valueA = a.value,
						valueB = b.value;

						let keyA = countries[valueA].native.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(),
						keyB = countries[valueB].native.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
  					
						// Compare the 2 dates
						if (keyA < keyB) return -1;
						if (keyA > keyB) return 1;
						return 0;
					});
				}

				if (globalCountry)
					options[options.length] = globalCountry;

				if (otherCountry)
					options[options.length] = otherCountry;
			}
			else if (field.name == "language") {
				$select.append('<option value="">' + atheneumInstance.Translation.getOrGetThemeKey('languageSelectLabel', 'Please select a language') + '</option>');
			}
			else {
				$select.append('<option value="">' + atheneumInstance.Translation.getOrGetThemeKey('optionSelectLabel', 'Please select an option') + '</option>');
			}

			for (var o = 0; o < options.length; o++) {
				var optionLabel = getTranslatedLabel(options[o]);

				let optionValue = options[o].value;
				if(field.name == 'country' && useNativeSelectNames && countries && countries.hasOwnProperty(optionValue)) {
					optionLabel = countries[optionValue].native;
				}


				$select.append('<option value="' + optionValue + '">' + optionLabel + '</option>');
			}
			break;

		case 'RADIO':
		case 'RADIO_MULTI':
		case 'CONSENT_TYPE':

			$fieldToAppend.addClass('atheneum-' + ((field.type == 'RADIO_MULTI') ? 'radio-multi' : 'radio') + '-form-field');

			$fieldToAppend.prepend('<input type="' + ((field.type == 'RADIO_MULTI') ? 'checkbox' : 'radio') + '" />');

			var optionDescription = '';
			if (field.optionDescription) {
				optionDescription = getTranslatedOptionDescription(field);
			}

			var fieldId = field.name + field.value;

			if (field.value) {
				$fieldToAppend.find('input[type=radio], input[type=checkbox]').val(field.value);
			}

			$section.append($fieldToAppend.find('label').addClass('atheneum-form-label').removeAttr('for'));

			if (field.required && SalesToolkit.Theme.getBooleanProperty('noAsteriskForOptionDescriptions', false) && optionDescription && !optionDescription.endsWith("*")) {
				optionDescription += '*';
			}
			$fieldToAppend.append('<label class="atheneum-radiogroup-label" for="' + fieldId + '">' + optionDescription + '</label>');

			var $label = $fieldToAppend.find('label').attr('for', fieldId);
			var $radio = $fieldToAppend.find('input[type=' + ((field.type == 'RADIO_MULTI') ? 'checkbox' : 'radio') + ']').attr('id', fieldId);

			if (field.freeText) {

				var freeTextId = field.value; //fieldId + '_customText';

				var $freeText = $('<input '
					+ ' id="' + freeTextId + '"'
					+ ' class="freeText"'
					+ ' type="text"'
					+ ' data-linked-field="' + fieldId + '"'
					//	+ ' onchange="$(\'#' + fieldId + '\').val(this.value);"'
					+ ' onfocus="$(\'#' + fieldId + '\').prop(\'checked\', true);"'
					+ ' />');


				$label.after($freeText);

				$radio.addClass('hasFreeText');
				$radio.attr('data-linked-field', freeTextId);
				$radio.attr('onclick', '$(\'#' + freeTextId + '\').focus();');
				$radio.attr('onfocus', '$(\'#' + freeTextId + '\').focus();');
				$radio.val(freeTextId);
			}

			if(field.type == 'RADIO_MULTI' && field.properties.hasOwnProperty('blockedCombinations')){
				$radio.data('blockedCombinations', field.properties.blockedCombinations);
				$radio.on('change', function(){
					let value = $(this).val();
					let blockedCombinations = $(this).data('blockedCombinations');
					blockedCombinations = JSON.parse(blockedCombinations);
					for(let i = 0; i<blockedCombinations.length; i++){
						let combinations = blockedCombinations[i];
						combinations = combinations.split(',');

						if(combinations.indexOf(value) < 0)
							continue;

						let name = $(this).attr('name');
						let $fields = $('[name="' + name + '"]:checked');
						$fields.each(function () {
							let $option = $(this);
							let optionValue = $option.val();
							if(optionValue === value)
								return;

							if(combinations.indexOf(optionValue) >= 0){
								$option.prop('checked', false);
							}
						})
					}
					
				});
			}

			break;

		case 'CONFIRM':
			var newLabel = $fieldToAppend.find('label')
			$fieldToAppend = $form.find('[name=' + field.confField + ']').last().parents('.atheneum-form-field').clone();
			$fieldToAppend.find('[name= ' + field.confField + ']').attr('id', field.name).attr('name', field.name);
			$fieldToAppend.find('label[for=' + field.confField + ']').replaceWith(newLabel);
			break;
		case 'DATE':
			let d = new Date();
			d.setMilliseconds(0);
			d.setSeconds(0);
			d.setMinutes(0);
			d.setHours(d.getHours()+1);

			let min = "";
			if(typeof field.properties !== 'undefined' && field.properties.hasOwnProperty('min'))
			{
				if(field.properties.min === 'now'){
					min = new Date().toISOString().substring(0,16);
				}else{
					min = field.properties.min;
				}	
			}
			
			
			if(typeof $.fn.datetimepicker === 'function'){
			 	
				$fieldToAppend.append('<input min="' + min +'" style="pointer-events: none;" onclick="event.preventDefault();"  type="datetime-local" placeholder="'+(field.format || "dd/mm/yyyy hh:ss")+'" value="' + d.toISOString().slice(0, 16) +'" data-format="' + (field.format || "yyyyMMdd hh:ss") + '" />');
				$fieldToAppend.datetimepicker({minDate: 0, step : 15, value : d, defaultDate: d }).on('change', function (ev) {
					let firstDate = new Date($(this).val());
					window.dateHasChange = true;
					$(this).find('input')[0].valueAsNumber = firstDate.getTime() - (firstDate.getTimezoneOffset() * 1000 * 60);
					
				 });
			}else{
				$fieldToAppend.append('<input min="'+min+'" type="datetime-local" value="' + d.toISOString().slice(0, 16) +'" data-format="' + (field.format || "yyyyMMdd hh:ss") + '" />');
			}

			
			
			break;
		default:
			$fieldToAppend = $('<p>TODO: ' + field.type + '</p>');
	}

	if (!field.visible)
		$fieldToAppend.hide();

	var $fieldInput = $fieldToAppend.find('input, select, textarea').not('.ignore, .freeText');
	$fieldInput.attr('data-type', field.type);
	$fieldInput.attr('data-default-value', field.defaultValue || '');
	$fieldInput.attr('name', field.name);
	//$fieldInput.attr('autocomplete', 'off');
	if(field.type === 'PASSWORD')
		$fieldInput.attr('autocomplete', 'new-password');
	else
		$fieldInput.attr('autocomplete', 'off');

	$fieldInput.attr('autocorrect', 'off');
	$fieldInput.attr('autocapitalize', 'off');
	$fieldInput.attr('spellcheck', false);

	$fieldToAppend.find('input.freeText:not(.ignore)').attr('data-default-value', '');

	if (field.type != 'RADIO' && field.type != 'CONSENT_TYPE' && field.type != 'RADIO_MULTI')
		$fieldInput.attr('id', field.name);

	if (asRemote && field.requiredInRemoteForm) {
		$fieldInput.attr('required', 'required');
		$fieldInput.addClass('required');
	}else if (field.required) {
		$fieldInput.attr('required', 'required');
		$fieldInput.addClass('required');
	}

	if (isFieldReadOnly($form.find('.ignore[name=id]').val(), field.name)) {
		$fieldInput.attr('readonly', 'readonly');
		$fieldInput.addClass('readonly');
	}

	if (field.type == 'BADGE') {

		var badgeLookupTimeout = null;

		$fieldInput.on('keydown', function (event) {
			if (event.which == 13) {
				// newline - someone is likely using a barcode scanner in keyboard mode
				event.preventDefault();
			}
		});


		$fieldInput.on('input', function () {
			if (badgeLookupTimeout != null) {
				window.clearTimeout(badgeLookupTimeout);
			}
			badgeLookupTimeout = window.setTimeout(function () {
				$fieldInput.val($fieldInput.val());
				lookupBadge();
			}, 750);
		});

		$fieldInput.on('change', function () {
			lookupBadge();
		});

		function lookupBadge() {

			if (badgeLookupTimeout != null) {
				window.clearTimeout(badgeLookupTimeout);
			}

			atheneumInstance.Badges.lookup($fieldInput[0].value, {
				success: function (badge) {
					if ($('#form-holderSection.currentSection').length > 0) {
						populateFormWithBadgeData($form, badge);
					}

				},
				failure: function (reason, httpStatus, errorCode) {
					Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Badges.lookup");

					if (Atheneum.Callbacks.isOffline(reason, httpStatus, errorCode)) {
						if (atheneumInstance.Theme.getBooleanProperty("ignoreBadgeOfflineError", false)) {
							return;
						}

						var popupText = atheneumInstance.Theme.getStringProperty("badgeScanOffline",
							"No internet connection available, please try again once a connection "
							+ "has been established or complete the form manually. Thank you"
						);

						vPopup.create({
							title: atheneumInstance.Theme.getStringProperty("errorTitle", "Error"),
							message: popupText
						});
					}
				},
				offline: function (reason, httpstatus, errorCode) {
					Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, "Atheneum.Badges.lookup");

					if (atheneumInstance.Theme.getBooleanProperty("ignoreBadgeOfflineError", false)) {
						return;
					}

					var popupText = atheneumInstance.Theme.getStringProperty("badgeScanOffline",
						"No internet connection available, please try again once a connection "
						+ "has been established or complete the form manually. Thank you"
					);

					vPopup.create({
						title: atheneumInstance.Theme.getStringProperty("errorTitle", "Error"),
						message: popupText
					});
				}
			});
		}
	}


	if (SalesToolkit.Theme.getBooleanProperty('allowCustomAfterForm', false) && field.properties.hasOwnProperty('customAfterForm') && field.properties['customAfterForm'] == 'true') {
		$('.deleteMePlease').remove();
		$form.after($fieldToAppend);
		let heightAdjust = field.properties.hasOwnProperty('customAfterFormHeightAdjust') ? parseInt(field.properties['customAfterFormHeightAdjust']) : 40;
		$form.attr('heightAdjust', heightAdjust);
	} else
		$section.append($fieldToAppend);
	if (clear == "true") {
		$section.append('<div class="form-clear"></div>')
	}

	if (field.type == 'SIGNATURE') {
		
		window.sigPad = $fieldToAppend.signaturePad({
			penColour: colourString(SalesToolkit.Theme.getColourProperty('signatureColour', '#ff0000')),
			onDrawEnd: function () {
				$form.find('[name=' + this.name + ']').val(
					this.getSignatureImage(signatureContentType).replace("data:" + (signatureContentType || "image/png") + ";base64,", '')
				);
			}
		});


		var initialSignatureState = atheneumInstance.Theme.getStringProperty('initialSignatureState', 'type');

		if (!atheneumInstance.Theme.getBooleanProperty('enableTypedSignature', true)) {
			$fieldToAppend.find('.typeIt').hide();
			initialSignatureState = 'draw';
		}

		sigPad.name = field.name;

		$fieldToAppend.find('label').on('click', function (event) {
			event.preventDefault();
			$(this).parents('.atheneum-form-field').find('.sigName:visible').focus();
		});

		$fieldToAppend.find('.typeIt a').on('click', function () {
			$(this).parents('.atheneum-form-field').find('.sigName').show();
			$(this).parents('.atheneum-form-field').find('.sigName').trigger('change');
			$(this).parents('.atheneum-form-field').find('.sigName').focus();
		});

		$fieldToAppend.find('.drawIt a').on('click', function () {
			$(this).parents('.atheneum-form-field').find('.sigName').hide();
		});

		$fieldToAppend.find('.clearButton').on('click', function () {
			$(this).parents('.atheneum-form-field').find('.sigData').val($(this).parents('.atheneum-form-field').find('.emptySigData').val());
		});

		if (initialSignatureState == 'draw') {
			var $drawItButton = $fieldToAppend.find('.drawIt').find('a');
			if ($drawItButton.length == 0) {
				$drawItButton = $fieldToAppend.find('.drawIt');
			}
			$drawItButton.click();
			$fieldToAppend.find('.sigName').hide();

		}
		else if (initialSignatureState == 'type') {
			$fieldToAppend.find('.sigName').show();
			$fieldToAppend.find('.sigName').trigger('change');
		}

		$fieldToAppend.find('canvas.pad').on('click', function () {
			if ($(this).parents('.atheneum-form-field').find('.typeIt .signature-current').length > 0) {
				$fieldToAppend.find('.sigName').focus();
			}
		});

		$fieldToAppend.find('.sigName').attr('data-default-value', '');

		$fieldToAppend.find('.sigName').on('change keyup', function () {

			var $fieldContainer = $(this).parents('.atheneum-form-field');
			var $sigData = $fieldContainer.find('.sigData');

			if (!$(this).val()) {
				$sigData.val($fieldContainer.find('.emptySigData').val());
			}


			var fontSize = $fieldContainer.find('.typed').css('font-size') || (defaultFontSize + 'px');

			var $canvas = $fieldContainer.find('canvas').clone().hide().attr('id', 'tmp_canvas');
			var defaultFontSize = ($canvas[0].height * 0.546) | 0;
			$fieldContainer.find('.typed').show();
			$fieldContainer.append($canvas);
			var context = $canvas[0].getContext('2d');
			context.clearRect(0, 0, $canvas[0].width, $canvas[0].height);
			context.fillStyle = '#fff';
			context.rect(0, 0, $canvas[0].width, $canvas[0].height);
			context.fill();
			context.font = fontSize + " 'Journal',Georgia,Times,serif";
			context.fillStyle = '#145394';
			var textSize = parseInt(fontSize.replace('px', ''));
			context.fillText($(this).val(), (textSize / 4), (($canvas.height() / 2) + (textSize / 2) - 5));
			$sigData.val($canvas[0].toDataURL(signatureContentType).replace("data:" + (signatureContentType || "image/png") + ";base64,", ''));
			$canvas.remove();
		});

		var emptyCanvasData = sigPad.getSignatureImage(signatureContentType).replace("data:" + (signatureContentType || "image/png") + ";base64,", '');
		$fieldToAppend.find('.emptySigData').val(emptyCanvasData);
		$fieldInput.val(emptyCanvasData);
		$fieldInput.attr('data-default-value', emptyCanvasData);
		$fieldInput.data('sigPad', sigPad);
	}

	if (atheneumInstance.Theme.getStringArrayProperty('modificationsToTheseFieldsUndoContactConsent', []).indexOf(field.name) != -1) {
		$fieldInput.attr('data-modifications-to-this-field-undo-consent', 'true');
	}

	addContactSuggestionsToFormField($form, $fieldInput);
}


function getCartShareForm() {
	var collectionIds = [];
	var forms = [];
	for (var a = 0; a < atheneumInstance.Cart.assetIds.length; a++) {
		var asset = atheneumInstance.Library.assets[atheneumInstance.Cart.assetIds[a]];
		if (asset.containedBy && collectionIds.indexOf(asset.containedBy) == -1) {
			collectionIds[collectionIds.length] = asset.containedBy;
		}
	}
	for (var c = 0; c < collectionIds.length; c++) {
		var collectionShareForm = atheneumInstance.Forms.getCollectionShareForm(collectionIds[c]);
		if (collectionShareForm && forms.indexOf(collectionShareForm) == -1) {
			forms[forms.length] = collectionShareForm;
		}
	}

	if(forms.length === 0){
		return atheneumInstance.Forms.getDefaultShareForm();
	}

	if (forms.length != 1) {
		// there are multiple forms
		// TODO - create some sort of hybrid form with a mix of the fields of all the forms
		return forms[0];
	}
	return forms[0];
}

function getMLRReviewForm() {
	var collectionIds = [];
	var forms = [];
	for (var a = 0; a < atheneumInstance.Cart.assetIds.length; a++) {
		var asset = atheneumInstance.Library.assets[atheneumInstance.Cart.assetIds[a]];
		if (asset.containedBy && collectionIds.indexOf(asset.containedBy) == -1) {
			collectionIds[collectionIds.length] = asset.containedBy;
		}
	}
	for (var c = 0; c < collectionIds.length; c++) {
		var collectionMLRForm = atheneumInstance.Forms.getCollectionMLRForm(collectionIds[c]);
		if (collectionMLRForm && forms.indexOf(collectionMLRForm) == -1) {
			forms[forms.length] = collectionMLRForm;
		}
	}
	if (forms.length != 1) {
		// there are multiple forms
		// TODO - create some sort of hybrid form with a mix of the fields of all the forms
		return forms[0];
	}
	return forms[0];
}

function getRegisterInterestForm() {
	var collectionIds = [];
	var forms = [];
	for (var a = 0; a < atheneumInstance.Cart.assetIds.length; a++) {
		var asset = atheneumInstance.Library.assets[atheneumInstance.Cart.assetIds[a]];
		if (asset.containedBy && collectionIds.indexOf(asset.containedBy) == -1) {
			collectionIds[collectionIds.length] = asset.containedBy;
		}
	}
	for (var c = 0; c < collectionIds.length; c++) {
		var collectionRIForm = atheneumInstance.Forms.getCollectionRegisterInterestForm(collectionIds[c]);
		if (collectionRIForm && forms.indexOf(collectionRIForm) == -1) {
			forms[forms.length] = collectionRIForm;
		}
	}
	if (forms.length != 1) {
		// there are multiple forms
		// TODO - create some sort of hybrid form with a mix of the fields of all the forms
		return forms[0];
	}
	return forms[0];
}

function getShareCartForm() {
	let form = atheneumInstance.Forms.getCollectionShareCartForm();
	
	if(typeof form !== 'undefined' && form != null)
	{
		return form;
	}	
}
/**
 * 
 * @param {jQuery} $htmlForm
 * @param {Form} form
 */
function dependenciesSetup( $htmlForm, form ) {
	
	
	for( var i=0; i<form.fields.length; i++ ) {
		var field = form.fields[i];
		if( field.dependencies == null || field.dependencies.length == 0 )
			continue;
		
		var isRequired = (field.required == undefined ? false : field.required);
		if(field.requiredForMeetingParticipants != undefined) {
			isRequired = field.requiredForMeetingParticipants;
		}
		
		var isVisible = field.visible;
		if(form.type === 'REMOTE_CONSENT' && field.visibleForMeetingParticipants != undefined) {
			isVisible = field.visibleForMeetingParticipants;
		}

		var $htmlFields = $htmlForm.find('[name='+field.name+']');
		if(field.type === 'LABEL'){
			$htmlFields = $htmlForm.find('[for='+field.name+']');
		}
		$htmlFields.attr('data-visible-default', isVisible);
		$htmlFields.attr('data-required-default', isRequired);
		$htmlFields.attr('data-disabled-default', ((field.disabled == undefined) ? ((field.enabled == undefined) ? false : !(field.enabled)) : field.disabled) );
		$htmlFields.attr('data-dependencies', JSON.stringify(field.dependencies));
	
		for(var j=0; j<field.dependencies.length; j++ ) {
			var dependency = field.dependencies[j];
			
			var $fieldsToApplyChangeHandlerTo;
			if( dependency.field ) {
				$fieldsToApplyChangeHandlerTo = $htmlForm.find('[name=' + dependency.field + ']');
			}
			else {
				$fieldsToApplyChangeHandlerTo = $htmlFields;
			}
			
			$fieldsToApplyChangeHandlerTo.attr('onchange', 'handleDependencies($(this).parents(\"form\").eq(0));' );
			// TODO:
			// Past Matt - Remember why I used attr('onchange',...) rather than on('change',...) 
			// Matt - possibly to prevent it firing multiple times?
		}
		
	}
		
	handleDependencies( $htmlForm );
}

const isEmailVal = function (value) {
    var input = document.createElement('input');
  
    input.type = 'email';
    input.required = true;
    input.value = value;
  
    return typeof input.checkValidity === 'function' ? input.checkValidity() : /\S+@\S+\.\S+/.test(value);
  }

async function handleDependenciesAsync($htmlForm, email){
	let contact = await atheneumInstance.Contacts.getByEmailAddress(email);
		
	handleDependencies($htmlForm, contact);
}

/**
 * 
 * @param {jQuery} $htmlForm
 */
function handleDependencies( $htmlForm, aContact = -1 ) {

	var formSubmissionBlockingPopup = null;
	
	var formContactId = $htmlForm.attr('data-contact-id') || undefined;

	
	var $emailField = $htmlForm.find("input[data-type='EMAIL']");
	if(formContactId && aContact == -1){
		setTimeout(handleDependenciesAsync, 0, $htmlForm, $emailField.val());
		return;
	}

	if (atheneumInstance.Theme.getBooleanProperty('dependenciesCompareContactEmail', false) && $emailField.length > 0 && $emailField.val().length > 0 && isEmailVal($emailField.val())) {
			let contact =aContact;
			if(contact && contact.length == 1){
				contact = contact[0];
				if(typeof formContactId == 'undefined' || formContactId != contact.id){
					if(!(contact instanceof Atheneum.Contact)){
						contact  = new Atheneum.Contact(contact);
					}
					onFormContactSelect($htmlForm, contact, $emailField, false);
					formContactId = $htmlForm.attr('data-contact-id') || undefined;
				}
				
			}else if(contact && contact.length == 2 && contact.filter(x=> x instanceof Atheneum.Contact).length == 1){
				contact = contact.filter(x=> x instanceof Atheneum.Contact);
				contact = contact[0];
				if(typeof formContactId != 'undefined' || formContactId != contact.id){
					onFormContactSelect($htmlForm, contact, $emailField, false);
					formContactId = $htmlForm.attr('data-contact-id') || undefined;
				}
			}
		
	}

	var formContactMDMId = $htmlForm.attr('data-contact-mdm-id') || undefined;
	//TODO VEEVA IS IT CRM ID?
	var formContactCRMId = $htmlForm.attr('data-contact-crm-id') || undefined;

	var formContactConsented = ($htmlForm.attr('data-contact-consented') || "false") == "true" ? true : false;
	


	$htmlForm.find('[data-dependencies]').each(function(){
		
		var $htmlField = $(this);

		var dependencies = JSON.parse($htmlField.attr('data-dependencies') || "[ ]");
		if( dependencies == null || dependencies.length == 0 )
			return; // this should never happen, but just in case
		
		var popups = [ ];
		var visible = undefined;
		var required = undefined;
		var enabled = undefined;
		
		for( var j=0; j<dependencies.length; j++ ) {
			var dependency = dependencies[j];
			
			var fieldValue = undefined;

			var $relatedField;
			if( dependency.field ) {
				$relatedField = $htmlForm.find( '[name=' + dependency.field + ']' );
			}
			else {
				$relatedField = $htmlForm.find( '[name=' + $htmlField.attr('name') + ']' );
			}
			
			if( $relatedField.is('[data-type=RADIO_MULTI]') ) {
				fieldValue = "";
				var $selectedOptions = $relatedField.filter(':checked')
				$selectedOptions.each(function(option) {
					if( fieldValue != "" ) {
						fieldValue += ",";
					}
					fieldValue += $(this).val();
				});
			}
			else if( $relatedField.is('input[type=checkbox]') ) {
				fieldValue = $relatedField.is(':checked') + "";
			}
			else if($relatedField.is('input[type=radio]')) {
				
				if( $relatedField.is(':checked') ) {
					fieldValue = $relatedField.filter(':checked').val();
				}
				else {
					fieldValue = null;
				}
			}
			else {
				fieldValue = $relatedField.val();
			}

			if($relatedField.data('type') === 'COUNTRY')
				fieldValue = fieldValue?.toUpperCase();
			
			var dependencyShouldApply = false;
			if (dependency.hasOwnProperty('rules') && Array.isArray(dependency.rules) && dependency.rules.length >= 1) {
				var matches = 0;
				$.each(dependency.rules, function(index, rule) {
					var depField = $htmlForm.find( '[name=' + rule.field + ']' );
					var value = depField.val();
					if (depField.is('input[type=checkbox]')) {
						value = depField.is(":checked").toString();
					}
					var matchFound = false;
					if (depField.length == 1) {
						if (rule.partialMatchEnabled) {
							matchFound = (value.indexOf(rule.field) >= 0);
						} else {
							matchFound = (value == rule.value);
						}
					}
					if (matchFound) {
						matches++;
					}
				});
				switch (dependency.ruleOperator) {
					case 'OR': {
					// check at least one rule matches
					dependencyShouldApply = (matches >= 1);
					break;
					}
					case 'XOR': {
					// check only one rule matches
					dependencyShouldApply = (matches == 1);
					break;
					}
					case 'NOT': {
					// check no rules match
					dependencyShouldApply = (matches == 0);
					break;
					}
					case 'AND':
					default: {
					// check all rules match
					dependencyShouldApply = (matches == dependency.rules.length);
					break;
					}
				}
			} else if(dependency.value == undefined) {
				dependencyShouldApply = true;
			} else if( $relatedField.is('[data-type=RADIO_MULTI]') ) {
				var fieldValues = fieldValue.split(',');
				for(var v=0; v<fieldValues.length; v++) {
					var value = fieldValues[v];
					if( dependency.partialMatchEnabled ) {
						dependencyShouldApply = (value.indexOf(dependency.value) != -1);
					}
					else {
						dependencyShouldApply = (value == dependency.value);
					}
				}
				
			}
			else if( dependency.partialMatchEnabled ) {
				dependencyShouldApply = (fieldValue.indexOf(dependency.value) != -1);
			}
			else {
				dependencyShouldApply = (fieldValue == dependency.value);
			}
			
			if( dependency.consented === true || dependency.consented === false ) {
				
				var contact = formContactId ? aContact : null;
				if(typeof SalesToolkit.Contacts.customContacts !== 'undefined' && (contact == null || contact == undefined)){
					contact = SalesToolkit.Contacts.customContacts[formContactMDMId] || null;
				}

				if(typeof SalesToolkit.Contacts.customContacts !== 'undefined' && (contact == null || contact == undefined)){
					contact = SalesToolkit.Contacts.customContacts[formContactCRMId] || null;
				}
				var consentedType = dependency.consentedType || 'HAS_CONTACT_AND_SUBSCRIBED';
				var unconsentedType = dependency.unconsentedType || 'ALL';
				
				if(dependency.consented) {
					if(consentedType == 'HAS_CONTACT') {
						dependencyShouldApply = dependencyShouldApply && (contact != null);
					}
					else if(consentedType == 'HAS_CONTACT_AND_SUBSCRIBED') {
						dependencyShouldApply = dependencyShouldApply
							&& (contact != null)
							&& (contact.status == Atheneum.Contact.Status.SUBSCRIBED
								|| contact.status == Atheneum.Contact.Status.SUBSCRIBED_PENDING);
					}
					else {
						// default = HAS_CONTACT_AND_SUBSCRIBED
						dependencyShouldApply = dependencyShouldApply
						&& (contact != null)
						&& (contact.status == Atheneum.Contact.Status.SUBSCRIBED
							|| contact.status == Atheneum.Contact.Status.SUBSCRIBED_PENDING);
					}
				}
				else {
					// consented = false
					
					var hasNoContact = (contact == null);
					var hasPendingContact = (contact != null && contact.status == Atheneum.Contact.Status.PENDING);
					var hasUnsubscribedContact = (contact != null && contact.status == Atheneum.Contact.Status.UNSUBSCRIBED);
					
					if(unconsentedType == 'NO_CONTACT') {
						dependencyShouldApply = dependencyShouldApply && hasNoContact;
					}
					else if(unconsentedType == 'CONTACT_WITH_UNSUBSCRIBED') {
						dependencyShouldApply = dependencyShouldApply && hasUnsubscribedContact;
					}
					else if(unconsentedType == 'CONTACT_WITH_PENDING') {
						dependencyShouldApply = dependencyShouldApply && hasPendingContact;
					}
					else if(unconsentedType == 'ANY') {
						dependencyShouldApply = dependencyShouldApply && (
								hasNoContact || hasUnsubscribedContact || hasPendingContact);
					}
					else {
						// default = ANY
						dependencyShouldApply = dependencyShouldApply && (
								hasNoContact || hasUnsubscribedContact || hasPendingContact);
					}
				}
			}
			
			
			if( dependencyShouldApply ) {
				
				switch( dependency.action ) {
					
					case "REQUIRED":
						required = true;
						break;
						
					case "OPTIONAL":
						required = required || false;
						break;
					
					case "SHOW":
						visible = true;
						break;

					case "HIDE":
						visible = visible || false;
						break;
						
					case "ENABLE":
						enabled = true;
						break;
						
					case "DISABLE":
						enabled = enabled || false;
						break;
					
					case "POPUP":
						var triggeringDependencyIdentifier = window.btoa(JSON.stringify(dependency));
						popups[popups.length] = {
							'id': triggeringDependencyIdentifier,
							'title': dependency.title,
							'message': dependency.message,
							'dismissFormButtonText': dependency.dismissFormButtonText || null,
							'dismissPopupButtonText': dependency.dismissPopupButtonText || null,
							'block': false
						};
						break;

					case "BLOCKPOPUP":
						formSubmissionBlockingPopup = {
							'title': dependency.title,
							'message': dependency.message,
							'dismissFormButtonText': dependency.dismissFormButtonText || null,
							'dismissPopupButtonText': dependency.dismissPopupButtonText || null,
							'block': true
						};
						break;
				}
			}
			else if( dependency.action == "POPUP" || dependency.action == "BLOCKPOPUP" ) {
				var popupsTriggered = JSON.parse(($htmlField.attr('data-popups-triggered') || '[]').replace(/&quot;/g, '"'));
				var triggeringDependencyIdentifier = window.btoa(JSON.stringify(dependency));
				popupsTriggered = popupsTriggered.filter(function(x) { return (x != triggeringDependencyIdentifier); });
				$htmlField.attr('data-popups-triggered', JSON.stringify(popupsTriggered).replace(/"/g, '&quot;'));
			}
		}
		
			
		if(visible == undefined)
			visible = $htmlField.attr('data-visible-default') == "false" ? false : true;
			
		if(required == undefined)
			required = $htmlField.attr('data-required-default') == "false" ? false : true;

		if(enabled == undefined)
			enabled = $htmlField.attr('data-disabled-default') == "false" ? true : false;
		
		if(required != $htmlField.prop('required')) {
			
			var $label = $htmlForm.find('label[for=' + $htmlField.attr('name') + ']');
			if($htmlField.prop('nodeName').toUpperCase() === 'LABEL')
				$label = $htmlField;
			if(!required) {
				
				// hide error messages
				$label.removeClass('failed invalid error');
				$htmlField.removeClass('failed invalid error');
				
				// remove last * character in label
				if( $label.text().endsWith('*') ) {
					$label.text($label.text().substring(0, $label.text().length - 1));
				}
				
				$htmlField.removeClass('required');
				$htmlField.removeAttr('required');
			}
			else {
				// add * character to end of label
				if( $label.text().trim() != "" && !($label.text().trim().endsWith("*")) ) {
					$label.html($label.html() + "*");
				}
				
				$htmlField.addClass('required');
				$htmlField.attr('required', 'required');
			}
		}
		
		var fieldLabelSelector = '.atheneum-form-label[for="'	+ $htmlField.attr('name') + '"]'
			+ ', '
			+ '.atheneum-form-label[for="' + $htmlField.attr('name') + 'Label"]'
			+ ', '
			+ '.atheneum-form-label[for="' + $htmlField.attr('name') + '_label"]'
		;

		// show / hide field based on visibility
		if( visible ) {
			if($htmlField.prop('nodeName').toUpperCase() === 'LABEL'){
				$htmlField.show();
			}else{
				$htmlField.parents('.atheneum-form-field').eq(0).show();
				$htmlField.parents('.atheneum-form-field').eq(0).parent().children(fieldLabelSelector).show();
			}
		
			
		} else {

			if($htmlField.prop('nodeName').toUpperCase() === 'LABEL'){
				$htmlField.hide();
			}else{
				$htmlField.parents('.atheneum-form-field').eq(0).hide();
				$htmlField.parents('.atheneum-form-field').eq(0).parent().children(fieldLabelSelector).hide();
			}
			
		}
		
		if($htmlField.prop('nodeName').toUpperCase() === 'LABEL')
			return;
			
		// disable fields if necessary
		if( !enabled ) {
			$htmlField.parents('.atheneum-form-field').addClass('disabled');
			$htmlField.parents('.atheneum-form-field').eq(0).find('input:not(.ignore), .sigName').attr('disabled', 'disabled');
			$htmlField.parents('.atheneum-form-field').eq(0).find('input:not(.ignore), .sigName').toggleClass('readonly', true);
			$htmlField.parents('.atheneum-form-field').eq(0).find('input:not(.ignore), .sigName').attr('readonly', 'readonly');
			$htmlField.parents('.atheneum-form-field').eq(0).parent().children(fieldLabelSelector).attr('data-disabled', 'true');
		}
		else {
			$htmlField.parents('.atheneum-form-field').removeClass('disabled');
			$htmlField.parents('.atheneum-form-field').eq(0).find('input:not(.ignore), .sigName').removeAttr('disabled');
			$htmlField.parents('.atheneum-form-field').eq(0).find('input:not(.ignore), .sigName').toggleClass('readonly', false);
			$htmlField.parents('.atheneum-form-field').eq(0).find('input:not(.ignore), .sigName').removeAttr('readonly', 'readonly');
			$htmlField.parents('.atheneum-form-field').eq(0).parent().children(fieldLabelSelector).attr('data-disabled', 'false');
		}
		
		var popupsTriggered = JSON.parse(($htmlField.attr('data-popups-triggered') || '[]').replace(/&quot;/g, '"'));
		for(var p=0; p<popups.length; p++) {
			var popup = popups[p];
			if( popupsTriggered.indexOf(popup.id) != -1 ) {
				// popup has already been shown - skip
				continue;
			}
			else {
				Array.prototype.slice.call($('input:focus, textarea:focus')).forEach(function(element) {
					element.blur();
				});
				
				if( popup.dismissFormButtonText || popup.dismissPopupButtonText ) {
					var popupButtons = [ ];
					if( popup.dismissFormButtonText ) {
						popupButtons[popupButtons.length] = {
							text: popup.dismissFormButtonText,
							action: 'dismiss-form',
						    dismiss: true,
							callback: function() {
								$('#backButton').click();
							},
							buttonClass: "vpopup-button dismiss-form-button"
						}
					}
					if( popup.dismissPopupButtonText ) {
						popupButtons[popupButtons.length] = {
							text: popup.dismissPopupButtonText,
							action: 'dismiss-popup',
						    dismiss: true,
							callback: function() { },
							buttonClass: "vpopup-button dismiss-popup-button vpopup-button-ok"
						}
					}
					vPopup.create({
						title: popup.title,
						message: popup.message,
						buttons: popupButtons
					});
				}
				else {
					vPopup.create({
						title: popup.title,
						message: popup.message
					});
				}
			}
		}
	});

	handleSectionsVisibility();
	
	if( formSubmissionBlockingPopup ) {
		$htmlForm.attr('data-submission-blocking-popup', JSON.stringify(formSubmissionBlockingPopup).replace(/"/g, '&quot;'));
	}
	else {
		$htmlForm.removeAttr('data-submission-blocking-popup');
	}
}

function handleSectionsVisibility(){
	if(!SalesToolkit.Theme.getBooleanProperty('hideSectionsWithNoVisibleInputs', true))
		return;

	$('.form-section').each(function(){
		if($(this).find('.atheneum-form-field').not('[style*="display: none"]').length == 0)
			$(this).hide();
		else
			$(this).show();
	});
}
/**
 * Validates the form, adding the "invalid" class to fields which fail validation.
 * Returns <code>true</code> if the form passes validation, <code>false</code> otherwise
 * 
 * @param {jQuery} $form
 * @returns {boolean}
 */
function validateForm($form, fromChange = false, shareLinkMode = false) {

	var invalidFieldNames = [];
	var fieldNamesToSkip = {};
	var validateField = true;

	if(typeof form === 'undefined')
	{
		var form = {};
	}
	var formId = $form.find('input[name="hidden-form-id"]').val();
	var formObj = SalesToolkit.Forms.formList[formId] || form;


	var $fields = $form.find('input:not(.ignore):not(.freeText), select, textarea');
	for (var f = 0; f < $fields.length; f++) {
		var $field = $($fields[f]);
		var name = $field.attr('name');

		if (name in fieldNamesToSkip)
			continue;

		let field = formObj?.fields?.find(x=> x.name === name);

		var invalid = false;

		var a = $field.data('type');

		//if field type REMOTE_CONSENT is checked, skip validating fields apart from "to" 
		if ($field.data('type') == 'REMOTE_CONSENT' && $field.is(':checked')) {
			validateField = false;
		}

		if ($field.data('type') == 'CHECKBOX' && validateField) {
			invalid = $field.is('.required:not(:checked)');
		}
		else if ($field.data('type') == 'EMAIL') {
			let hasRequired = $field.is('.required');
			if(!shareLinkMode && $field.parents('.atheneum-form-field').data('requiredForNonLink') == true){
				hasRequired = true;
			}

			if ((!validateField && $field.attr('id') == 'to') || validateField) {
				invalid = (hasRequired && !$field.val()) || ($field.val() && !validateEmailList($field.val()));
			}

			if(shareLinkMode)
				invalid = false;
		}
		else if($field.data('type') == 'PHONE') {
			invalid = ($field.is('.required') && !$field.val()) || ($field.val() && !validatePhone($field.val()));
		}
		else if (($field.data('type') == 'RADIO' || $field.data('type') == 'RADIO_MULTI') && validateField) {

			var $optionGroup = $form.find('[name=' + name + ']');

			name = $field.attr('id');

			invalid = $optionGroup.is('.required') && !$optionGroup.is(':checked');

			if ($field.is('.hasFreeText')) {
				var $freeTextField = $form.find('#' + $field.attr('data-linked-field'));

				if ($field.is(':checked') && $freeTextField.val().trim() == '') {
					invalid = true;
					$freeTextField.addClass('invalid');
				}
				else {
					$freeTextField.removeClass('invalid');
				}
			}
		}
		else if ($field.data('type') == 'SIGNATURE' && validateField) {
			invalid = $field.is('.required') && ($field.parents('.atheneum-form-field').eq(0).find('.emptySigData').val() == $field.val());
		}else if($field.attr('data-filtered-textfield') != undefined && $field.is('.required') && validateField){
			let filteredTextFieldId = $field.data('filtered-textfield');
			let filteredTextField = window[filteredTextFieldId];
			if(filteredTextField)
				invalid = filteredTextField.selectedItems.length == 0;
			else
				invalid = !$field.val();
		}
		else if ($field.is('.required') && validateField) {
			invalid = !$field.val();
		}

		if((typeof meetingId !== 'string' || dateHasChange) && !fromChange && !invalid && $field.data('type') == 'DATE' && validateField && typeof field?.properties !== 'undefined' && field?.properties.hasOwnProperty('min')){
			let min = field.properties.min;
			let dateValue = new Date($field.val());

			if(min === 'now')
				min = new Date();
			else
				min = new Date(min);

			if($field.is('.required') && dateValue.getTime() < min.getTime()){
				//Date should not be less than min
				invalid = true;
				var notificationBody = atheneumInstance.Translation.getFormatted('dateMustBeInTheFuture', 'The date selected must be after {0}', [min.toLocaleString()]);
				atheneumInstance.UI.Notifications.showCustomNotification("info", notificationBody);
			}
		}

		//CHANGED FOR GLU
		//var $label = $('label[for="' + name + '"]');
		var $label = $form.find('label[for="' + name + '"]');

		if (invalid) {
			$field.addClass('invalid');
			$label.addClass('invalid');
			$field.addClass('invalid previously-invalid');
			$label.addClass('invalid previously-invalid');
			invalidFieldNames[invalidFieldNames.length] = name;
		} else {
			$field.removeClass('invalid');
			$label.removeClass('invalid');
		}

		fieldNamesToSkip[name] = true;
	}

	return invalidFieldNames.length == 0;
}

var contactPopupAlreadyTriggered = false;
var emailContactPopupAlreadyTriggered = false;
// called when the user alters the value in a field that was autofilled by contact info
function onChangePrefilledContactField($field, $form) {

	let formId = $form.find('input[name="hidden-form-id"]').val();
	let formObj = atheneumInstance.Forms.formList[formId];
	
	$field.attr('data-field-value-autofilled-by-contact', 'false');

	if ($field.is('[data-modifications-to-this-field-undo-consent="true"]')) {
		$form.attr('data-contact-consented', 'false');
		handleDependencies($form);
	}

	var modifiedContactAutofilledFields = $form.find('[data-field-value-initially-autofilled-by-contact][data-field-value-autofilled-by-contact=false]').length;

	let contactFieldModificationsNeededToTriggerPopup = atheneumInstance.Theme.getIntegerProperty('contactFieldModificationsNeededToTriggerPopup', 2);
	try {
		if(typeof formObj !== 'undefined' && formObj.hasOwnProperty('contactFieldModificationsNeededToTriggerPopup'))
			contactFieldModificationsNeededToTriggerPopup = parseInt(formObj.contactFieldModificationsNeededToTriggerPopup);
	} catch (error) {
		contactFieldModificationsNeededToTriggerPopup = atheneumInstance.Theme.getIntegerProperty('contactFieldModificationsNeededToTriggerPopup', 2);
	}

	if(!emailContactPopupAlreadyTriggered && $field.data('type') === 'EMAIL' && atheneumInstance.Theme.getBooleanProperty('showContactEmailChangedPopup', false)){
		vPopup.create({
			title: atheneumInstance.Translation.getOrGetThemeKey('contactEmailUpdatePopupTitle', 'Email Updated'),
			message: atheneumInstance.Translation.getOrGetThemeKey('contactEmailUpdatePopupMessage', 'On form submission the email inputed in this form will be used for further transactions'),
			buttons: [
				{
					action: "OK",
					text: atheneumInstance.Translation.getOrGetThemeKey('contactEmailUpdatePopupOK', 'OK'),
					callback: function () {
						emailContactPopupAlreadyTriggered = true;
						$field.focus();
					}
				}
			]
		});
	}

	if (!contactPopupAlreadyTriggered && modifiedContactAutofilledFields >= contactFieldModificationsNeededToTriggerPopup) {

		vPopup.create({
			title: atheneumInstance.Translation.getOrGetThemeKey('contactUpdatePopupTitle', 'Update Contact'),
			message: atheneumInstance.Translation.getOrGetThemeKey('contactUpdatePopupMessage',
				'You\'ve made multiple changes to this contact\'s information. '
				+ 'Do you wish for this contact to be updated, or create a new one entirely?'
			),
			buttons: [
				{
					action: "UPDATE",
					text: atheneumInstance.Translation.getOrGetThemeKey('contactUpdatePopupUpdate', 'Update'),
					callback: function () {
						contactPopupAlreadyTriggered = true;
					}
				},
				{
					action: "DO_NOT_UPDATE",
					text: atheneumInstance.Translation.getOrGetThemeKey('contactUpdatePopupDoNotUpdate', 'Create New'),
					callback: function () {
						onFormUnselectContact($form);
					}
				}
			]
		});
	}
	else if (atheneumInstance.Theme.getBooleanProperty('clearFormContactAfterClearingAllVisibleFields', true)) {
		allFieldsBlank = true;
		$form.find('input:not([type=checkbox]):not([type=radio]), select, textarea').filter(':visible').each(function () {
			if ($(this).val().trim()) {
				allFieldsBlank = false;
			}
		});
		if (allFieldsBlank) {
			onFormUnselectContact($form);
		}
	}
}

// called when someone changes the value in a field back to the value prefilled from the contact info
function onResetPrefilledContactField($field, $form) {
	$field.attr('data-field-value-autofilled-by-contact', 'true');
	if ($form.attr('data-contact-originally-consented') == 'true'
		&& $form.find('[data-field-value-autofilled-by-contact="false"][data-modifications-to-this-field-undo-consent="true"]').length == 0) {
		$form.attr('data-contact-consented', 'true');
		handleDependencies($form);
	}
}

function onFormUnselectContact($htmlForm) {
	$htmlForm.removeAttr('data-contact-id');
	$htmlForm.removeAttr('data-contact-mdm-id');
	$htmlForm.removeAttr('data-contact-consented');
	$htmlForm.removeAttr('data-contact-originally-consented');
	$htmlForm.find('input[name="CONTACT_ID"]').addClass('ignore').val('');
	$htmlForm.find('[data-field-value-autofilled-by-contact=true]').removeAttr('data-field-value-autofilled-by-contact');
	$htmlForm.find('[data-field-value-initially-autofilled-by-contact]').removeAttr('data-field-value-initially-autofilled-by-contact');

	var $formFields = $htmlForm.find('input[name], select[name], textarea[name]');
	for (var f = 0; f < $formFields.length; f++) {
		var $field = $formFields.eq(f);
		var fieldName = $field.attr('name');
		if (isFieldReadOnly($htmlForm.find('input[name=id]').val(), fieldName)) {
			$field.attr('readonly', 'readonly');
			$field.addClass('readonly');
			$field.attr('disabled', 'disabled');
		}
		else {
			$field.removeAttr('readonly');
			$field.removeClass('readonly');
			$field.removeAttr('disabled');
		}
	}

	contactPopupAlreadyTriggered = false;

	handleDependencies($htmlForm);
}

/**
 * Triggered when the user selects a contact for the form.
 * In the event that it was triggered by a suggestion for a specific field, said field will be the 3rd argument
 */
function onFormContactSelect($htmlForm, contact, $triggeringFormField, preventAlreadyCapturedPopup = false) {
	if ($htmlForm.data('multiple-contacts-possible')) {
		console.log('multiple contact ids possible');
		var index = $triggeringFormField.parent().parent().index();
		$htmlForm.attr('data-contact-id-'+index, contact.id);
		if(contact.hasOwnProperty('info') && contact.info.hasOwnProperty('mdmId'))
			$htmlForm.attr('data-contact-mdm-id-'+index, contact.info.mdmId);
		//TODO VEEVA IS IT CRMID?
		if(contact.hasOwnProperty('info') && contact.info.hasOwnProperty('crmId'))
			$htmlForm.attr('data-contact-crm-id-'+index, contact.info.crmId);

		$htmlForm.attr('data-contact-consented-'+index, contact.isConsented());
		$htmlForm.attr('data-contact-originally-consented-' + index, contact.isConsented());
		if ($htmlForm.find('input[name="CONTACT_ID_' + index +'"]').length == 0)
			$htmlForm.find('input[name="CONTACT_ID"]').parent().append('<input type="hidden" name="CONTACT_ID_' + index+'" value="'+contact.id+'" />');
		else
			$htmlForm.find('input[name="CONTACT_ID_' + index +'"]').removeClass('ignore').val(contact.id);
	}

	$htmlForm.attr('data-contact-id', contact.id);
	if(contact.hasOwnProperty('info') && contact.info.hasOwnProperty('mdmId'))
			$htmlForm.attr('data-contact-mdm-id', contact.info.mdmId);
	//TODO VEEVA IS IT CRMID?
	if(contact.hasOwnProperty('info') && contact.info.hasOwnProperty('crmId'))
		$htmlForm.attr('data-contact-crm-id', contact.info.crmId);
	$htmlForm.attr('data-contact-consented', contact.isConsented());
	$htmlForm.attr('data-contact-originally-consented', contact.isConsented());
	$htmlForm.find('input[name="CONTACT_ID"]').removeClass('ignore').val(contact.id);

	var formId = $htmlForm.find('input[name="hidden-form-id"]').val();
	var includeOtherFormSubmissionsInCount = $htmlForm.attr('data-contact-includeOtherFormSubmissionsInCount');
	if (includeOtherFormSubmissionsInCount && Atheneum.Theme.TRUE_VALUES.contains(includeOtherFormSubmissionsInCount))
		includeOtherFormSubmissionsInCount = true;
	else
		includeOtherFormSubmissionsInCount = false;
	var maxSubmissionsPerContact = $htmlForm.attr('data-contact-maxSubmissionsPerContact');
	var requireConsent = $htmlForm.attr('data-contact-requireConsent');
	if (requireConsent && Atheneum.Theme.TRUE_VALUES.contains(requireConsent))
		requireConsent = true;
	else
		requireConsent = false;

	if (contact.isBlocked(formId, includeOtherFormSubmissionsInCount, maxSubmissionsPerContact)) {
		// blocked contact selected popup
		if (atheneumInstance.Theme.getBooleanProperty('showBlockedLoadedAlerts', true)) {
			var blockedContactPopupTitle = atheneumInstance.Translation.getOrGetThemeKey('blockedLoadedTitle', 'Blocked');
			var blockedContactPopupMessage = atheneumInstance.Translation.getOrGetThemeKey('blockedLoadedMessage', 'Contact has exceeded the maximum number of submissions.');
			vPopup.create({
				title: blockedContactPopupTitle,
				message: blockedContactPopupMessage
			});
		}
	} else if (requireConsent && !contact.isConsented()) {
		// require consent popup
		if (atheneumInstance.Theme.getBooleanProperty('showConsentRequiredAlerts', true)) {
			var consentRequiredPopupTitle = atheneumInstance.Translation.getOrGetThemeKey('consentRequiredLoadedTitle', 'Consent Required');
			var consentRequiredPopupMessage = atheneumInstance.Translation.getOrGetThemeKey('consentRequiredLoadedMessage', 'Selected contact must be either SUBSCRIBED or SUBSCRIBED_PENDING status.');
			vPopup.create({
				title: consentRequiredPopupTitle,
				message: consentRequiredPopupMessage
			});
		}
	} else if (contact.isConsented()) {
		// consented contact selected popup
		if (atheneumInstance.Theme.getBooleanProperty('showContactLoadedAlerts', true) && !preventAlreadyCapturedPopup) {
			var consentedContactPopupTitle = atheneumInstance.Translation.getOrGetThemeKey('contactLoadedTitle', 'Consent');
			var consentedContactPopupMessage = atheneumInstance.Translation.getOrGetThemeKey('contactLoadedMessage', 'Previously Captured');
			vPopup.create({
				title: consentedContactPopupTitle,
				message: consentedContactPopupMessage
			});
		}
	}
	else if (contact.status == 'UNSUBSCRIBED') {
		// unsubscribed contact selected popup
		if (atheneumInstance.Theme.getBooleanProperty('contactUnsubscribedLoadedAlerts', true)) {
			var unsubscribedPopupTitle = atheneumInstance.Translation.getOrGetThemeKey('contactUnsubscribedLoadedTitle', 'Attention');
			var unsubscribedPopupMessage = atheneumInstance.Translation.getOrGetThemeKey('contactUnsubscribedLoadedMessage', 'This user has previously granted consent but since unsubscribed. The user can re-subscribe if desired');
			vPopup.create({
				title: unsubscribedPopupTitle,
				message: unsubscribedPopupMessage
			});
		}
	}

	if ($('.vpopup-button-ok').length > 0) {
		$('.vpopup-button-ok').attr('tabindex', 0).focus();
		$('.vpopup-button-ok').on('click', function () {
			if ($triggeringFormField && $triggeringFormField.length > 0) {
				$triggeringFormField.focus();
			}
		});
	}

	// update form fields to match contact, and maybe disable them
	var fieldToValueMap = {};
	if (contact.info) {
		fieldToValueMap = contact.info;
	}
	else {
		if (contact.email) {
			fieldToValueMap = { 'to': contact.email, 'email': contact.email }
		}
	}

	var $formFields = $htmlForm.find('input[name], select[name], textarea[name]');
	for (var f = 0; f < $formFields.length; f++) {
		var $field = $formFields.eq(f);
		var fieldName = $field.attr('name');
		if (isFieldReadOnlyWhenContactSelected($htmlForm.find('input[name=id]').val(), fieldName)) {
			$field.attr('readonly', 'readonly');
			$field.addClass('readonly');
			$field.attr('disabled', 'disabled');
		}
		else {
			$field.removeAttr('readonly');
			$field.removeClass('readonly');
			$field.removeAttr('disabled');
		}
	}

	for (var prop in fieldToValueMap) {
		if (!fieldToValueMap.hasOwnProperty(prop)) {
			continue;
		}

		var fieldName = prop;
		var fieldValue = fieldToValueMap[prop];

		var $formFields = $htmlForm.find('input[name="' + fieldName + '"], select[name="' + fieldName + '"], textarea[name="' + fieldName + '"]');

		if ($htmlForm.data('multiple-contacts-possible') && fieldName == 'to' && $triggeringFormField.attr('data-type').toLowerCase() == 'email')
			$formFields = $triggeringFormField;

		for (var f = 0; f < $formFields.length; f++) {
			var $field = $formFields.eq(f);
			if (['CHECKBOX', 'RADIO'].indexOf($field.attr('data-type')) != -1) {
				var desiredPropertyState = (['yes', 'y', 'true', 'on'].indexOf(fieldValue.toLowerCase()) != -1);
				desiredPropertyState = desiredPropertyState || $field.val().toLowerCase() === fieldValue.toLowerCase();
				if(['RADIO'].indexOf($field.attr('data-type')) != -1)
					desiredPropertyState = $field.val().toLowerCase() === fieldValue.toLowerCase();
				
				(function ($field, desiredPropertyState) {
					$field.prop('checked', desiredPropertyState);
					$field.attr('data-field-value-autofilled-by-contact', 'true');
					$field.on('change', function () {
						if ($(this).prop('checked') !== desiredPropertyState) {
							onChangePrefilledContactField($field, $htmlForm);
						}
						else {
							onResetPrefilledContactField($field, $htmlForm);
						}
					});

				})($field, desiredPropertyState);
			}
			else if ($field.attr('data-type') == 'RADIO_MULTI') {
				$field.attr('data-field-value-initially-autofilled-by-contact', 'true');
				var matched = false;
				var fieldValues = fieldValue.split(',');
				for (var v = 0; v < fieldValues.length; v++) {
					var value = fieldValues[v];

					if (value == $field.val()) {
						(function ($field) {
							$field.prop('checked', true);
							$field.attr('data-field-value-autofilled-by-contact', 'true');
							$field.on('change', function () {
								if (!($field.prop('checked'))) {
									onChangePrefilledContactField($field, $htmlForm);
								}
								else {
									onResetPrefilledContactField($field, $htmlForm);
								}
							});
						})($field);
						matched = true;
					}
				}
				if (!matched) {
					(function ($field) {
						$field.prop('checked', false);
						$field.attr('data-field-value-autofilled-by-contact', 'true');
						$field.on('change', function () {
							if ($field.prop('checked')) {
								onChangePrefilledContactField($field, $htmlForm);
							}
							else {
								onResetPrefilledContactField($field, $htmlForm);
							}
						});
					})($field);
				}
			}
			else if ($field.attr('data-type') == 'CONSENT_TYPE') {
				// DO NOTHING
			}
			else {
				$field.attr('data-field-value-initially-autofilled-by-contact', 'true');
				(function ($field, fieldValue) {
					if($field.attr('data-type') == 'COUNTRY')
						fieldValue = fieldValue?.toLowerCase();

					if($field.attr('data-filtered-textfield') != undefined){
						let filteredTextFieldId = $field.data('filtered-textfield');
						let filteredTextField = window[filteredTextFieldId];
						if(filteredTextField){
							filteredTextField.setSelectedItems(fieldValue.split(','));
						}
						else
							$field.val(fieldValue);
					}else if($field.attr('data-type') == 'DATE'){
						let dtStr = fieldValue;
						let dateParts = dtStr.split("/");
						let timeParts = dateParts[2].split(" ")[1].split(":");
						dateParts[2] = dateParts[2].split(" ")[0];
						// month is 0-based, that's why we need dataParts[1] - 1
						let dateTime = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1]);

						if(dateTime != null && dateTime instanceof Date && dateTime.getTime() === dateTime.getTime()){
							$field.val(dateTime.toISOString().slice(0, 16));
						}
					}else{
						$field.val(fieldValue);
					}

					
					$field.attr('data-field-value-autofilled-by-contact', 'true');
					$field.on('input', function () {
						if ($field.val() !== fieldValue) {
							onChangePrefilledContactField($field, $htmlForm);
						}
						else {
							onResetPrefilledContactField($field, $htmlForm);
						}
					});
				})($field, fieldValue);
			}
		}
	}

	if (contact.isConsented()) {
		var $formConsentFields = $htmlForm.find('input[data-type=CONSENT_TYPE]:not(.ignore)');
		for (var f = 0; f < $formConsentFields.length; f++) {
			var $field = $formConsentFields.eq(f);
			if ($field.val() == 'consentRequired') {
				$field.prop('checked', true);
				$field.attr('data-field-value-autofilled-by-contact', 'true');
			}
			else if ($field.val() == 'consentBypassed') {
				$field.prop('checked', false);
				$field.attr('data-field-value-autofilled-by-contact', 'true');
			}
		}
	}

	if (typeof emailInputChanged === 'function')
		emailInputChanged($triggeringFormField, true);

	handleDependencies($htmlForm);

}

/**
 * Returns <code>true</code> if the <code>email</code> matches the valid email regex, <code>false</code> otherwise.
 * @param {String} email
 * @returns {boolean}
 */
function validateEmail(email) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	return re.test(email);
}

function validateEmailList(emailList) {
	var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))([,]\s*(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))*$/;
	return re.test(emailList);
}

function validatePhone(phone){
	var re = /^[0-9\\+\\-\\(\\)\\.\\s#\\*,;x/]*$/
	return re.test(phone);
}

/**
 * Returns a map of { name: value } for the fields in the form.
 * @param {jQuery} $form
 * @param callback 
 * @returns {Object}
 */
function getFormData($form, callback) {

	var formData = {};

	var $fields = $form.find('input:not(.ignore):not(.freeText), select, textarea');

	var fileFields = [];

	for (var f = 0; f < $fields.length; f++) {
		var $field = $($fields[f]);
		var name = $field.attr('name');

		if (name in formData)
			continue;

		var value = null;
		if ($field.data('type') == 'CHECKBOX' || $field.data('type') == 'REMOTE_CONSENT') {
			value = $field.is(':checked');
		} else if ($field.data('type') == 'FILE')
		{
			fileFields.push($field);
        }
		else if ($field.data('type') == 'RADIO' || $field.data('type') == 'CONSENT_TYPE') {
			//CHANGED FOR GLU
			//var $field = $('[name="' + name + '"]:checked');
			var $field = $form.find('[name="' + name + '"]:checked'); //Had to find the field relatively to the form passed as parameter for it to find it in the iframe.
			value = $field.val();
			if ($field.hasClass('hasFreeText')) {
				formData[$field.data('linkedField')] = $('#' + $field.data('linkedField')).val();
			}
		}
		else if ($field.data('type') == 'RADIO_MULTI') {
			//CHANGED FOR GLU
			//var $field = $('[name="' + name + '"]:checked');
			 var $field = $form.find('[name="' + name + '"]:checked');
			value = "";
			$field.each(function () {
				var $option = $(this);
				var optionValue = $option.val();
				if ($option.hasClass('hasFreeText')) {
					formData[$option.data('linkedField')] = $('#' + $option.data('linkedField')).val();
				}
				if (value != "") {
					value += ",";
				}
				value += optionValue;
			})
		}
		else if ($field.data('type') == 'DATE') {
			let dateTime = $field.val();
			dateTime = new Date(dateTime);
			value = formatDateTime(dateTime);
        }else if($field.attr('data-filtered-textfield') != undefined){
			let filteredTextFieldId = $field.data('filtered-textfield');
			let filteredTextField = window[filteredTextFieldId];
			if(filteredTextField){
				value = filteredTextField.selectedItems.toString();
			}
			else
				value = $field.val();
		}
		else {
			value = $field.val();
		}

		formData[name] = value;
	}

	if (fileFields.length == 0)
	{
		if (callback)
			callback(formData);
		else
			return formData;
    }
	else {
		window.fieldCompletedCount = 0;
		window.fieldTotalCount = fileFields.length;

		for (var i = 0; i < fileFields.length; i++) {
			$fileField = fileFields[i];
			if ($fileField && $fileField[0] && $fileField[0].files && $fileField[0].files.length > 0 && window.FileReader) {

				if($fileField[0].files.length > 1){
					fieldTotalCount -= 1;
					fieldTotalCount += $fileField[0].files.length;
				}
				
				for(let j = 0; j < $fileField[0].files.length; j++){
					readFile(j, $fileField, formData, callback);					
				}
				
			} else {
				var name = $fileField.attr('name');

				formData[name] = null;
				fieldCompletedCount++;

				if (fieldCompletedCount >= fieldTotalCount) {
					if (callback)
						callback(formData);
				}
            }
		}

    }
}

function readFile(j, $fileField, formData, callback){
	var fr = new FileReader();

	fr.onloadend = function (e) {
		var name = $fileField.attr('name');
		if(j > 0){
			name+=j;
		}
		formData[name] = e.target.result;
		fieldCompletedCount++;

		if (fieldCompletedCount >= fieldTotalCount) {
			if (callback)
				callback(formData);
		}
	}

	$fileField[0].files[j]
	fr.readAsDataURL($fileField[0].files[j]);
}

function setFormData($form, formData) {

	var $fields = $form.find('input:not(.ignore):not(.freeText), select, textarea');

	var fileFields = [];

	for (var f = 0; f < $fields.length; f++) {
		var $field = $($fields[f]);
		var name = $field.attr('name');

		if (!(name in formData))
			continue;

		var value = null;
		if ($field.data('type') == 'CHECKBOX' || $field.data('type') == 'REMOTE_CONSENT') {
			$field.prop('checked', Atheneum.Theme.TRUE_VALUES.contains(formData[name]) || formData[name] === true);
		} else if ($field.data('type') == 'FILE') {
			fileFields.push($field);
		}
		else if ($field.data('type') == 'RADIO' || $field.data('type') == 'CONSENT_TYPE') {
			var $field = $('[name="' + name + '"][value="' + formData[name] + '"]');
			if ($field.hasClass('hasFreeText')) {
				$('#' + $field.data('linkedField')).val(formData[$field.data('linkedField')]);
			} else {
				$field.prop('checked', true);
            }
		}
		else if ($field.data('type') == 'RADIO_MULTI') {
			var $field = $('[name="' + name + '"]');
			
			$field.each(function () {
				var $option = $(this);
				var optionValue = $option.val();
				if ($option.hasClass('hasFreeText')) {
					$('#' + $option.data('linkedField')).val(formData[$option.data('linkedField')]);
				}

				if (formData[name] && formData[name].indexOf(optionValue) >= 0){
					$option.attr('selected', true);
					$option.attr('checked', true);
				}
				
			})
		}
		else if ($field.data('type') == 'DATE') {
			let dtStr = formData[name];
			let dateParts = dtStr.split("/");
			let timeParts = dateParts[2].split(" ")[1].split(":");
			dateParts[2] = dateParts[2].split(" ")[0];
			// month is 0-based, that's why we need dataParts[1] - 1
			let dateTime = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0], timeParts[0], timeParts[1]);

			$field.val(dateTime.toISOString().slice(0, 16));
		}
		else {
			$field.val(formData[name]);
		}
	}

	//TODO file fields
}



function preloadImage(url) {

	var url = atheneumInstance.Proxy.rewriteURL(url); 

	if (globalImageBuffer[url] == undefined) {
		var img = new Image();
		img.src = url;
		globalImageBuffer[url] = img;
		var imgCache = document.querySelector('body > .image-cache');
		if (imgCache == null) {
			imgCache = document.createElement('DIV');
			imgCache.setAttribute('class', 'image-cache');
			imgCache.style.opacity = '0.00001';
			imgCache.style.position = 'absolute';
			imgCache.style.pointerEvents = 'none';
			imgCache.style.top = '0';
			imgCache.style.width = '100px';
			imgCache.style.height = '100px';
			imgCache.style.overflow = 'hidden';
			document.body.appendChild(imgCache);
		}
		img.style.opacity = '0.00001';
		img.style.position = 'absolute';
		img.style.pointerEvents = 'none';
		img.style.top = '0';
		imgCache.appendChild(img);
	}

}

// preload the checkbox images to avoid flicker, and the image not loading if connectivity is lost
preloadImage('img/radio_button_off.png');
preloadImage('img/radio_button_on.png');


function loadContactsIfNecessaryThenDoInitialActionIfLoggedIn() {

	var autoLoadContacts = atheneumInstance.Theme.getBooleanProperty('autoLoadContacts', true);
	if (atheneumInstance.Proxy.enabled) {
		autoLoadContacts = atheneumInstance.Theme.getBooleanProperty('autoLoadContactsWhenStandalone', true);
	}

	if (autoLoadContacts) {
		requestedContacts = true;
		updateWhenContactsReady({
			success: function () {
				if (requestedContacts) {
					contactsLoaded = true;
				}
				if (!(atheneumInstance.Proxy.enabled && atheneumInstance.Theme.getBooleanProperty('skipWaitingForContactsWhenOnline', false))) {
					if ($('#syncInfo').is(':visible')) {
						$('#progressbar').progressbar({
							value: 100
						});
						setTimeout(function () {
							$('#syncInfo').hide();
							initialActionIfLoggedIn();
						}, 250);
					}
					else {
						initialActionIfLoggedIn();
					}
				}
			},
			progress: function (progress) {
				if (!(atheneumInstance.Proxy.enabled && atheneumInstance.Theme.getBooleanProperty('skipWaitingForContactsWhenOnline', false))
					&& (progress.percentage < 34 || $('#syncInfo').is(':visible'))) {
					showSyncProgressBar(progress.percentage, atheneumInstance.Translation.getOrGetThemeKey('loadingContacts', 'Loading Contacts'));
				}
			},
			failure: function (reason, httpStatus, errorCode) {
				Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.Contacts.update');
				initialActionIfLoggedIn();
				$('#syncInfo').hide();
			}
		});
		if (atheneumInstance.Theme.getBooleanProperty('skipWaitingForContactsWhenOnline', false)) {
			$('#syncInfo').hide();
			initialActionIfLoggedIn();
		}
	}
	else {
		$('#syncInfo').hide();
		initialActionIfLoggedIn();
	}
}

function uuid() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
		var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
		return v.toString(16);
	});
}

function hideSuggestionListForField($field) {
	if ($field.attr('data-suggestion-list-id')) {
		//CHANGED FOR GLU
		if(window.location.href.indexOf("viewAsset") >= 0 || window.self !== window.top){
			$field.closest('#form-holder').find('#' + $field.attr('data-suggestion-list-id')).parent().remove();
			$field.removeAttr('data-suggestion-list-id')
		}else{
			$('#' + $field.attr('data-suggestion-list-id')).parent().remove();
		}
	}
}

async function showSuggestionListForField($field, suggestions, suggestionHeader) {

	if (!suggestions || (suggestions.length == 0 && !suggestionHeader)) {
		hideSuggestionListForField($field);
		return;
	}

	var suggestionListId;
	if ($field.attr('data-suggestion-list-id')) {
		suggestionListId = $field.attr('data-suggestion-list-id');
	}
	else {
		suggestionListId = 'suggestion-' + uuid();
		$field.attr('data-suggestion-list-id', suggestionListId);
	}

	var $suggestionLists = $('.suggestion-list');
	$suggestionLists.not('#' + suggestionListId).parent().remove();

	var $suggestionList = $('#' + suggestionListId);
	var $suggestionListWrapper = $('.suggestion-wrapper');
	
	let contactInfoMode = atheneumInstance.Theme.getBooleanProperty('showSuggestionsWithContactInfo', false)? "contactInfoMode" : "";

	if($suggestionListWrapper.length == 0){
		$suggestionListWrapper = $('<div class="suggestion-wrapper '+contactInfoMode+'"></div>');
		$field.after($suggestionListWrapper);
	}

	if ($suggestionList.length == 0) {
		$suggestionList = $('<div id="' + suggestionListId + '" class="suggestion-list"></div>')
		$suggestionListWrapper.append($suggestionList);
	}

	$suggestionList.html('');

	if($suggestionListWrapper.find('.suggestion-list-close').length == 0 && atheneumInstance.Theme.getBooleanProperty('showSuggestionListClose', false)){
		$suggestionListWrapper.prepend('<div onclick="hideAllSuggestionLists()" class="suggestion-list-close">' + atheneumInstance.Translation.get('suggestionListClose', '[Click here to close ⓧ]') + '</div>');
	}

	if (atheneumInstance.Contacts.caching) {
		var bgColour = colourString(atheneumInstance.Theme.getColourProperty('contactsCachingHeaderBackground', 'FF0000'));
		var textColour = colourString(atheneumInstance.Theme.getColourProperty('contactsCachingHeaderTextColor', 'ffffff'));
		$suggestionList.before('<div id="contacts-caching-header" style="background-color: ' + bgColour + '; color:' + textColour + ';" class="suggestion-list-header">' + atheneumInstance.Translation.get("cachingContactsHeader", "Contacts are currently being downloaded, the full list may not be available yet") + '</div>');
	} else {
		$('#contacts-caching-header').remove();
    }

	if (suggestionHeader) {
		$suggestionListWrapper.find('.suggestion-list-header').remove();
		$suggestionList.before('<div class="suggestion-list-header">' + suggestionHeader + '</div>');
	}

	if(atheneumInstance.Theme.getBooleanProperty('showConsentKeyIfNeeded', false) && suggestions.some(x=> x.hasOwnProperty('displayConsentStatusInSuggestions') && x.displayConsentStatusInSuggestions == true)){
		$suggestionListWrapper.find('.suggestion-list-consent-key').remove();
		$suggestionList.before('<div class="suggestion-list-consent-key"><div class="consent-group"><div class="consent-circle SUBSCRIBED"></div><span>'+SalesToolkit.Translation.get('consentKeySubscribed', 'Subscribed')+'</span></div><div class="consent-group"><div class="consent-circle UNSUBSCRIBED"></div><span>'+SalesToolkit.Translation.get('consentKeyUnsubscribed', 'Unsubscribed')+'</span></div><div class="consent-group"><div class="consent-circle PENDING"></div><span>'+SalesToolkit.Translation.get('consentKeyPending', 'Pending')+'</span></div></div>');
	}

	for (var s = 0; s < suggestions.length; s++) {
		let suggestion = suggestions[s];
		if (typeof suggestion === 'string') {
			suggestion = { text: suggestion, value: suggestion, contact: null };
		}

		let contact = suggestion.contact;
		if(suggestion.hasOwnProperty('fullContact'))
			contact = suggestion.fullContact;
		else if(contact)
			contact = await atheneumInstance.Contacts.getById(contact);
		else
			contact = undefined;

		if(contact && atheneumInstance.Theme.getBooleanProperty('showSuggestionsWithContactInfo', false)){
			
			var contactName = '';
			if (contact.info && contact.info['firstName'] && contact.info['lastName']) {
				contactName = contact.info['firstName'] + ' ' + contact.info['lastName'];
				lastNameOffset = contact.info['firstName'].length + 1;
			}
			else if (contact.info && (contact.info['name'] || contact.info['fullName'])) {
				contactName = contact.info['name'] || contact.info['fullName'];
				contactName = contactName.indexOf(' ') == -1 ? -1 : contactName.indexOf(' ') + 1;
			}
			else if (contact.info && contact.info['lastName']) {
				lastNameOffset = 0;
				contactName = contact.info['lastName'];
			}
			else if (contact.info && contact.info['firstName']) {
				contactName = contact.info['firstName'];
			}

			let event = "onmousedown";
			let event2 = "onmouseup";
			if (SalesToolkit.CrossPlatform.enabled) {
				event = "ontouchstart";
				event2 = "ontouchend";
			}

			let $suggestion = $('<div tabindex="0" ' + event + '="onSuggestionsMouseDown();" ' + event2 +'="onSuggestionsMouseUp();"   onclick="onSuggestionClick(this)"  class="suggestion info-suggestion" data-suggestion-value="' + suggestion.value + '"'
			+ (suggestion.contact ? (' data-suggestion-contact="' + suggestion.contact + '"') : '') + '>'
			+ (suggestion.displaySubmissionStatusInSuggestions ? '<span class="suggestionListSubmissionsCount ' + suggestion.trafficLightClass + '">' + suggestion.formSubmissionCount + '</span>' : '')
			+ (suggestion.displayConsentStatusInSuggestions ? '<span class="suggestionlistConsentStatusCircle ' + suggestion.consentStatus + '"></span>' : '')
			+ '<span class="suggestionListText">' + suggestion.text + '</span>'
			+ '<div class="contact-info">'
			+ '<div class="contact-info-group">'+contactName+'</div>'
			+ '</div>'
			+ '</div>');

			$suggestionList.append($suggestion);
			
			let $contactInfo = $suggestion.find('.contact-info');
			let contactInfoItems = atheneumInstance.Theme.getStringProperty('contactSuggestionsInfoItems', 'email');
			contactInfoItems = contactInfoItems.split(',');
			
			let breakAtAt = atheneumInstance.Theme.getBooleanProperty('shouldBreakSuggestionsAtAt', true);
			let breakAtFullStops = atheneumInstance.Theme.getBooleanProperty('shouldBreakSuggestionsAtFullStops', true);
			
			for(let i=0; i<contactInfoItems.length; i++){
				if(!contact.hasOwnProperty('info'))
					break;

				let item = contactInfoItems[i];
				if(!contact.info.hasOwnProperty(item))
					continue;

				let itemLabel = atheneumInstance.Translation.get('contactSuggestionInfoItem_'+item, item.charAt(0).toUpperCase() + item.slice(1) + ':');
				let itemValue = contact.info[item];

				if(typeof itemValue !== 'string' || itemValue.length == 0)
					continue;

				if (breakAtAt && itemValue.contains('@')) {
					let parts = itemValue.split('@');
					if (parts && parts.length == 2)
						itemValue = parts[0] + '<wbr>@<wbr>' + parts[1];
				}
				if(breakAtFullStops){
					itemValue = itemValue.replaceAll('.', '<wbr>.<wbr>');
				}
				
				$contactInfo.append('<div class="contact-info-group"><span><b>'+itemLabel+'</b> '+itemValue+'</span></div>')
			}
		}else{
			let event = "onmousedown";
			let event2 = "onmouseup";
			if(SalesToolkit.CrossPlatform.enabled){
				event = "ontouchstart";
				event2 = "ontouchend";
			}
			
			$suggestionList.append('<div tabindex="0" ' + event + '="onSuggestionsMouseDown();" ' + event2 +'="onSuggestionsMouseUp();"   onclick="onSuggestionClick(this)" class="suggestion" data-suggestion-value="' + suggestion.value + '"'
			+ (suggestion.contact ? (' data-suggestion-contact="' + suggestion.contact + '"') : '') + '>'
			+ (suggestion.displaySubmissionStatusInSuggestions ? '<span class="suggestionListSubmissionsCount ' + suggestion.trafficLightClass + '">' + suggestion.formSubmissionCount + '</span>' : '')
			+ (suggestion.displayConsentStatusInSuggestions ? '<span class="suggestionlistConsentStatus ' + suggestion.consentStatus + '">'+suggestion.consentStatus+'</span>' : '')
			+ '<span class="suggestionListText">' + suggestion.text + '</span>'
			+ '</div>');
		}
		
		var $newSuggestion = $suggestionList.find('.suggestion:last-child');
		$newSuggestion.on('keydown', function (event) {
			if (event.which == 38 /* up */) {
				if ($(this).prev().length == 0) {
					$field.focus();
				}
				else {
					$(this).prev().focus();
				}
				event.preventDefault();
			}
			else if (event.which == 40 /* down */) {
				if ($(this).next().length == 0) {
					$field.focus();
				}
				else {
					$(this).next().focus();
				}
				event.preventDefault();
			}
			else if (event.which == 13 /* enter */) {
				event.preventDefault();
				$(this).click();
			}
			else if (event.which == 27 /* escape */) {
				hideSuggestionListForField($field);
				$field.focus();
			}
		});
	}
}


function onDocumentClickWhileSuggestionActive(event) {
	var suggestionList = $('.suggestion-list');
	if (suggestionList.length > 0) {
		var suggestionListId = suggestionList.eq(0).attr('id');
		if (suggestionListId) {
			var $field = $('[data-suggestion-list-id="' + suggestionListId + '"]');
			if (event.target != $field[0]) {
				hideSuggestionListForField($field);
			}
		}
	}
}

function hideAllSuggestionLists() {
	//CHANGED FOR GLU
	//var suggestionLists = $('.suggestion-list');
	var formElement = $('#form-holder');
	if (formElement.length == 0) {
		formElement = $(window.$formElement);
	}

	if (formElement.length == 0) {
		formElement = $(iframeFormElement);
	}
	var suggestionLists = formElement.find('.suggestion-list');
	if (suggestionLists.length > 0) {
		for (var i = 0; i < suggestionLists.length; i++) {
			let suggestionList = $(suggestionLists[i]);
			let suggestionListId = suggestionList.attr('id');
			if (suggestionListId) {
				var $field = formElement.find('[data-suggestion-list-id="' + suggestionListId + '"]');
				hideSuggestionListForField($field);
			}
        }
	}


	hideAllSuggestionsForMeetingAttendees();
	
}

function hideAllSuggestionsForMeetingAttendees() {
	//var suggestionLists = $('.suggestion-list');
	var formElement = $('#addAttendeeForm');
	if (formElement.length == 0) {
		formElement = $(window.$formElement);
	}

	if (formElement.length == 0) {
		formElement = $(iframeFormElement);
	}

	var suggestionLists = formElement.find('.suggestion-list');
	if (suggestionLists.length > 0) {
		for (var i = 0; i < suggestionLists.length; i++) {
			let suggestionList = $(suggestionLists[i]);
			let suggestionListId = suggestionList.attr('id');
			if (suggestionListId) {
				var $field = formElement.find('[data-suggestion-list-id="' + suggestionListId + '"]');
				hideSuggestionListForField($field);
			}
		}
	}
}

$(document).on('click', onDocumentClickWhileSuggestionActive);

function onSuggestionsMouseDown() {
	window.populatingFromSuggestion = true;
}

function onSuggestionsMouseUp() {
	setTimeout(function () {
		window.populatingFromSuggestion = false;
	}, 2000);
}

async function onSuggestionClick(suggestion) {
	
	var suggestionListId = $(suggestion).parents('.suggestion-list').eq(0).attr('id');
	var $field = $('[data-suggestion-list-id="' + suggestionListId + '"]');
	var $form = $field.parents().filter('form').eq(0);
	var contactId = $(suggestion).attr('data-suggestion-contact');
	if (contactId) {
		let contact = await atheneumInstance.Contacts.getById(contactId);
		if (contact instanceof Array) {
			contact = contact[0];
		}
		if (contact) {

			if(contact.hasOwnProperty('info') && contact.info.hasOwnProperty('mdmId') && SalesToolkit.Theme.getBooleanProperty('useGSKContacts', false)){
				
				SalesToolkit.UI.Notifications.showCustomNotification("info", atheneumInstance.Translation.getOrGetThemeKey('updatingExternalContactInfo', 'Getting latest contact information'));

				window.formAPICallInProgress = true;

				SalesToolkit.API.searchGSKContactDetails(contact.info.mdmId, {
					success: function(json){
						
						if(json.hasOwnProperty('account')){
                               
                            for (var key in json.account) {
                                if (json.account.hasOwnProperty(key) && typeof json.account[key] !== 'undefined') {
                                    contact.info[key] = json.account[key];
                                }
                            }
                        }

						hideSuggestionListForField($field);
						onFormContactSelect($form, contact, $field);
						window.formAPICallInProgress = false;
						if (SalesToolkit.Theme.getBooleanProperty('allowDelayedSubmits', false) && typeof window.pendingSubmit == 'function') {
							window.pendingSubmit();
						}
					},
					failure: function(reason, httpStatus, errorCode){
						hideSuggestionListForField($field);
						onFormContactSelect($form, contact, $field);
						window.formAPICallInProgress = false;
						if (SalesToolkit.Theme.getBooleanProperty('allowDelayedSubmits', false) && typeof window.pendingSubmit == 'function') {
							window.pendingSubmit();
						}
					}
				});

				return;
			}

			if (contact.hasOwnProperty('info') && (contact.info.hasOwnProperty('crmId') || contact.info.hasOwnProperty('externalId')) && SalesToolkit.Theme.getBooleanProperty('useVeevaContacts', false)){

				let extId = contact.info.hasOwnProperty("crmId") ? contact.info['crmId'] : contact.info['externalId'];

				SalesToolkit.UI.Notifications.showCustomNotification("info", atheneumInstance.Translation.getOrGetThemeKey('updatingExternalContactInfo', 'Getting latest contact information'));

				window.formAPICallInProgress = true;

				SalesToolkit.API.searchVeevaContactDetails(extId, {
					success: function(json){
						
						if(json.hasOwnProperty('account')){
                               
                            for (var key in json.account) {
                                if (json.account.hasOwnProperty(key) && typeof json.account[key] !== 'undefined') {
                                    contact.info[key] = json.account[key];
                                }
                            }
                        }

						hideSuggestionListForField($field);
						onFormContactSelect($form, contact, $field);
						window.formAPICallInProgress = false;
						if (SalesToolkit.Theme.getBooleanProperty('allowDelayedSubmits', false) && typeof window.pendingSubmit == 'function') {
							window.pendingSubmit();
						}
					},
					failure: function(reason, httpStatus, errorCode){
						hideSuggestionListForField($field);
						onFormContactSelect($form, contact, $field);
						window.formAPICallInProgress = false;
						if (SalesToolkit.Theme.getBooleanProperty('allowDelayedSubmits', false) && typeof window.pendingSubmit == 'function') {
							window.pendingSubmit();
						}
					}
				});

				return;
			}

			hideSuggestionListForField($field);
			onFormContactSelect($form, contact, $field);
		}
	}
	else {
		$field.val($(suggestion).attr('data-suggestion-value'));
		hideSuggestionListForField($field);
		handleDependencies($form);
	}

	window.populatingFromSuggestion = false;
}

function addContactSuggestionsToFormField($form, $field) {

	var autoLoadContacts = atheneumInstance.Theme.getBooleanProperty('autoLoadContacts', true);
	if (atheneumInstance.Proxy.enabled) {
		autoLoadContacts = atheneumInstance.Theme.getBooleanProperty('autoLoadContactsWhenStandalone', true);
	}

	if(typeof $form.displayContactSuggestions === 'undefined')
		$form.displayContactSuggestions = SalesToolkit.Theme.getBooleanProperty('displayContactSuggestionsDefault', true);

	if(typeof $form.displayConsentStatusInSuggestions === 'undefined')
		$form.displayConsentStatusInSuggestions = SalesToolkit.Theme.getBooleanProperty('displayConsentStatusInSuggestionsDefault', true);
	
	if(typeof $form.displaySubmissionStatusInSuggestions === 'undefined')
		$form.displaySubmissionStatusInSuggestions = SalesToolkit.Theme.getBooleanProperty('displaySubmissionStatusInSuggestionsDefault', false);
		
	if (!atheneumInstance.Theme.getBooleanProperty('showFormContactSuggestions', true) || !$form.displayContactSuggestions) {
		// contact suggestions are disabled - do nothing
		 // Add  return = tab anyway
		$field.on('keypress',function(e) {
			if(e.which == 13) {
				var tabables = $("*[tabindex != '-1']:visible");
				var index = tabables.index(this);
				index = index + 1;
				while(tabables.length > index){
					if(tabables.eq(index).is('input') || tabables.eq(index).is('textarea'))
					{
						tabables.eq(index).focus();
						break;
					}else if( tabables.eq(index).find('input').length > 0){
						tabables.eq(index).find('input').focus();
						 break;
					}

					index = index + 1;
				}
				
				hideAllSuggestionLists();
			}
		});
		return;
	}
	else if (!requestedContacts && autoLoadContacts) {
		requestedContacts = true;
		updateWhenContactsReady({
			success: function () {
				if (requestedContacts) {
					contactsLoaded = true;
				}
			}
		});
	}

	// TODO - CONFIRM fields
	var fieldIsSuitableForSuggestions = [
		'TEXT', 'TEXTBOX', 'EMAIL', 'NUMBER',
		'PHONE', 'NIF_NIE', 'BADGE'].indexOf($field.attr('data-type')) != -1;

	let fieldsToIgnoreforSuggestions = atheneumInstance.Theme.getStringProperty('fieldsToIgnoreforSuggestions', '');
	fieldsToIgnoreforSuggestions = fieldsToIgnoreforSuggestions.split(',');
	if(fieldsToIgnoreforSuggestions.contains($field.attr('name'))){
		fieldIsSuitableForSuggestions = false;
	}

	if($field.attr('data-type') !== 'TEXTBOX'){
		$field.on('keypress',function(e) {
			if(e.which == 13) {
				var tabables = $("*[tabindex != '-1']:visible");
				var index = tabables.index(this);
				index = index + 1;
				while(tabables.length > index){
					if(tabables.eq(index).is('input') || tabables.eq(index).is('textarea'))
					{
						tabables.eq(index).focus();
						break;
					}else if( tabables.eq(index).find('input').length > 0){
						tabables.eq(index).find('input').focus();
						 break;
					}
	
					index = index + 1;
				}
				
				hideAllSuggestionLists();
			}
		});
	
	}
	
	if (fieldIsSuitableForSuggestions) {
		$field.on('keydown', function (event) {
			if (event.which == 40 /* down */) {
				if ($field.attr('data-suggestion-list-id')) {
					var $list = $('#' + $field.attr('data-suggestion-list-id'));
					var $firstSuggestionInList = $list.find('.suggestion').eq(0);
					if ($firstSuggestionInList.length > 0) {
						$firstSuggestionInList.focus();
					}
				}
				event.preventDefault();
			}
			if (event.which == 9 /* tab */) {
				hideSuggestionListForField($field);
			}
		});

		if(atheneumInstance.CrossPlatform.enabled && atheneumInstance.CrossPlatform.isAndroid()){
			$field.on('blur', function(e){

				if (suggestionsTimeout) {
					window.clearTimeout(suggestionsTimeout);
				}

				setTimeout(function () {
					hideAllSuggestionLists();
				}, 200);
			});
		}else{
			$field.on('blur', function(e){
				if (suggestionsTimeout) {
					window.clearTimeout(suggestionsTimeout);
				}
			});
			
		}

		var suggestionsTimeout = undefined;
		var executeSuggestionsDelayInMilliseconds = atheneumInstance.Theme.getIntegerProperty('delayOnSuggestionsTyping', 400);

		function executeSuggestionsAfterShortDelay($field) {
			if (suggestionsTimeout) {
			  window.clearTimeout(suggestionsTimeout);
			}
			
			suggestionsTimeout = window.setTimeout(executeSuggestionsForField, executeSuggestionsDelayInMilliseconds, $field);
		  }

		async function executeSuggestionsForField($field){
			var fieldName = $field.attr('name');
			var searchTerm = $field.val();
			
			var formId = $('input[name="hidden-form-id"]').val();
			// ADDED FOR GLU
			if (formId === undefined && typeof iframeFormId !== 'undefined') {
				formId = iframeFormId;

			}

			var $form = $field.parents('form');
			if(typeof form === 'undefined')
				var form = {};
			var formObj = SalesToolkit.Forms.formList[formId] || form;

			$form.displayContactSuggestions = formObj.displayContactSuggestions;
			$form.displayConsentStatusInSuggestions = formObj.displayConsentStatusInSuggestions;
			$form.displaySubmissionStatusInSuggestions = formObj.displaySubmissionStatusInSuggestions;

			if (formObj == undefined || formObj == null)
				return false;

			if (window.location.href.indexOf('cart') >= 0 || (window.location.href.indexOf('index.html') >= 0 && !document.body.classList.contains('module-cart'))){
				$form.data('assetIds', atheneumInstance.Cart.assetIds);
				if(!$form.displayContactSuggestions)
					$form.displayContactSuggestions = SalesToolkit.Theme.getBooleanProperty('displayContactSuggestionsCartOverride', false);
		
				if(!$form.displayConsentStatusInSuggestions)
					$form.displayConsentStatusInSuggestions = SalesToolkit.Theme.getBooleanProperty('displayConsentStatusInSuggestionsCartOverride', false);
				
				if(!$form.displaySubmissionStatusInSuggestions)
					$form.displaySubmissionStatusInSuggestions = SalesToolkit.Theme.getBooleanProperty('displaySubmissionStatusInSuggestionsCartOverride', false);
			}

			// TODO - perhaps there should be some way to blacklist fields from suggestions?
			var contactAlreadySelected = ($form.find('input[name="CONTACT_ID"]').val() != '');
			if (contactAlreadySelected && !atheneumInstance.Theme.getBooleanProperty('showContactSuggestionsEvenWhenContactIsSelected', false)) {
				return;
			}
			await atheneumInstance.Contacts.getByFieldValueAsync(fieldName, searchTerm, true, atheneumInstance.Theme.getIntegerProperty('contactSuggestionListMaxLength', 100), {

				success: async function (contacts) {
					let TRUE_VALUES = ['on', 'true', 'y', 'yes', true]
					if(Array.isArray(contacts) && !TRUE_VALUES.contains(SalesToolkit.User.test)){
						contacts = contacts.filter(x=> !x.hasOwnProperty('test')  || !x.test)
					}
					
					// request the N most relevant contacts from the server (default 10)
					// sort alphabetically

					// TODO - perhaps check most recently used contacts, and put them on top of list?

					// if the field is empty, show nothing
					if ($field.val() == '') {
						hideSuggestionListForField($field);
						return;
					}

					var showContactSearchResultHeader = atheneumInstance.Theme.getBooleanProperty('contactSuggestionListHeaderEnabled', true);
					var contactSearchResultTextFormat;
					if (atheneumInstance.Theme.getIntegerProperty('contactSuggestionListMaxLength', 100) <= 0) {
						contactSearchResultTextFormat = atheneumInstance.Translation.getOrGetThemeKey('contactSuggestionListHeaderUnlimitedTextFormat', 'Showing {$matches} matching contacts of {$total}');
					}
					else {
						contactSearchResultTextFormat = atheneumInstance.Translation.getOrGetThemeKey('contactSuggestionListHeaderTextFormat', 'Showing {$matches} matching contacts (max {$limit}) of {$total}');
					}

					var contactSearchResultNoMatch = atheneumInstance.Translation.getOrGetThemeKey('contactSuggestionListHeaderTextNoMatches', 'No contacts matched your search');


					var matchesParam = (contacts.length || 0) + '';
					var totalParam = (atheneumInstance.Contacts.totalContacts || 0) + '';
					var limitParam = atheneumInstance.Theme.getIntegerProperty('contactSuggestionListMaxLength', 100);
					if (limitParam <= 0) {
						limitParam = 'âˆž';
					}
					
					var suggestionTextFormat = atheneumInstance.Theme.getStringProperty('suggestionTextFormat',
						'{if (name)}{name} ({endif}{email}{if (name)}){endif}');

					
					var suggestions = [];
					for (var c = 0; c < contacts.length; c++) {
						var contact = contacts[c];
	
						let ignoreFields = ['firstName', 'name', 'lastName', 'fullName', 'email', 'to'];
						if(contact.info.hasOwnProperty(fieldName) && ignoreFields.indexOf(fieldName) < 0){
							suggestionTextFormat = atheneumInstance.Theme.getStringProperty('suggestionTextFormatForNonIgnoreFields',
							'{$field} - {if (name)}{name} ({endif}{email}{if (name)}){endif}');
						}else{
							suggestionTextFormat = atheneumInstance.Theme.getStringProperty('suggestionTextFormat',
							'{if (name)}{name} ({endif}{email}{if (name)}){endif}');
						}
						
						if(SalesToolkit.Theme.getBooleanProperty('filterContactsSuggesstionsWithExistingFormEntries', true)){
							let ignoreContact = false;
							let keys = Object.keys(contact.info);
							let i;
						
							for(i = 0; i<keys.length; i++){
								
								let key = keys[i];
								if(!contact.info.hasOwnProperty(key))
									continue;

								if(key == fieldName)
									continue;

								let form = $field.parents('form');
								let field = form.find(
									'input[name="' + key + '"]'
									+ ', select[name="' + key + '"]'
									+ ', textarea[name="' + key + '"]'
								);

								if(field.length == 0)
									continue;
								
								field = field[0];

								if(field.type !== 'text')
									continue;
									
								let val = $(field).val();
								if(val !== undefined && val.length > 0){
									if(contact.info[key].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(val.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()) < 0)
									{
										matchesParam = parseInt(matchesParam) - 1 + ""
										ignoreContact = true;
										break;
									}
								}
							}

							if(ignoreContact)
								continue;
						}

						var lastNameOffset = -1;

						var contactName = '';
						if (contact.info && contact.info['firstName'] && contact.info['lastName']) {
							contactName = contact.info['firstName'] + ' ' + contact.info['lastName'];
							lastNameOffset = contact.info['firstName'].length + 1;
						}
						else if (contact.info && (contact.info['name'] || contact.info['fullName'])) {
							contactName = contact.info['name'] || contact.info['fullName'];
							contactName = contactName.indexOf(' ') == -1 ? -1 : contactName.indexOf(' ') + 1;
						}
						else if (contact.info && contact.info['lastName']) {
							lastNameOffset = 0;
							contactName = contact.info['lastName'];
						}
						else if (contact.info && contact.info['firstName']) {
							contactName = contact.info['firstName'];
						}

						var contactText = suggestionTextFormat;

						var flowRegex = /\{\s*if\s*\(\s*([a-zA-Z]+)\s*\)\s*\}(.*?)(?:\{\s*else\s*\}(.*?))?\{\s*end\s?if\s*\}/g;

						contactText = contactText.replace(flowRegex, function (fullMatch, condition, ifTrue, ifFalse) {
							var conditionValue = '';
							if (condition == 'id') {
								conditionValue = contact.id;
							}
							else if (condition == 'name' || condition == 'fullName') {
								conditionValue = contactName;
							}
							else if (condition == 'email' || condition == 'to') {
								conditionValue = contact.email;
							}
							else {
								conditionValue = contact.info[condition];
							}
							if (conditionValue) {
								return ifTrue || '';
							}
							else {
								return ifFalse || '';
							}
						});

						if (contactName == '' && contact.email) {
							contactName = contact.email;
						}

						if (contactName == '') {
							contactName = '[Contact ' + contact.id + ']';
						}
						var searchTermRegex = new RegExp(searchTerm.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'ig');

						contactText = contactText.replace(/\{\s*((?:(?:\$field)|(?:\$search)|[a-zA-Z]+))\s*\}/g, function (fullMatch, property) {
							var propValue = '';

							if (property == '$search') {
								propValue = propValue;
							}
							if (property == '$field') {
								property = fieldName;
							}

							if (property == 'id') {
								propValue = contact.id;
							}
							else if (property == 'name' || property == 'fullName') {
								propValue = contactName;
							}
							else if (property == 'email' || property == 'to') {
								propValue = contact.email;
							}
							else {
								propValue = contact.info[property];
							}


							if (property == fieldName
								|| (property == 'email' && fieldName == 'to')
								|| (property == 'name' && fieldName == 'fullName')
							) {
								propValue = propValue.replace(searchTermRegex, function (match) {
									return '<span class="contact-search-matched-text">' + match + '</span>';
								});
							}
							else if (property == 'name' && fieldName == 'firstName') {
								if (lastNameOffset != -1) {
									var firstNamePart = propValue.substring(0, lastNameOffset);
									var lastNamePart = propValue.substring(lastNameOffset);

									firstNamePart = firstNamePart.replace(searchTermRegex, function (match) {
										return '<span class="contact-search-matched-text">' + match + '</span>';
									});

									propValue = firstNamePart + lastNamePart;
								}
							}
							else if (property == 'name' && fieldName == 'lastName') {
								if (lastNameOffset != -1) {
									var firstNamePart = propValue.substring(0, lastNameOffset);
									var lastNamePart = propValue.substring(lastNameOffset);

									lastNamePart = lastNamePart.replace(searchTermRegex, function (match) {
										return '<span class="contact-search-matched-text">' + match + '</span>';
									});

									propValue = firstNamePart + lastNamePart;
								}
							}
							return propValue || '';
						});

						// let ignoreFields = ['firstName', 'name', 'lastName', 'fullName', 'email', 'to'];
						// if(contact.info.hasOwnProperty(fieldName) && ignoreFields.indexOf(fieldName) < 0){
						// 	contactText = contactText.replace('{currentValue}', contact.info[fieldName]);
						// 	contactText = contactText.replace('{currentValueSeparator', SalesToolkit.Translation.get('currentValueSeparator', ' - '));
						// }else{
						// 	contactText = contactText.replace('{currentValue}', '');
						// 	contactText = contactText.replace('{currentValueSeparator', '');
						// }
						

						var includeOtherFormSubmissionsInCount = $form.attr('data-contact-includeOtherFormSubmissionsInCount');
						var maxSubmissionsPerContact = $form.attr('data-contact-maxSubmissionsPerContact');

						var suggestion = {
							'text': contactText,
							'value': contact.info[$field.attr('name')],
							'contact': contact.id,
							'consentStatus': contact.status,
							'formSubmissionCount': (includeOtherFormSubmissionsInCount == "true" ? (contact.totalFormSubmissions || 0) : ((contact.hasOwnProperty('formSubmissionsCount') && contact.formSubmissionsCount.hasOwnProperty(formId))? contact.formSubmissionsCount[formId] : 0)),
							'trafficLightClass': ($form.displaySubmissionStatusInSuggestions ? getTrafficLightClass((contact.hasOwnProperty('formSubmissionsCount') && contact.formSubmissionsCount.hasOwnProperty(formId)) ? contact.formSubmissionsCount[formId] : 0, maxSubmissionsPerContact, includeOtherFormSubmissionsInCount, (contact.totalFormSubmissions || 0)) : ""),
							'displaySubmissionStatusInSuggestions': $form.displaySubmissionStatusInSuggestions,
							'displayConsentStatusInSuggestions': $form.displayConsentStatusInSuggestions
						};

						if(atheneumInstance.Contacts.contactHelper)
							suggestion.fullContact= contact;

						suggestions.push(suggestion);
					}

					contactSearchResultTextFormat = contactSearchResultTextFormat.replace(/\{\s*(\$matches|\$total|\$limit|\$search|\$field|0|1|2)\s*\}/g, function (fullMatch, text) {
						if (text == '$matches' || text == '0') {
							return matchesParam;
						}
						if (text == '$total' || text == '1') {
							return totalParam;
						}
						if (text == '$limit' || text == '2') {
							return limitParam;
						}
						if (text == '$search') {
							return searchTerm;
						}
						if (text == '$field') {
							return fieldName;
						}
					});
					contactSearchResultNoMatch = contactSearchResultNoMatch.replace(/\{\s*(\$matches|\$total|\$limit|\$search|\$field|0|1|2)\s*\}/g, function (fullMatch, text) {
						if (text == '$matches' || text == '0') {
							return matchesParam;
						}
						if (text == '$total' || text == '1') {
							return totalParam;
						}
						if (text == '$limit' || text == '2') {
							return limitParam;
						}
						if (text == '$search') {
							return searchTerm;
						}
						if (text == '$field') {
							return fieldName;
						}
					});


					var suggestionHeader = contacts.length == 0 ? sanitizeHTML(contactSearchResultNoMatch) : sanitizeHTML(contactSearchResultTextFormat);
					if (!showContactSearchResultHeader || totalParam == '0') {
						suggestionHeader = '';
					}

					suggestions.sort(function (a, b) {
						return (a.text > b.text) ? 1 : ((a.text == b.text) ? 0 : -1);
					});

					await showSuggestionListForField($field, suggestions, suggestionHeader);
				},
				failure: function () {
					hideSuggestionListForField($field);
				},
				offline: function () {
					hideSuggestionListForField($field);
				}
			}, null, null, SalesToolkit.Theme.getBooleanProperty('filterContactsSuggesstionsWithExistingFormEntries', true), formObj, $form);
		}
		  
		$field.on('input', function () {
			if(this.value.length < SalesToolkit.Theme.getIntegerProperty('contactSuggestionsMinLength', 3)){
				hideAllSuggestionLists();
				return;
			}
			executeSuggestionsAfterShortDelay($field);
		});
	}
}

var showContactSuggestions = async function($field, contacts){
	var fieldName = $field.attr('name');
	var searchTerm = $field.val();
	var formId = $('input[name="hidden-form-id"]').val();
	var $form = $field.parents('form');
	var formObj = SalesToolkit.Forms.formList[formId] || form;

	if (formObj == undefined || formObj == null)
		return false;

	let TRUE_VALUES = ['on', 'true', 'y', 'yes', true]
	if(Array.isArray(contacts) && !TRUE_VALUES.contains(SalesToolkit.User.test)){
		contacts = contacts.filter(x=> !x.hasOwnProperty('test')  || !x.test)
	}
	
	$form.displayContactSuggestions = formObj.displayContactSuggestions;
	$form.displayConsentStatusInSuggestions = formObj.displayConsentStatusInSuggestions;
	$form.displaySubmissionStatusInSuggestions = formObj.displaySubmissionStatusInSuggestions;

	
	var showContactSearchResultHeader = atheneumInstance.Theme.getBooleanProperty('contactSuggestionListHeaderEnabled', true);
	var contactSearchResultTextFormat;
	if (atheneumInstance.Theme.getIntegerProperty('contactSuggestionListMaxLength', 100) <= 0) {
		contactSearchResultTextFormat = atheneumInstance.Translation.getOrGetThemeKey('contactSuggestionListHeaderUnlimitedTextFormat', 'Showing {$matches} matching contacts of {$total}');
	}
	else {
		contactSearchResultTextFormat = atheneumInstance.Translation.getOrGetThemeKey('contactSuggestionListHeaderTextFormat', 'Showing {$matches} matching contacts (max {$limit}) of {$total}');
	}

	var contactSearchResultNoMatch = atheneumInstance.Translation.getOrGetThemeKey('contactSuggestionListHeaderTextNoMatches', 'No contacts matched your search');


	var matchesParam = (contacts.length || 0) + '';
	var totalParam = (await atheneumInstance.Contacts.getTotalNumberOfContacts() || 0) + '';
	var limitParam = atheneumInstance.Theme.getIntegerProperty('contactSuggestionListMaxLength', 100);
	if (limitParam <= 0) {
		limitParam = 'âˆž';
	}
	
	var suggestionTextFormat = atheneumInstance.Theme.getStringProperty('suggestionTextFormat',
		'{if (name)}{name} ({endif}{email}{if (name)}){endif}')

	var suggestions = [];
	for (var c = 0; c < contacts.length; c++) {
		var contact = contacts[c];

		var lastNameOffset = -1;

		var contactName = '';
		if (contact.info && contact.info['firstName'] && contact.info['lastName']) {
			contactName = contact.info['firstName'] + ' ' + contact.info['lastName'];
			lastNameOffset = contact.info['firstName'].length + 1;
		}
		else if (contact.info && (contact.info['name'] || contact.info['fullName'])) {
			contactName = contact.info['name'] || contact.info['fullName'];
			contactName = contactName.indexOf(' ') == -1 ? -1 : contactName.indexOf(' ') + 1;
		}
		else if (contact.info && contact.info['lastName']) {
			lastNameOffset = 0;
			contactName = contact.info['lastName'];
		}
		else if (contact.info && contact.info['firstName']) {
			contactName = contact.info['firstName'];
		}

		var contactText = suggestionTextFormat;

		var flowRegex = /\{\s*if\s*\(\s*([a-zA-Z]+)\s*\)\s*\}(.*?)(?:\{\s*else\s*\}(.*?))?\{\s*end\s?if\s*\}/g;

		contactText = contactText.replace(flowRegex, function (fullMatch, condition, ifTrue, ifFalse) {
			var conditionValue = '';
			if (condition == 'id') {
				conditionValue = contact.id;
			}
			else if (condition == 'name' || condition == 'fullName') {
				conditionValue = contactName;
			}
			else if (condition == 'email' || condition == 'to') {
				conditionValue = contact.email;
			}
			else {
				conditionValue = contact.info[condition];
			}
			if (conditionValue) {
				return ifTrue || '';
			}
			else {
				return ifFalse || '';
			}
		});

		if (contactName == '' && contact.email) {
			contactName = contact.email;
		}

		if (contactName == '') {
			contactName = '[Contact ' + contact.id + ']';
		}
		var searchTermRegex = new RegExp(searchTerm.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'ig');

		contactText = contactText.replace(/\{\s*((?:(?:\$field)|(?:\$search)|[a-zA-Z]+))\s*\}/g, function (fullMatch, property) {
			var propValue = '';

			if (property == '$search') {
				propValue = propValue;
			}
			if (property == '$field') {
				property = fieldName;
			}

			if (property == 'id') {
				propValue = contact.id;
			}
			else if (property == 'name' || property == 'fullName') {
				propValue = contactName;
			}
			else if (property == 'email' || property == 'to') {
				propValue = contact.email;
			}
			else {
				propValue = contact.info[property];
			}


			if (property == fieldName
				|| (property == 'email' && fieldName == 'to')
				|| (property == 'name' && fieldName == 'fullName')
			) {
				propValue = propValue.replace(searchTermRegex, function (match) {
					return '<span class="contact-search-matched-text">' + match + '</span>';
				});
			}
			else if (property == 'name' && fieldName == 'firstName') {
				if (lastNameOffset != -1) {
					var firstNamePart = propValue.substring(0, lastNameOffset);
					var lastNamePart = propValue.substring(lastNameOffset);

					firstNamePart = firstNamePart.replace(searchTermRegex, function (match) {
						return '<span class="contact-search-matched-text">' + match + '</span>';
					});

					propValue = firstNamePart + lastNamePart;
				}
			}
			else if (property == 'name' && fieldName == 'lastName') {
				if (lastNameOffset != -1) {
					var firstNamePart = propValue.substring(0, lastNameOffset);
					var lastNamePart = propValue.substring(lastNameOffset);

					lastNamePart = lastNamePart.replace(searchTermRegex, function (match) {
						return '<span class="contact-search-matched-text">' + match + '</span>';
					});

					propValue = firstNamePart + lastNamePart;
				}
			}
			return propValue || '';
		});

		var includeOtherFormSubmissionsInCount = $form.attr('data-contact-includeOtherFormSubmissionsInCount');
		var maxSubmissionsPerContact = $form.attr('data-contact-maxSubmissionsPerContact');

		var suggestion = {
			'text': contactText,
			'value': contact.info[$field.attr('name')],
			'contact': contact.id,
			'consentStatus': contact.status,
			'formSubmissionCount': (includeOtherFormSubmissionsInCount == "true" ? (contact.totalFormSubmissions || 0) : ((contact.hasOwnProperty('formSubmissionsCount') && contact.formSubmissionsCount.hasOwnProperty(formId)) ? contact.formSubmissionsCount[formId] : 0)),
			'trafficLightClass': ($form.displaySubmissionStatusInSuggestions ? getTrafficLightClass((contact.hasOwnProperty('formSubmissionsCount') && contact.formSubmissionsCount.hasOwnProperty(formId)) ? contact.formSubmissionsCount[formId] : 0, maxSubmissionsPerContact, includeOtherFormSubmissionsInCount, (contact.totalFormSubmissions || 0)) : ""),
			'displaySubmissionStatusInSuggestions': $form.displaySubmissionStatusInSuggestions,
			'displayConsentStatusInSuggestions': $form.displayConsentStatusInSuggestions
		};

		if(atheneumInstance.Contacts.contactHelper)
			suggestion.fullContact= contact;

		suggestions.push(suggestion);
	}

	contactSearchResultTextFormat = contactSearchResultTextFormat.replace(/\{\s*(\$matches|\$total|\$limit|\$search|\$field|0|1|2)\s*\}/g, function (fullMatch, text) {
		if (text == '$matches' || text == '0') {
			return matchesParam;
		}
		if (text == '$total' || text == '1') {
			return totalParam;
		}
		if (text == '$limit' || text == '2') {
			return limitParam;
		}
		if (text == '$search') {
			return searchTerm;
		}
		if (text == '$field') {
			return fieldName;
		}
	});
	contactSearchResultNoMatch = contactSearchResultNoMatch.replace(/\{\s*(\$matches|\$total|\$limit|\$search|\$field|0|1|2)\s*\}/g, function (fullMatch, text) {
		if (text == '$matches' || text == '0') {
			return matchesParam;
		}
		if (text == '$total' || text == '1') {
			return totalParam;
		}
		if (text == '$limit' || text == '2') {
			return limitParam;
		}
		if (text == '$search') {
			return searchTerm;
		}
		if (text == '$field') {
			return fieldName;
		}
	});


	var suggestionHeader = contacts.length == 0 ? sanitizeHTML(contactSearchResultNoMatch) : sanitizeHTML(contactSearchResultTextFormat);
	if (!showContactSearchResultHeader || totalParam == '0') {
		suggestionHeader = '';
	}

	suggestions.sort(function (a, b) {
		return (a.text > b.text) ? 1 : ((a.text == b.text) ? 0 : -1);
	});

	await showSuggestionListForField($field, suggestions, suggestionHeader);
}

var showAllContactSuggestions = async function ($field) {
	var fieldName = $field.attr('name');
	var searchTerm = $field.val();
	var formId = $('input[name="hidden-form-id"]').val();
	var $form = $field.parents('form');
	var formObj = SalesToolkit.Forms.formList[formId] || form;

	if (formObj == undefined || formObj == null)
		return false;

		$form.displayContactSuggestions = formObj.displayContactSuggestions;
		$form.displayConsentStatusInSuggestions = formObj.displayConsentStatusInSuggestions;
		$form.displaySubmissionStatusInSuggestions = formObj.displaySubmissionStatusInSuggestions;
	
	event.preventDefault();
	event.stopPropagation();

	await atheneumInstance.Contacts.getByFieldValueAsync(fieldName, null, true, atheneumInstance.Theme.getIntegerProperty('contactSuggestionListMaxLength', 100), {

		success: async function (contacts) {

			let TRUE_VALUES = ['on', 'true', 'y', 'yes', true]
			if(Array.isArray(contacts) && !TRUE_VALUES.contains(SalesToolkit.User.test)){
				contacts = contacts.filter(x=> !x.hasOwnProperty('test')  || !x.test)
			}
			// request the N most relevant contacts from the server (default 10)
			// sort alphabetically

			// TODO - perhaps check most recently used contacts, and put them on top of list?

			// if the field is empty, show nothing
			//if ($field.val() == '') {
			//	hideSuggestionListForField($field);
			//	return;
			//}

			contacts = contacts.filter(function (cv, i, arr) {
				return cv.email && cv.email.length > 0;
			});


			var showContactSearchResultHeader = atheneumInstance.Theme.getBooleanProperty('contactSuggestionListHeaderEnabled', true);
			var contactSearchResultTextFormat;
			if (atheneumInstance.Theme.getIntegerProperty('contactSuggestionListMaxLength', 100) <= 0) {
				contactSearchResultTextFormat = atheneumInstance.Translation.getOrGetThemeKey('contactSuggestionListHeaderUnlimitedTextFormat', 'Showing {$matches} matching contacts of {$total}');
			}
			else {
				contactSearchResultTextFormat = atheneumInstance.Translation.getOrGetThemeKey('contactSuggestionListHeaderTextFormat', 'Showing {$matches} matching contacts (max {$limit}) of {$total}');
			}

			var contactSearchResultNoMatch = atheneumInstance.Translation.getOrGetThemeKey('contactSuggestionListHeaderTextNoMatches', 'No contacts matched your search');


			var matchesParam = (contacts.length || 0) + '';
			var totalParam = (await atheneumInstance.Contacts.getTotalNumberOfContacts() || 0) + '';
			var limitParam = atheneumInstance.Theme.getIntegerProperty('contactSuggestionListMaxLength', 100);
			if (limitParam <= 0) {
				limitParam = 'âˆž';
			}
			

			var suggestionTextFormat = atheneumInstance.Theme.getStringProperty('suggestionTextFormat',
				'{if (name)}{name} ({endif}{email}{if (name)}){endif}')

			var suggestions = [];
			
			for (var c = 0; c < contacts.length; c++) {
				var contact = contacts[c];

				if (SalesToolkit.Theme.getBooleanProperty('filterContactsSuggesstionsWithExistingFormEntries', true)) {
					let ignoreContact = false;
					let keys = Object.keys(contact.info);
					let i;

					for (i = 0; i < keys.length; i++) {

						let key = keys[i];
						if (!contact.info.hasOwnProperty(key))
							continue;

						if (key == fieldName)
							continue;

						let form = $field.parents('form');
						let field = form.find(
							'input[name="' + key + '"]'
							+ ', select[name="' + key + '"]'
							+ ', textarea[name="' + key + '"]'
						);

						if (field.length == 0)
							continue;

						field = field[0];

						if (field.type !== 'text')
							continue;

						let val = $(field).val();
						if (val !== undefined && val.length > 0) {
							if (contact.info[key].normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(val.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()) < 0) {
								matchesParam = parseInt(matchesParam) - 1 + ""
								ignoreContact = true;
								break;
							}
						}
					}

					if (ignoreContact)
						continue;
				}

				var lastNameOffset = -1;

				var contactName = '';
				if (contact.info && contact.info['firstName'] && contact.info['lastName']) {
					contactName = contact.info['firstName'] + ' ' + contact.info['lastName'];
					lastNameOffset = contact.info['firstName'].length + 1;
				}
				else if (contact.info && (contact.info['name'] || contact.info['fullName'])) {
					contactName = contact.info['name'] || contact.info['fullName'];
					contactName = contactName.indexOf(' ') == -1 ? -1 : contactName.indexOf(' ') + 1;
				}
				else if (contact.info && contact.info['lastName']) {
					lastNameOffset = 0;
					contactName = contact.info['lastName'];
				}
				else if (contact.info && contact.info['firstName']) {
					contactName = contact.info['firstName'];
				}

				var contactText = suggestionTextFormat;

				var flowRegex = /\{\s*if\s*\(\s*([a-zA-Z]+)\s*\)\s*\}(.*?)(?:\{\s*else\s*\}(.*?))?\{\s*end\s?if\s*\}/g;

				contactText = contactText.replace(flowRegex, function (fullMatch, condition, ifTrue, ifFalse) {
					var conditionValue = '';
					if (condition == 'id') {
						conditionValue = contact.id;
					}
					else if (condition == 'name' || condition == 'fullName') {
						conditionValue = contactName;
					}
					else if (condition == 'email' || condition == 'to') {
						conditionValue = contact.email;
					}
					else {
						conditionValue = contact.info[condition];
					}
					if (conditionValue) {
						return ifTrue || '';
					}
					else {
						return ifFalse || '';
					}
				});

				if (contactName == '' && contact.email) {
					contactName = contact.email;
				}

				if (contactName == '') {
					contactName = '[Contact ' + contact.id + ']';
				}
				var searchTermRegex = new RegExp(searchTerm.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&'), 'ig');

				contactText = contactText.replace(/\{\s*((?:(?:\$field)|(?:\$search)|[a-zA-Z]+))\s*\}/g, function (fullMatch, property) {
					var propValue = '';

					if (property == '$search') {
						propValue = propValue;
					}
					if (property == '$field') {
						property = fieldName;
					}

					if (property == 'id') {
						propValue = contact.id;
					}
					else if (property == 'name' || property == 'fullName') {
						propValue = contactName;
					}
					else if (property == 'email' || property == 'to') {
						propValue = contact.email;
					}
					else {
						propValue = contact.info[property];
					}


					if (property == fieldName
						|| (property == 'email' && fieldName == 'to')
						|| (property == 'name' && fieldName == 'fullName')
					) {
						propValue = propValue.replace(searchTermRegex, function (match) {
							return '<span class="contact-search-matched-text">' + match + '</span>';
						});
					}
					else if (property == 'name' && fieldName == 'firstName') {
						if (lastNameOffset != -1) {
							var firstNamePart = propValue.substring(0, lastNameOffset);
							var lastNamePart = propValue.substring(lastNameOffset);

							firstNamePart = firstNamePart.replace(searchTermRegex, function (match) {
								return '<span class="contact-search-matched-text">' + match + '</span>';
							});

							propValue = firstNamePart + lastNamePart;
						}
					}
					else if (property == 'name' && fieldName == 'lastName') {
						if (lastNameOffset != -1) {
							var firstNamePart = propValue.substring(0, lastNameOffset);
							var lastNamePart = propValue.substring(lastNameOffset);

							lastNamePart = lastNamePart.replace(searchTermRegex, function (match) {
								return '<span class="contact-search-matched-text">' + match + '</span>';
							});

							propValue = firstNamePart + lastNamePart;
						}
					}
					return propValue || '';
				});

				var includeOtherFormSubmissionsInCount = $form.attr('data-contact-includeOtherFormSubmissionsInCount');
				var maxSubmissionsPerContact = $form.attr('data-contact-maxSubmissionsPerContact');

				var suggestion = {
					'text': contactText,
					'value': contact.info[$field.attr('name')],
					'contact': contact.id,
					'consentStatus': contact.status,
					'formSubmissionCount': (includeOtherFormSubmissionsInCount == "true" ? (contact.totalFormSubmissions || 0) : ((contact.hasOwnProperty('formSubmissionsCount') && contact.formSubmissionsCount.hasOwnProperty(formId)) ? contact.formSubmissionsCount[formId] : 0)),
					'trafficLightClass': ($form.displaySubmissionStatusInSuggestions ? getTrafficLightClass((contact.hasOwnProperty('formSubmissionsCount') && contact.formSubmissionsCount.hasOwnProperty(formId)) ? contact.formSubmissionsCount[formId] : 0, maxSubmissionsPerContact, includeOtherFormSubmissionsInCount, (contact.totalFormSubmissions || 0)) : ""),
					'displaySubmissionStatusInSuggestions': $form.displaySubmissionStatusInSuggestions,
					'displayConsentStatusInSuggestions': $form.displayConsentStatusInSuggestions
				};

				if(atheneumInstance.Contacts.contactHelper)
					suggestion.fullContact= contact;

				suggestions.push(suggestion);
			}

			contactSearchResultTextFormat = contactSearchResultTextFormat.replace(/\{\s*(\$matches|\$total|\$limit|\$search|\$field|0|1|2)\s*\}/g, function (fullMatch, text) {
				if (text == '$matches' || text == '0') {
					return matchesParam;
				}
				if (text == '$total' || text == '1') {
					return totalParam;
				}
				if (text == '$limit' || text == '2') {
					return limitParam;
				}
				if (text == '$search') {
					return searchTerm;
				}
				if (text == '$field') {
					return fieldName;
				}
			});
			contactSearchResultNoMatch = contactSearchResultNoMatch.replace(/\{\s*(\$matches|\$total|\$limit|\$search|\$field|0|1|2)\s*\}/g, function (fullMatch, text) {
				if (text == '$matches' || text == '0') {
					return matchesParam;
				}
				if (text == '$total' || text == '1') {
					return totalParam;
				}
				if (text == '$limit' || text == '2') {
					return limitParam;
				}
				if (text == '$search') {
					return searchTerm;
				}
				if (text == '$field') {
					return fieldName;
				}
			});


			var suggestionHeader = contacts.length == 0 ? sanitizeHTML(contactSearchResultNoMatch) : sanitizeHTML(contactSearchResultTextFormat);
			if (!showContactSearchResultHeader || totalParam == '0') {
				suggestionHeader = '';
			}
			
			suggestions.sort(function (a, b) {
				return (a.text > b.text) ? 1 : ((a.text == b.text) ? 0 : -1);
			});

			await showSuggestionListForField($field, suggestions, suggestionHeader);
		},
		failure: function () {
			hideSuggestionListForField($field);
		},
		offline: function () {
			hideSuggestionListForField($field);
		}
	}, null, null, SalesToolkit.Theme.getBooleanProperty('filterContactsSuggesstionsWithExistingFormEntries', true), formObj, $form);
}

function getTrafficLightClass(formSubmissionsCount, maxSubmissionsPerContact, includeOtherFormSubmissionsInCount, totalFormSubmissions) {
	result = "";
	if (maxSubmissionsPerContact <= 0) {
		return result = 'trafficLightColourGreen';
	}
	var suggestionListFormsSubmissionsCountRed = atheneumInstance.Theme.getIntegerProperty('suggestionListFormsSubmissionsCountRed', 3);
	var suggestionListFormsSubmissionsCountAmber = atheneumInstance.Theme.getIntegerProperty('suggestionListFormsSubmissionsCountAmber', 2);
	var suggestionListFormsSubmissionsCountGreen = atheneumInstance.Theme.getIntegerProperty('suggestionListFormsSubmissionsCountGreen', 1);

	if (includeOtherFormSubmissionsInCount == "true") {
		if (totalFormSubmissions >= maxSubmissionsPerContact || totalFormSubmissions >= suggestionListFormsSubmissionsCountRed) {
			result = "trafficLightColourRed ";
		} else if (totalFormSubmissions < maxSubmissionsPerContact && totalFormSubmissions >= suggestionListFormsSubmissionsCountAmber) {
			result = 'trafficLightColourAmber';
		} else {
			result = 'trafficLightColourGreen';
		}
	} else {
		if (formSubmissionsCount >= maxSubmissionsPerContact || formSubmissionsCount >= suggestionListFormsSubmissionsCountRed) {
			result = "trafficLightColourRed ";
		} else if (formSubmissionsCount < maxSubmissionsPerContact && formSubmissionsCount >= suggestionListFormsSubmissionsCountAmber) {
			result = 'trafficLightColourAmber';
		} else {
			result = 'trafficLightColourGreen';
		}
	}
	return result;
}

function setFieldValue($field, value) {

	if ($field.attr('data-type') == 'CHECKBOX' || $field.attr('data-type') == 'REMOTE_CONSENT') {

		if (value == null || value == '') {
			$field.prop('checked', false);
		}
		else if (value === true) {
			$field.prop('checked', true);
		}
		else if (value === false) {
			$field.prop('checked', true);
		}
		else if (['true', 'yes', 'on'].indexOf(value.toLowerCase()) != -1) {
			$field.prop('checked', true);
		}
		else if (['false', 'no', 'off'].indexOf(value.toLowerCase()) != -1) {
			$field.prop('checked', false);
		}
		else {
			$field.prop('checked', true);
		}
	}
	else if ($field.attr('data-type') == 'RADIO' || $field.attr('data-type') == 'CONSENT_TYPE') {
		$field.each(function () {
			if ($(this).val() == value) {
				$(this).prop('checked', true);
			}
			else {
				$(this).prop('checked', false);
			}
		})
	}
	else if ($field.attr('data-type') == 'RADIO_MULTI') {
		var values = (value || '').split(',');
		$field.each(function () {
			if (values.indexOf($(this).val()) != -1) {
				$(this).prop('checked', true);
			}
			else {
				$(this).prop('checked', false);
			}
		});
	}
	else if ($field.attr('data-type') == 'SIGNATURE') {
		// TODO - is this even possible
	}
	else if($field.attr('data-type') == 'COUNTRY'){
		$field.val(value.toLowerCase());
	}else if($field.attr('data-filtered-textfield') != undefined){
		let filteredTextFieldId = $field.data('filtered-textfield');
		let filteredTextField = window[filteredTextFieldId];
		if(filteredTextField){
			filteredTextField.setSelectedItems(value.split(','));
		}
		else
			$field.val(fieldValue);
	}
	else {
		$field.val(value);
	}
}

function populateFormWithBadgeData($form, badge) {

	// note: badge data may have strange capitalisation

	var toFieldAutogenerated = false;
	if (!(badge.hasOwnProperty('to')) && !(badge.hasOwnProperty('To')) && !(badge.hasOwnProperty('TO'))
		&& (badge.hasOwnProperty('email') || badge.hasOwnProperty('Email') || badge.hasOwnProperty('EMAIL'))) {
		badge['to'] = badge['email'] || badge['Email'] || badge['EMAIL'];
		toFieldAutogenerated = true;
	} else if (badge.hasOwnProperty('to') && !badge.hasOwnProperty('email'))  {
		badge['email'] = badge['to'];
	}

	for (fieldName in badge) {

		if (!(badge.hasOwnProperty(fieldName))) {
			continue;
		}

		$field = $form.find(
			'input[name="' + fieldName + '"]'
			+ ', select[name="' + fieldName + '"]'
			+ ', textarea[name="' + fieldName + '"]'
		);

		if ($field.length == 0) {

			// field capitalization may not match, do a slower case-insensitive check

			var matches = [];
			var $fields = $form.find('input[name], select[name], textarea[name]');
			$fields.each(function () {
				if ($(this).attr('name').toLowerCase() == fieldName.toLowerCase()) {
					matches.push(this);
				}
			});
			$field = $(matches);

			if ($field.length == 0 && !(toFieldAutogenerated && fieldName == 'to')) {
				// turns out there's nothing at all
				console.warn('field "' + fieldName + '" with value "' + badge[fieldName] + '" was present in the badge, but there is no corresponding field on the form to populate');
				continue;
			}
		}

		setFieldValue($field, badge[fieldName]);

	}

	handleDependencies($form);
}

var sessionBadgeId = null;
var sessionBadgeData = {};

function endSession() {
	sessionBadgeId = null;
	sessionBadgeData = null;
	atheneumInstance.Session.end();
}

atheneumInstance.Badges.addBadgeScanCallback(function (badgeId) {

	//TODO CHECK WORKS
	if ($('form').length > 0) {
		var $badgeField = $('form .atheneum-form-field input[data-type=BADGE]');
		if ($badgeField.length > 0) {
			$badgeField.eq(0).val(badgeId);
			$badgeField.eq(0).trigger('change');
		}
	}
});


// on form text field focus:

// if ios

// if safe region is too small to contain the field

// scroll page until the safe region is large enough to contain the field

// if field not within safe region

// scroll form until form within safe region

/*TODO FIND OUT function scrollForm(value) {
	return smoothScroll($('#form-holderWrapper')[0], value);
}
function scrollPage(value) {
	return smoothScroll($('body')[0], value);
}
function smoothScroll(element, value) {
	console.log("scrolling from " + (element.scrollTop | 0) + " to " + value)
	$(element).animate({ 'scrollTop': (value | 0) }, 200);
}*/

function getDefaultSignupForm() {
	return {
		type: 'SIGNUP',
		fields: [
			{ type: 'TEXT', name: 'userName', label: 'Username', editable: false, visible: true, required: true },
			{ type: 'EMAIL', name: 'email', label: 'Email', editable: true, visible: true, required: true },

			{ type: 'TEXT', name: 'title', label: 'Title', editable: true, visible: true },
			{ type: 'TEXT', name: 'firstName', label: 'First Name', editable: true, visible: true },
			{ type: 'TEXT', name: 'middleName', label: 'Middle Name', editable: true, visible: true },
			{ type: 'TEXT', name: 'lastName', label: 'Last Name', editable: true, visible: true },

			//{ type: 'PASSWORD', name: 'password', label: 'Password', editable: true, visible: true },
			//{ type: 'CONFIRM', name: 'passwordConf', label: 'Confirm Password', editable: true, visible: true, confField: 'password' }
		]
	};
}



function dismissPopup() {
	var $okButton = $('.vpopup-overlay .vpopup-buttons .vpopup-button-ok');
	if ($okButton.length > 0) {
		$okButton.click();
	}
	else {
		$('.vpopup-overlay').remove();
	}
}

$(document).on('click', '[data-action]', function () {

	var action = $(this).attr('data-action');

	if (action == 'dismissPopup') {
		dismissPopup();
		return;
	}

	if (action == 'logout') {
		if ($(this).attr('data-dismiss-popup') != 'true') {
			$('.vpopup-overlay').remove();
		}
		else {
			dismissPopup()
		}
		performLogout();
		return;
	}

	if (action == 'showHomeScreen') {
		dismissPopup()
		showHomeScreen();
		return;
	}

	if (action == 'showCollection' && $(this).attr('data-collection-id')) {
		dismissPopup()
		showCollection($(this).attr('data-collection-id'));
		return;
	}

	if (action == 'showPreview' && ($(this).attr('data-reprint-id') || $(this).attr('data-asset-id'))) {
		dismissPopup()
		previewAsset($(this).attr('data-reprint-id') || $(this).attr('data-asset-id'));
		return;
	}

	if (action == 'showForm' && $(this).attr('data-form-id')) {
		dismissPopup()
		showFormScreen($(this).attr('data-form-id'));
		return;
	}

	if (action == 'showSummaryScreen') {
		dismissPopup()
		showSummaryScreen();
		return;
	}

	if (action == 'openURL') {

		if ($(this).attr('data-dismiss-popup') == 'true') {
			dismissPopup()
		}

		var target = '_blank';
		if ($(this).attr('data-target') == '_self') {
			target = '_blank';
		}

		var url = $(this).attr('data-url');
		if (url) {
			window.open(url, target);
		}
	}

});

var prepopupScreenBackData = {};

$(document).on('click', '.passwordVisibilityToggle', function () {
	$(this).toggleClass('toggled');
	var $passwordField = $(this).prevAll().filter('input[type=password], input.password-field').first();
	if ($passwordField.length == 0) {
		$passwordField = $(this).parent().find('input[type=password], input.password-field').eq(0);
	}
	if ($passwordField.attr('type') != 'password') {
		$passwordField.attr('type', 'password');
	}
	else {
		$passwordField.attr('type', 'text').addClass('password-field');
	}
});

console.log("atheneumAPI.Forms.js - loaded");

function showFormScreen(formId, params) {
	loadForm(formId, params);
}

/**
 * MEETINGS
 **/


function filterMeetings(meetings, collectionId) {

	var meetingFormCollectionId = collectionId;
	if (meetingFormCollectionId == '')
		meetingFormCollectionId = null;

	if (meetingFormCollectionId != null) {
		// step up to root looking for meeting collection
		// first collection with a different form must have been parent of actual meeting form collection
		var meetingForm = atheneumInstance.Forms.getMeetingForm(collectionId);
		var collection = atheneumInstance.Library.collections[collectionId];
		while (collection != null) {
			var parent = (collection.containedBy) == null ? null : atheneumInstance.Library.collections[collection.containedBy];
			var parentMeetingForm = atheneumInstance.Forms.getMeetingForm(parent);
			if (meetingForm != parentMeetingForm) {
				meetingFormCollectionId = (collection == null) ? null : collection.id;
				break;
			}
			if (collection == null) {
				meetingFormCollectionId = null;
				break;
			}
			collection = parent;
		}
	}

	var matches = [];
	if (meetings) {
		for (var m = 0; m < meetings.length; m++) {
			var meeting = meetings[m];
			if (meetingFormCollectionId == null) {
				// all meetings
				matches.push(meeting);
			}
			else if (meeting.collection == null) {
				continue;
			}
			else if (meeting.collection.id == meetingFormCollectionId) {
				// in collections
				matches.push(meeting);
			}
			else {
				// not in the collection, but in "a" collection
				// check if descendent of meeting form collection
				var col = atheneumInstance.Library.collections[meeting.collection.id];
				while (col != null) {
					var parentId = col.containedBy;
					if (parentId == null) {
						break;
					}
					if (parentId == meetingFormCollectionId) {
						// descendent of meeting form collection
						matches.push(meeting);
						break;
					}
					col = atheneumInstance.Library.collections[parentId];
				}
			}
		}
	}

	return matches;
}

function showMeetingsScreen(collectionId) {
	if (window.location.href.indexOf('meetings.html') < 0) {
		if (collectionId) {
			window.location = "meetings.html?collectionId=" + collectionId;
		} else {
			window.location = "meetings.html";
        }
		
		return;
    }


	window.clearTimeout(meetingAttendeeTimeOut);
	atheneumInstance.API.getMeetings({
		success: function (json) {
			if (collectionId)
				showMeetingsTable(filterMeetings(json.meetings, collectionId));
			else
				showMeetingsTable(json.meetings);
		},
		failure: function (reason, httpStatus, errorCode) {
			showOfflineMeetings();
		}
	});

}

var contactsTablePage = 0;
var contactsPerPage = 20;
var totalContactPages = 1;
var totalContacts = 0;
var contactTableParams = Object.create(null);
//ADDED WITH GEMINI
var contactHelperTableParams = { sortBy: 'email', sortOrder: 'asc' };
var contactsColumns = [ ];

async function showContactsScreen(viewingCollection, attempt) {
	if (window.location.href.indexOf('contacts.html') < 0) {
		window.location = "contacts.html";
		return;
	}

	if(atheneumInstance.Theme.getBooleanProperty("liveContactsTable", false) || atheneumInstance.Contacts.contactHelper)
		$('#contactsSection').toggleClass('liveContacts', true);
	else
		$('#contactsSection').removeClass('liveContacts');

	let contacts = [];
	if(!atheneumInstance.Contacts.contactHelper && !atheneumInstance.Theme.getBooleanProperty("liveContactsTable", false)){
		contacts = await atheneumInstance.Contacts.getById('', { exact: false });
	}
	
	var collectionIdToCompare = (!viewingCollection || viewingCollection == null || viewingCollection.id == null) ? '' : viewingCollection.id;
	if (collectionIdToCompare == '')
		collectionIdToCompare = atheneumInstance.getHomeCollectionID() || '';
	if (atheneumInstance.Theme.getBooleanProperty('showCollectionDropDown', true)) {

		atheneumInstance.API.getCollectionsContacts({
			success: async function (json) {
				$('#collectionDropdown').empty();
				$('#collectionDropdown').append('<optgroup label="Collections"><option value = "" selected = "selected">' + atheneumInstance.Translation.getOrGetThemeKey('contactsScreenShowAll', 'Show all') + '</option>');

				var visibleDropDown = false;
				 
				$.each(json.collections, function (key, value) {
					$('#collectionDropdown optgroup[label="Collections"]').append($('<option value=' + value.id + (value.id === collectionIdToCompare ? ' selected = "selected"' : '') + '>' + value.name + '</option>'));
					if (collectionIdToCompare != null && value.id === collectionIdToCompare) {
						visibleDropDown = true;
					}
				});

				$('#collectionDropdown').append('</optgroup><optgroup label="Contacts"><option value="myContacts">' + atheneumInstance.Translation.getOrGetThemeKey('contactsScreenShowOnlyMyContacts', 'Show only my contacts') + '</option>');

				if (collectionIdToCompare == null || collectionIdToCompare === '' || visibleDropDown) {
					$('#collectionDropdown').show();
					$('#collectionDropdown').on('change', async function (event) {
							
								var select = $('#collectionDropdown');
								var selectedCollectionId = $('#collectionDropdown').val();
							var showMyContacts = $('#collectionDropdown').val() == "myContacts";

								atheneumInstance.Theme.setOverridingCollection(selectedCollectionId);
								applyThemeToToolkit();

								if(atheneumInstance.Theme.getBooleanProperty("liveContactsTable", false))
								{
									contactTableParams.showOnlyMyContacts = showMyContacts;
									contactTableParams.collectionId = collectionId || null;
									if(contactTableParams.collectionId && contactTableParams.collectionId != null)
										contactTableParams.excludeAccountLevelContacts = true;
									else 
										contactTableParams.excludeAccountLevelContacts = false;
										
									contactsTablePage = 0;	
									updateLiveContactsTable();
									return;
								}else if(atheneumInstance.Contacts.contactHelper){
									contactsTablePage = 0;
									updateContactHelperTable();
								}


								var contacts = await atheneumInstance.Contacts.getByEmailAddress('');
								var lookupContacts = contacts.filter(function (item) {
									if (selectedCollectionId != '' && item.collection && item.collection.id != selectedCollectionId) {
										return false;
									}
									return true;
								});
								lookupContacts = lookupContacts.filter(function (item) {
									if (showMyContacts && item.createdBy != atheneumInstance.User.id) {
										return false;
									}
									return true;
								});

								showContactsTable(lookupContacts);
						});
				}  else {
					$('#collectionDropdown').hide();
				}

			},
			failure: function (reason, httpStatus, errorCode) {
				$('#collectionDropdown').hide();
				Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.API.getCollectionsWithMeetings');
			}
		});
	}

	if(atheneumInstance.Theme.getBooleanProperty("liveContactsTable", false))
	{
		showContactsTable([]);
		contactsTablePage = 0;
		$('#pagingNextButton').css('background-color', atheneumInstance.Theme.getColourProperty('titleButtonTint', Atheneum.Colour.TRUSTRACK_BLUE));
		$('#pagingNextButton').css('color', atheneumInstance.Theme.getColourProperty('titleButtonFontColour6', 'ffffff'));
		$('#pagingBackButton').css('background-color', atheneumInstance.Theme.getColourProperty('titleButtonTint', Atheneum.Colour.TRUSTRACK_BLUE));
		$('#pagingBackButton').css('color', atheneumInstance.Theme.getColourProperty('titleButtonFontColour6', 'ffffff'));
		$('#contactsTableRefreshButton').css('background-color', atheneumInstance.Theme.getColourProperty('titleButtonTint', Atheneum.Colour.TRUSTRACK_BLUE));
		$('#contactsTableRefreshButton').css('color', atheneumInstance.Theme.getColourProperty('titleButtonFontColour6', 'ffffff'));
		
		$('.contactsTableLoader').css('border-top-color', atheneumInstance.Theme.getColourProperty('titleButtonTint', Atheneum.Colour.TRUSTRACK_BLUE));
		
		$('.contactsTablePagingWrapper').show();
		$('.contactsTableLoader').show();
		
		var contactsPerPageUserValue = parseInt(localStorage.getItem("contactsPerPage")) || 20;
		var selectionList = 2;
		switch(contactsPerPageUserValue){
			case 10:
				selectionList = 1;
				contactsPerPage = 10;
				break;
			case 50:
				selectionList = 3;
				contactsPerPage = 50;
				break;
			case 100:
				selectionList = 4;
				contactsPerPage = 100;
				break;
			case 20:
			default:
				selectionList = 2;
				contactsPerPage = 20;
				break;
				
		}
		
		$('#contactsPerPageSelect').val(contactsPerPage);
		
		('#contactsPerPageSelect').off('change').on('change', function(event){
			contactsPerPage = parseInt($(this).val());
			localStorage.setItem("contactsPerPage", contactsPerPage);
			
			if(contactsPerPage * (contactsTablePage + 1) > totalContacts) {
				contactsTablePage = Math.ceil(totalContacts / contactsPerPage) - 1;
				if(contactsTablePage < 0) {
					contactsTablePage = 0;
				}
			}
			if (atheneumInstance.Contacts.contactHelper) {
				updateContactHelperTable();
			} else {
				updateLiveContactsTable();
			}
		});
						
		loadingLiveContactsTable = true;
		
		atheneumInstance.API.getContacts(contactsPerPage, contactsTablePage, 0, contactTableParams, {
			success: function(json){ 
				totalContactPages = json.totalPages;
				totalContacts = json.totalContacts;
				$('#pagingCurrentPageText').val(""+(contactsTablePage + 1)+"/"+totalContactPages);
				$('#pagingCurrentPageText').show();
				$('#pagingBackButton').prop( "disabled", true );
				$('#contactsTableRefreshButton').prop( "disabled", false );
				if(totalContactPages > 1)
					$('#pagingNextButton').prop( "disabled", false );
					
				$('#pagingCurrentPageText').attr('title', ""+json.totalContacts);
					
				showContactsTable(json.contacts);
				
		 	},
			failure: function( reason, httpStatus, errorCode ) {
				Atheneum.Callbacks.logFailureDetails( reason, httpStatus, errorCode, 'atheneumInstance.API.getContacts' );
				showContactsTableError(atheneumInstance.Theme.getStringProperty("liveContactsError", "Could not load contacts: "+reason));
			},
			offline: function( reason, httpStatus, errorCode ) {
				Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'atheneumInstance.API.getContacts');
				showContactsTableError(atheneumInstance.Theme.getStringProperty("liveContactsOfflineError", "Contacts are unavailable while offline"));
			}
			});
		
		return;
	}

	if(atheneumInstance.Contacts.contactHelper){
		showContactsTable([]);
		contactsTablePage = 0;
		$('#pagingNextButton').css('background-color', atheneumInstance.Theme.getColourProperty('titleButtonTint', Atheneum.Colour.TRUSTRACK_BLUE));
		$('#pagingNextButton').css('color', atheneumInstance.Theme.getColourProperty('titleButtonFontColour6', 'ffffff'));
		$('#pagingBackButton').css('background-color', atheneumInstance.Theme.getColourProperty('titleButtonTint', Atheneum.Colour.TRUSTRACK_BLUE));
		$('#pagingBackButton').css('color', atheneumInstance.Theme.getColourProperty('titleButtonFontColour6', 'ffffff'));
		$('#contactsTableRefreshButton').css('background-color', atheneumInstance.Theme.getColourProperty('titleButtonTint', Atheneum.Colour.TRUSTRACK_BLUE));
		$('#contactsTableRefreshButton').css('color', atheneumInstance.Theme.getColourProperty('titleButtonFontColour6', 'ffffff'));
		
		$('.contactsTableLoader').css('border-top-color', atheneumInstance.Theme.getColourProperty('titleButtonTint', Atheneum.Colour.TRUSTRACK_BLUE));
		
		$('.contactsTablePagingWrapper').show();
		
		var contactsPerPageUserValue = parseInt(localStorage.getItem("contactsPerPage")) || 20;
		switch(contactsPerPageUserValue){
			case 10: contactsPerPage = 10; break;
			case 50: contactsPerPage = 50; break;
			case 100: contactsPerPage = 100; break;
			case 20: default: contactsPerPage = 20; break;
		}
		
		$('#contactsPerPageSelect').val(contactsPerPage);
		$('#contactsPerPageSelect').off('change').on('change', function(event){
								let select = $('#contactsPerPageSelect');
								let selectedValue = select.val();
			                	contactsPerPage = parseInt(selectedValue);
								localStorage.setItem("contactsPerPage", contactsPerPage);
								contactsTablePage = 0;
								updateContactHelperTable();
		});
						
		updateContactHelperTable();
		return;
	}
	

	if (collectionIdToCompare !== '') {
		var lookupContacts = contacts.filter(function (item) {
			if (collectionIdToCompare != '' && item.collection && item.collection.id != collectionIdToCompare) {
				return false;
			}
			return true;
		});

		showContactsTable(lookupContacts);
		return;
	}
	showContactsTable(contacts);

}



var formColumns = getFormColumns();

function getFormColumns() {
	var forms = atheneumInstance.Forms.getHomeScreenForms();
	var displayFormColumns = [];
	for (var i = 0; i < forms.length; i++) {
		if (forms[i].displayFormSubmissionsColumn) {
			var data = {};
			data.name = forms[i].title;
			data.formId = forms[i].id;
			data.formSubmissionsColumnName = (!!forms[i].formSubmissionsColumnName? forms[i].formSubmissionsColumnName : forms[i].title.replace(/\s/g, '')) ;
			data.formSubmissionsType = forms[i].formSubmissionsType;
			data.formSubmissionCustomRules = forms[i].formSubmissionCustomRules;
			displayFormColumns.push(data);
		}
	}
	return displayFormColumns;
}


var loadingLiveContactsTable = false;

function loadPreviousContactsPage(){
	if(loadingLiveContactsTable) return;
		
	if(contactsTablePage == 0) return;
	
	contactsTablePage -= 1;
	
	if(contactsTablePage <= 0)
	{
		contactsTablePage = 0;
		$('#pagingBackButton').prop( "disabled", true );
	}
	
	if((contactsTablePage + 1) < totalContactPages)
	{
		$('#pagingNextButton').prop( "disabled", false );
	}else{
		$('#pagingNextButton').prop( "disabled", true );
	}
	
	if (atheneumInstance.Contacts.contactHelper) {
        updateContactHelperTable();
    } else {
		loadingLiveContactsTable = true;
	    updateLiveContactsTable();
    }
	
}

function loadNextContactsPage(){
	if(loadingLiveContactsTable) return;
		
	if((contactsTablePage + 1) >= totalContactPages) return;
	
	contactsTablePage += 1;
	
	if(contactsTablePage >= totalContactPages)
	{
		contactsTablePage = totalContactPages;
		$('#pagingNextButton').prop( "disabled", true );
	}
	
	if(contactsTablePage == 0)
	{
		$('#pagingBackButton').prop( "disabled", true );
	}else{
		$('#pagingBackButton').prop( "disabled", false );
	}	
	
	if (atheneumInstance.Contacts.contactHelper) {
        updateContactHelperTable();
    } else {
		loadingLiveContactsTable = true;
	    updateLiveContactsTable();
    }
}

function refreshContactsTable(){
	if(loadingLiveContactsTable)
		return;
		
	if (atheneumInstance.Contacts.contactHelper) {
        updateContactHelperTable();
    } else {
		loadingLiveContactsTable = true;	
		updateLiveContactsTable();
    }

}

function selectContactsPage(){
	var text = atheneumInstance.Translation.getOrGetThemeKey("selectContactPageTitle", "Please enter a page from 1 to {0}");
	text.replaceAll("{0}", totalContactPages);
	  var selection = parseInt(window.prompt(text, "1"), 10);
	
	 if(isNaN(selection) || selection < 1){
		selection = 1;
	}else if(selection > totalContactPages)
	{
		selection = totalContactPages;
	}
	
	var indexSelected = selection - 1;
	
	if(indexSelected >= totalContactPages)
		indexSelected = totalContactPages - 1;
	if(indexSelected < 0)
		indexSelected = 0;
		
	contactsTablePage = indexSelected;
	
	if (atheneumInstance.Contacts.contactHelper) {
        updateContactHelperTable();
    } else {
		loadingLiveContactsTable = true;
		updateLiveContactsTable();
    }
}

async function updateContactHelperTable() {
    if (loadingLiveContactsTable) return;
    loadingLiveContactsTable = true;

    $('.contactsTableLoader').show();
    $('.contactsTableError').hide();
    $('#contactsTable').find('tbody').html('');

    const collectionId = $('#collectionDropdown').val() === 'myContacts' ? null : ($('#collectionDropdown').val() || null);
    
    try {
        // First, get the total count for pagination
       totalContacts = collectionId? await atheneumInstance.Contacts.contactHelper.getTotalContacts({ collectionId: collectionId }) : await atheneumInstance.Contacts.getTotalNumberOfContacts();
        totalContactPages = Math.ceil(totalContacts / contactsPerPage);
        if (totalContactPages === 0) totalContactPages = 1;

        // Adjust current page if it's out of bounds
        if (contactsTablePage >= totalContactPages) {
            contactsTablePage = totalContactPages - 1;
        }
        if (contactsTablePage < 0) {
            contactsTablePage = 0;
        }

        // Update paging UI
        $('#pagingCurrentPageText').val(`${contactsTablePage + 1}/${totalContactPages}`);
        $('#pagingCurrentPageText').show();
        $('#pagingCurrentPageText').attr('title', `${totalContacts} total contacts`);
        $('#pagingBackButton').prop('disabled', contactsTablePage === 0);
        $('#pagingNextButton').prop('disabled', (contactsTablePage + 1) >= totalContactPages);
        $('#contactsTableRefreshButton').prop( "disabled", false );
        
        // Now, get the paginated contacts
        const contacts = await atheneumInstance.Contacts.contactHelper.getContacts({
            collectionId: collectionId,
            sortBy: contactHelperTableParams.sortBy,
            sortOrder: contactHelperTableParams.sortOrder,
            limit: contactsPerPage,
            offset: contactsTablePage * contactsPerPage
        });

        showContactsTable(contacts, null, getContactHelperInitialSortColumn(), getContactHelperInitialSortDirection(), false);

    } catch (error) {
        console.error("Error updating contacts table with helper:", error);
        showContactsTableError("Could not load contacts: " + error.message);
    } finally {
        loadingLiveContactsTable = false;
        $('.contactsTableLoader').hide();
    }
}

function updateLiveContactsTable(){
	$('.contactsTableLoader').show();
		$('.contactsTableError').hide();
	$('#contactsTable').find('tbody').html('');
	$('#pagingCurrentPageText').val(""+(contactsTablePage + 1)+"/"+totalContactPages);
	
	var searchText = $('#searchBoxInput').val();
	if(searchText && searchText != null && searchText.length > 0)
	{
		searchLiveContactsTable(searchText, contactsTablePage);
		return;
	}
	
	
	atheneumInstance.API.getContacts(contactsPerPage, contactsTablePage, 0, contactTableParams, {
		success: function(json){ 
			totalContactPages = json.totalPages;
			$('#pagingCurrentPageText').val(""+(contactsTablePage + 1)+"/"+totalContactPages);
			if(contactsTablePage == 0)
				$('#pagingBackButton').prop( "disabled", true );
			if(totalContactPages > 1)
				$('#pagingNextButton').prop( "disabled", false );
			if((contactsTablePage + 1) == totalContactPages)
				$('#pagingNextButton').prop( "disabled", true );
			
			$('#pagingCurrentPageText').attr('title', ""+json.totalContacts);
				
			showContactsTable(json.contacts, null, getLiveContactsInitialSortColumn(), getLiveContactsInitialSortDirection(), false);
	 	},
		failure: function( reason, httpStatus, errorCode ) {
			Atheneum.Callbacks.logFailureDetails( reason, httpStatus, errorCode, 'atheneumInstance.API.getContacts' );
			showContactsTableError(atheneumInstance.Theme.getStringProperty("liveContactsError", "Could not load contacts: "+reason));
		},
		offline: function( reason, httpStatus, errorCode ) {
			Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'atheneumInstance.API.getContacts');
			showContactsTableError(atheneumInstance.Theme.getStringProperty("liveContactsOfflineError", "Contacts are unavailable while offline"));
		}
	});
}

function searchLiveContactsTable(searchText, pageIndex){
	
	if(!searchText || searchText == null || searchText.length == 0){
		 updateLiveContactsTable();
	return;
	}
		
	
	$('.contactsTableLoader').show();
		$('.contactsTableError').hide();
	$('#contactsTable').find('tbody').html('');
	$('#pagingCurrentPageText').val(""+(contactsTablePage + 1)+"/"+totalContactPages);
	if(!pageIndex || pageIndex < 0)
		pageIndex = 0;
		
	contactsTablePage = pageIndex;
	atheneumInstance.API.searchContacts(undefined , searchText, true, contactsPerPage, pageIndex, {
			success: function(json){ 
				totalContactPages = json.totalPages;
				$('#pagingCurrentPageText').val(""+(contactsTablePage + 1)+"/"+totalContactPages);
				if(contactsTablePage == 0)
					$('#pagingBackButton').prop( "disabled", true );
				if(totalContactPages > 1)
					$('#pagingNextButton').prop( "disabled", false );
				if((contactsTablePage + 1) == totalContactPages)
					$('#pagingNextButton').prop( "disabled", true );
				showContactsTable(json.contacts, null, getLiveContactsInitialSortColumn(), getLiveContactsInitialSortDirection(), true);
		 	},
			failure: function( reason, httpStatus, errorCode ) {
				Atheneum.Callbacks.logFailureDetails( reason, httpStatus, errorCode, 'atheneumInstance.API.getContacts' );
				showContactsTableError(atheneumInstance.Theme.getStringProperty("liveContactsError", "Could not load contacts: "+reason));
			},
			offline: function( reason, httpStatus, errorCode ) {
				Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'atheneumInstance.API.getContacts');
				showContactsTableError(atheneumInstance.Theme.getStringProperty("liveContactsOfflineError", "Contacts are unavailable while offline"));
			}
		});
}

function getLiveContactsInitialSortColumn(){
	if(!contactTableParams || !contactTableParams.sortByFieldName || contactTableParams.sortByFieldName == null)
		return undefined;
	
	switch(contactTableParams.sortByFieldName){
		case "email": 
			return "contactsTableEmailColumn";
		case "firstName":
			return "contactsTableFirstNameColumn";
		case "lastName":
			return "contactsTableLastNameColumn";
		case "totalFormSubmissions":
			return "contactsTableTotalSubCountColumn";
		case "repSubmittedConsentGained":
			return "contactsRepSubmittedColumn";
		case "consentStatus":
			return "contactsTableStatusColumn";
		default:
			try{
				var contact = contactsColumns.filter(function(item) {
	    	        if (item.name === contactTableParams.sortByFieldName) {
	    	        	return true;
	    	        }
	        		return false;
	            });
	
				if(contact && contact.length > 0)
				{
					if(contact[0].columnClass)
						return contact[0].columnClass;
				}
			}catch(err){
				console.log(err);
			}
			
			break;
	}
	
	return undefined;
}

function getLiveContactsInitialSortNameFromColumn(columnToSort){
	switch(columnToSort){
		case "contactsTableEmailColumn": 
			return "email";
		case "contactsTableFirstNameColumn":
			return "firstName";
		case "contactsTableLastNameColumn":
			return "lastName";
		case "contactsTableTotalSubCountColumn":
			return "totalFormSubmissions";
		case "contactsRepSubmittedColumn":
			return "repSubmittedConsentGained";
		case "contactsTableStatusColumn":
			return "consentStatus";
		default:
			try{
				var contact = contactsColumns.filter(function(item) {
	    	        if (item.columnClass === columnToSort) {
	    	        	return true;
	    	        }
	        		return false;
	            });
	
				if(contact && contact.length > 0)
				{
					if(contact[0].name)
						return contact[0].name;
				}
			}catch(err){
				console.log(err);
			}
			break;
	}
	
	return "email";
}

function getLiveContactsInitialSortDirection(){
	if(!contactTableParams || !contactTableParams.sortDirection || contactTableParams.sortDirection == null)
		return undefined;
		
	if(contactTableParams.sortDirection == "ASC")
		{
			return "tableHeaderSortUp";
		}else if(contactTableParams.sortDirection == "DESC"){
			return "tableHeaderSortDown";
		}
		
		return undefined;
} 

function setupSortingForLiveContacts(columnToSort, sortDirection){
	contactTableParams.sortByFieldName = getLiveContactsInitialSortNameFromColumn(columnToSort);
	contactTableParams.sortDirection = sortDirection;
}

function getContactHelperInitialSortColumn() {
    const sortBy = contactHelperTableParams.sortBy;
    switch(sortBy) {
        case 'email': return 'contactsTableEmailColumn';
        case 'externalId': return 'contactsTableExternalIdColumn';
        case 'firstName': return 'contactsTableFirstNameColumn';
        case 'lastName': return 'contactsTableLastNameColumn';
        case 'totalSubCount': return 'contactsTableTotalSubCountColumn';
        case 'repSubmitted': return 'contactsTableRepSubmittedColumn';
        case 'consentStatus': return 'contactsTableStatusColumn';
        default: return 'contactsTableEmailColumn';
    }
}

function getContactHelperSortNameFromColumn(columnClass) {
	switch(columnClass){
		case "contactsTableEmailColumn": return "email";
        case "contactsTableExternalIdColumn": return "externalId";
		case "contactsTableFirstNameColumn": return "firstName";
		case "contactsTableLastNameColumn": return "lastName";
		case "contactsTableTotalSubCountColumn": return "totalSubCount";
		case "contactsRepSubmittedColumn": return "repSubmitted";
		case "contactsTableStatusColumn": return "consentStatus";
		default: return "email";
	}
}

function getContactHelperInitialSortDirection() {
    return contactHelperTableParams.sortOrder === 'desc' ? 'tableHeaderSortDown' : 'tableHeaderSortUp';
}

var contactsTable;

function showContactsTable(contacts, options, initialSort, sortDirection, fromSearch) {
	$('.contactsTableError').hide();
	loadingLiveContactsTable = false;

	 var isLiveOrHelper = atheneumInstance.Theme.getBooleanProperty("liveContactsTable", false) || !!atheneumInstance.Contacts.contactHelper;

	if(!initialSort && isLiveOrHelper)
		initialSort = "contactsTableEmailColumn";
		
	if(!sortDirection && isLiveOrHelper)	
		sortDirection = "tableHeaderSortUp";
	
	if(!isLiveOrHelper)
	{
		contacts = Array.prototype.slice.call(contacts || [ ]).sort(function(a, b) {
			if(!a.email && !b.email) return 0;
			if(!a.email) return -1;
			if(!b.email) return 1;
			if(a.email.toLowerCase() < b.email.toLowerCase()) return -1;
			if(a.email.toLowerCase() > b.email.toLowerCase()) return 1;
			return 0;
		});
	}

	try {
		if (contactsTable && contacts.length == contactsTable.rows()[0].length && !isLiveOrHelper)
			return;

			let TRUE_VALUES = ['on', 'true', 'y', 'yes', true]
		if(Array.isArray(contacts) && !TRUE_VALUES.includes(atheneumInstance.User.test)){
			contacts = contacts.filter(x=> !x.hasOwnProperty('test')  || !x.test)
		}
		
	} catch (err) { }


	var tableHeader = "";

	var contactsColumnList = atheneumInstance.Theme.getStringArrayProperty('contactsScreenColumns', [ ]);
	contactsColumns = [];

	if(contactsColumnList == null || contactsColumnList.length == 0) {
		if (atheneumInstance.Theme.getBooleanProperty('showContactsEmail', true)) {
			contactsColumns.push({ name:'email', translationKey:'contactsScreenEmail', translationDefault:'Email&nbsp;Address', columnClass:'contactsTableEmailColumn' });
		}

		if (atheneumInstance.Theme.getBooleanProperty('showContactsExternalId', 'on')) {
			contactsColumns.push({ name:'externalId', translationKey:'contactsScreenExternalId', translationDefault:'External Id', columnClass:'contactsTableExternalIdColumn' });
		}

		if (atheneumInstance.Theme.getBooleanProperty('showContactsFirstName', true)) {
			contactsColumns.push({ name:'firstName', translationKey:'contactsScreenFirstName', translationDefault:'First&nbsp;Name', columnClass:'contactsTableFirstNameColumn' });
		}
		if (atheneumInstance.Theme.getBooleanProperty('showContactsLastName', true)) {
			contactsColumns.push({ name:'lastName', translationKey:'contactsScreenLastName', translationDefault:'Last&nbsp;Name', columnClass:'contactsTableLastNameColumn' });
		}
		if (atheneumInstance.Theme.getBooleanProperty('showContactsTotalSubCount', true)) {
			contactsColumns.push({ name:'totalSubCount', translationKey:'contactsScreenTotalSubCount', translationDefault:'Total Submissions Count', columnClass:'contactsTableTotalSubCountColumn' });
		}
		if (atheneumInstance.Theme.getBooleanProperty('showContactsRepSubmitted', false)) {
			contactsColumns.push({ name:'repSubmitted', translationKey:'contactsRepSubmitted', translationDefault:'Rep&nbsp;Submitted&nbsp;- <br>Consent&nbsp;gained', columnClass:'contactsTableRepSubmittedColumn' });
		}
		if (atheneumInstance.Theme.getBooleanProperty('showContactsStatus', true)) {
			contactsColumns.push({ name:'consentStatus', translationKey:'contactsScreenStatus', translationDefault:'Consent&nbsp;Status', columnClass:'contactsTableStatusColumn' });
		}

		contactsColumns.push({ name:'applyFormColumns', translationKey:'applyFormColumnsReplacement', translationDefault:'ReplaceMe', columnClass:'applyFormColumns' });
		
		if (atheneumInstance.Theme.getBooleanProperty('showContactsStatusInfo', true)) {
			contactsColumns.push({ name:'info', translationKey:'contactsScreenConsentStatusInfo', translationDefault:'', columnClass:'contactsTableStatusInfoColumn' });
		}
		if (atheneumInstance.Theme.getBooleanProperty('showContactsDownloadSubmission', true)) {
			contactsColumns.push({ name:'download', translationKey:'contactsScreenDownloadSubmission', translationDefault:'', columnClass:'contactsTableDownloadSubmissionColumn' });
		}
			
	}
	else {
		for(var c=0; c<contactsColumnList.length; c++) {
			var columnName = contactsColumnList[c].trim();
			if(!columnName) {
				continue;
			}
			var columnBaseName = columnName;
			if(columnName == 'download') {
				columnBaseName = 'downloadSubmission';
			}
			else if(columnName == 'info') {
				columnBaseName = 'statusInfo';
			}
			
			var translationDefault = null;
			// TODO - get from form
			if(translationDefault == null) {
				if(columnName == 'email') {
					translationDefault = 'Email&nbsp;Address';
				}
				if(columnName == 'firstName') {
					translationDefault = 'First&nbsp;Name';
				}
				if(columnName == 'lastName') {
					translationDefault = 'Last&nbsp;Name';
				}
				if(columnName == 'repSubmitted') {
					translationDefault = 'Rep&nbsp;Submitted&nbsp;- <br>Consent&nbsp;gained';
				}
				if(columnName == 'totalSubCount') {
					translationDefault = 'Total Submissions Count';
				}
				if(columnName == 'consentStatus') {
					translationDefault = 'Consent&nbsp;Status';
				}
				if(columnName == 'info') {
					translationDefault = '';
				}
				if(columnName == 'download') {
					translationDefault = '';
				}
			}
			if(translationDefault == null) {
				translationDefault = columnName.charAt(0).toUpperCase() + columnName.substring(1);
			}
			
			
			var translationKey = 'contactsScreen' + columnBaseName.charAt(0).toUpperCase() + columnBaseName.substring(1);
			if(columnName == 'repSubmitted') {
				translationKey = 'contactsRepSubmitted';
			}
			else if(columnName == 'consentStatus') {
				translationKey = 'contactsScreenStatus';
			}
			
			var columnClass = 'contactsTable' + columnBaseName.charAt(0).toUpperCase() + columnBaseName.substring(1) + 'Column';
			if(columnName == 'consentStatus') {
				columnClass = 'contactsTableStatusColumn';
			}
			
			var column = { 'name': columnName, 'translationDefault': translationDefault, 'translationKey': translationKey, 'columnClass': columnClass };
						
			contactsColumns.push(column);
		}
	}
	
	var emailColumnClass = null;
	
	for(var c=0; c<contactsColumns.length; c++) {
		var column = contactsColumns[c];
		if(column.name === 'applyFormColumns'){
			if (formColumns.length > 0) {
				for (var i = 0; i < formColumns.length; i++) {
					var customRules = formColumns[i].formSubmissionCustomRules;
					if (customRules) {
						tableHeader += "<th class='tableHeader contactsTableFormColumnHeader'>" + formColumns[i].formSubmissionsColumnName + "</th>";
					}
				}
			}	
			continue;
		}
		var columnHtml = 
			'<th'
			+ (column.translationKey ? (' data-translation-rendered="true" data-translation-key="' + column.translationKey +  '"') : '')
			+ (column.translationDefault != undefined ? (' data-translation-default="' + column.translationDefault +  '"') : '')
			+ ' class="tableHeader' + (column.columnClass != undefined ? (' ' + column.columnClass) : '') + '"'
			+ '>'
			+ (column.translationKey ? atheneumInstance.Translation.getOrGetThemeKey(column.translationKey, column.translationDefault || '') : (column.translationDefault || '') )
			+ '</th>';
		
		tableHeader += columnHtml;
		
		if(column.name == 'email') {
			emailColumnClass = column.columnClass;
		}

	}
	
	if (contactsTable)
		contactsTable.destroy(false);

	$('#contactsTable thead tr').html("");
	$('#contactsTable thead tr').append(tableHeader);

	$('th.tableHeader').removeClass("tableHeaderSortUp");
	$('th.tableHeader').removeClass("tableHeaderSortDown");
	$('th.'+initialSort).addClass(sortDirection);


	$("th.tableHeader").off("click").on("click", function(e) {
		if (loadingLiveContactsTable) return;
	
		var isLiveTable = atheneumInstance.Theme.getBooleanProperty("liveContactsTable", false);
		var isContactHelper = !!atheneumInstance.Contacts.contactHelper;
	
		if (!isLiveTable && !isContactHelper) {
			return;
		}
		
		loadingLiveContactsTable = trueS;
		
		var columnToSort = "contactsTableEmailColumn";
		var currentSortDirection = 'none';
		var classList = $(this).attr('class').split(/\s+/);
		for (var i = 0; i < classList.length; i++) {
			if (classList[i].indexOf("Column") >= 0) {
				columnToSort = classList[i];
			} else if (classList[i] === "tableHeaderSortDown") {
				currentSortDirection = 'down';
			} else if (classList[i] === "tableHeaderSortUp") {
				currentSortDirection = 'up';
			}
		}
	
		var newSortDirection = 'ASC';
		var newSortClassName = "tableHeaderSortUp";
		if (currentSortDirection === 'up') {
			newSortDirection = 'DESC';
			newSortClassName = "tableHeaderSortDown";
		}
	
		$('th.tableHeader').removeClass("tableHeaderSortUp").removeClass("tableHeaderSortDown");
		$('th.' + columnToSort).addClass(newSortClassName);
	
		if (isLiveTable) {
			setupSortingForLiveContacts(columnToSort, newSortDirection);
			updateLiveContactsTable();
		} else if (isContactHelper) {
			loadingLiveContactsTable = false;
			contactHelperTableParams.sortBy = getContactHelperSortNameFromColumn(columnToSort);
			contactHelperTableParams.sortOrder = newSortDirection.toLowerCase();
			updateContactHelperTable();
		}
	});


	$('#contactsTable tbody').html("");

	let enStatusMap = {
    	'SUBSCRIBED': 'Approved',
    	'SUBSCRIBED_PENDING': 'Approved',
    	'PENDING': 'Pending',
    	'UNSUBSCRIBED': 'Declined',
    	'VERBAL': 'Verbal',
    };

	for (var i = 0; i < contacts.length; i++) {

		var rowClass="even";
		if (i%2==0) {
			rowClass = "odd";
		}
		var tableRow = "<tr class='"+ rowClass+"' id='" + contacts[i].id + "'>";
		
		for(var c=0; c<contactsColumns.length; c++) {
			var column = contactsColumns[c];
			var info = contacts[i].info || {};

			if(column.name == 'email') {
				tableRow += '<td class="' + (column.columnClass ? column.columnClass : 'contactsTableEmailColumn')
								+ '">' + (contacts[i].email || info.email || '&nbsp') + '</td>';
			}else if(column.name == 'externalId'){
				tableRow += "<td class='contactsTableExternalIdColumn'>" + (contacts[i].externalId || info.externalId || '&nbsp') + "</td>";
			}
			else if(column.name == 'totalSubCount') {
				tableRow += "<td class='contactsTableTotalSubCountColumn'><span style='visibility:hidden; position:absolute;'>" + contacts[i].totalFormSubmissions + "</span><input type='button' class='contactsTableTotalSubCountColumn " + getTrafficLightClassForContactsScreen(contacts[i].totalFormSubmissions) + "' value='" + contacts[i].totalFormSubmissions + "'></td>";
			}else if(column.name == 'repSubmitted') {
				var isRepSubmitted = !!(contacts[i].repSubmitted);
				tableRow += '<td class="' + (column.columnClass ? column.columnClass : 'contactsTableRepSubmittedColumn') + '">'
					  	 +     '<div class="atheneum-form-field atheneum-tick"><input class="readonly ignore" onclick="return false;" type="checkbox" data-type="CHECKBOX" name="isRepSubmitted" autocomplete="off" '+ (isRepSubmitted ? ' checked' : '') +' /><label style="display:none" for="isRepSubmitted">'+isRepSubmitted+'</label></div>'
					     + '</td>';
			}
			else if(column.name == 'consentStatus') {
				tableRow += "<td class='contactsTableStatusColumn'><span style='visibility:hidden; position:absolute;'>" + contacts[i].status + "</span><input type='button' class='contactsTableStatusColumn " + contacts[i].status + "' value='" + contacts[i].status + "'></td>";
			}else if(column.name === 'applyFormColumns'){
				tableRow += addFormColumnRowsToContactTable(contacts[i]);
			}
			else if(column.name == 'info') {
				// TODO
				if (!contacts[i].info.formSubmissionPdfUrl) {
		    		tableRow += '<td><input type="button" class="' + (column.columnClass ? column.columnClass : 'contactsTableStatusColumn') + ' disabled"/></td>';
		    	} else {
		    		var url = JSON.stringify(contacts[i].info.formSubmissionPdfUrl);
		    		var pdfPreview = null;
		    		if (atheneumInstance.Theme.getBooleanProperty('showFormSubmissionPdfPopup', false)) {
		    			pdfPreview='window.open(' + url + ', "_blank", "toolbar=yes,scrollbars=yes,resizable=yes")';
		    		} else {
		    			pdfPreview='window.open(' + url + ')';
		    		}
		    		tableRow += "<td><input type='button' class='" + (column.columnClass ? column.columnClass : 'contactsTableStatusColumn') + "'" 
		    				 +  (contacts[i].info.formSubmissionPdfUrl ? " onclick='"+ pdfPreview +"; '" : "" )
		    				 +	"></td>";
		    	}
			}
			else if(column.name == 'download') {
				if (!contacts[i].info.formSubmissionPdfUrl) {
					tableRow += '<td class="'
							 + (column.columnClass ? column.columnClass : 'contactsTableDownloadSubmissionColumn')
							 + '"><input type="button" class="'
							 + (column.columnClass ? column.columnClass : 'contactsTableDownloadSubmissionColumn')
							 + ' disabled"/></td>';
		    	} else {
		    		tableRow += '<td class="'
							 + (column.columnClass ? column.columnClass : 'contactsTableDownloadSubmissionColumn')
							 + '"><input type="button" class="'
							 + (column.columnClass ? column.columnClass : 'contactsTableDownloadSubmissionColumn')
							 + '"'
		    				 +  (contacts[i].info.formSubmissionPdfUrl ? " onclick='downloadFile(" + JSON.stringify(contacts[i].info.formSubmissionPdfUrl) + "); '" : "" )
		    				 +	"></td>";
		    	}
			}
			else {
				tableRow += '<td class="' + (column.columnClass ? column.columnClass : '') + '">' + (contacts[i].info[column.name] || '&nbsp') + "</td>";
			}
		}
	    
	    $('#contactsTable tbody').append(tableRow);
	}

	if( atheneumInstance.Theme.getBooleanProperty('showContactsDownloadSubmission', true))
	{
		$('th.tableHeader').removeClass("tableHeaderSortUp");
		$('th.tableHeader').removeClass("tableHeaderSortDown");
		$('th.'+initialSort).addClass(sortDirection);
		$("th.tableHeader").off("click").on("click",function(e) {
			if (loadingLiveContactsTable) return;
	
		var isLiveTable = atheneumInstance.Theme.getBooleanProperty("liveContactsTable", false);
		var isContactHelper = !!atheneumInstance.Contacts.contactHelper;
	
		if (!isLiveTable && !isContactHelper) {
			return;
		}
		
		loadingLiveContactsTable = true;
		
		var columnToSort = "contactsTableEmailColumn";
		var currentSortDirection = 'none';
		var classList = $(this).attr('class').split(/\s+/);
		for (var i = 0; i < classList.length; i++) {
			if (classList[i].indexOf("Column") >= 0) {
				columnToSort = classList[i];
			} else if (classList[i] === "tableHeaderSortDown") {
				currentSortDirection = 'down';
			} else if (classList[i] === "tableHeaderSortUp") {
				currentSortDirection = 'up';
			}
		}
	
		var newSortDirection = 'ASC';
		var newSortClassName = "tableHeaderSortUp";
		if (currentSortDirection === 'up') {
			newSortDirection = 'DESC';
			newSortClassName = "tableHeaderSortDown";
		}
	
		$('th.tableHeader').removeClass("tableHeaderSortUp").removeClass("tableHeaderSortDown");
		$('th.' + columnToSort).addClass(newSortClassName);
	
		if (isLiveTable) {
			setupSortingForLiveContacts(columnToSort, newSortDirection);
			updateLiveContactsTable();
		} else if (isContactHelper) {
			loadingLiveContactsTable = false;
			contactHelperTableParams.sortBy = getContactHelperSortNameFromColumn(columnToSort);
			contactHelperTableParams.sortOrder = newSortDirection.toLowerCase();
			updateContactHelperTable();
		}
	});
	}

	let orderArr = SalesToolkit.Theme.getStringProperty('contactSortingJSON', '[[0, "asc"], [1, "asc"]]');
	try {
		orderArr = JSON.parse(orderArr);
		if (!Array.isArray(orderArr)) {
			orderArr = [[0, 'asc'], [1, 'asc']];
        }
	} catch (err) {
		orderArr = [[0, 'asc'], [1, 'asc']];
    }

	var dtOptions = {
		"order": [[0, 'asc'], [1, 'asc']],
		"pageLength": 10,
		"pagingType": "full_numbers",
		"paging": true,
		"responsive": true,
		language: {
			"decimal": atheneumInstance.Translation.get("decimal", ""),
			"emptyTable": atheneumInstance.Translation.get("emptyTable", "No data available in table"),
			"info": atheneumInstance.Translation.get("info", "Presenting _START_ to _END_ of _TOTAL_ entries"),
			"infoEmpty": atheneumInstance.Translation.get("infoEmpty", "Showing 0 to 0 of 0 entries"),
			"infoFiltered": atheneumInstance.Translation.get("infoFiltered", "(filtered from _MAX_ total entries)"),
			"infoPostFix": atheneumInstance.Translation.get("infoPostFix", ""),
			"thousands": atheneumInstance.Translation.get("thousands", ","),
			"lengthMenu": atheneumInstance.Translation.get("lengthMenu", "Show _MENU_ entries"),
			"loadingRecords": atheneumInstance.Translation.get("loadingRecords", "Loading..."),
			"processing": atheneumInstance.Translation.get("processing", "Processing..."),
			"search": atheneumInstance.Translation.get("search", "Search") + ":",
			"zeroRecords": atheneumInstance.Translation.get("zeroRecords", "No matching records found"),
			"paginate": {
				"first": atheneumInstance.Translation.get("first", "<<"),
				"last": atheneumInstance.Translation.get("last", ">>"),
				"next": atheneumInstance.Translation.get("next", ">"),
				"previous": atheneumInstance.Translation.get("previous", "<")
			},
			"aria": {
				"sortAscending": atheneumInstance.Translation.get("sortAscending", ": activate to sort column ascending"),
				"sortDescending": atheneumInstance.Translation.get("sortDescending", ": activate to sort column descending")
			}
		}
	}

	if(isLiveOrHelper){
		dtOptions.paging = false;
        dtOptions.searching = false;
        dtOptions.info = false;
        dtOptions.ordering = false;
	}

	contactsTable = $('#contactsTable').DataTable(dtOptions);

	 if(isLiveOrHelper) {
        $('.dataTables_filter, .dataTables_paginate, .dataTables_length, .dataTables_info').hide();
    } else {
         $('.dataTables_filter, .dataTables_paginate, .dataTables_length, .dataTables_info').show();
    }

	let input = $('#contactsTable_filter').find('input').get(0);
	if(typeof input === 'undefined')
		return;
	input.setAttribute('autocomplete', 'off')
	input.setAttribute('autocorrect', 'off')
	input.setAttribute('autocapitalize', 'off')
	input.setAttribute('spellcheck', false)

	if (SalesToolkit.CrossPlatform.enabled && SalesToolkit.CrossPlatform.isIOS()) {
		//SAFARI refuses to update the change to the html for the showing info, hiding then showing seems to force it to render
		$('#contactsTable_filter').find('input').on('input', function () {
			$('#contactsTable_info').hide();
			setTimeout(function () { $('#contactsTable_info').show(); }, 100);

		});
    }
}

function getTrafficLightClassForContactsScreen(totalFormSubmissions) {
	result = "";
	var contactsScreenTotalFormsSubmissionsCountRed = atheneumInstance.Theme.getIntegerProperty('contactsScreenTotalFormsSubmissionsCountRed', 3);
	var contactsScreenTotalFormsSubmissionsCountAmber = atheneumInstance.Theme.getIntegerProperty('contactsScreenTotalFormsSubmissionsCountAmber', 2);
	var contactsScreenTotalFormsSubmissionsCountGreen = atheneumInstance.Theme.getIntegerProperty('contactsScreenTotalFormsSubmissionsCountGreen', 1);

	if (totalFormSubmissions >= contactsScreenTotalFormsSubmissionsCountRed) {
		result = 'trafficLightColourRed';
	} else if (totalFormSubmissions >= contactsScreenTotalFormsSubmissionsCountAmber) {
		result = 'trafficLightColourAmber';
	} else if (totalFormSubmissions <= contactsScreenTotalFormsSubmissionsCountGreen) {
		result = 'trafficLightColourGreen';
	}

	return result;
}

function addFormColumnRowsToContactTable(contact) {
	var row = '';
	if (formColumns.length > 0) {
		for (var j = 0; j < formColumns.length; j++) {
			var totalFormSubmissions = (contact.formSubmissionsCount && contact.formSubmissionsCount[formColumns[j].formId]) || 0;
			var customRules = formColumns[j].formSubmissionCustomRules;
			var formSubmissionsType = formColumns[j].formSubmissionsType;
			if (customRules) {
				var rule = findActiveRule(totalFormSubmissions, customRules);
				if(typeof rule.textColour === 'undefined'){
					rule.textColour = colourString(atheneumInstance.Theme.getColourProperty('contactRuleBackupTextColour', 'FFFFFF')).replaceAll('#', '');
				}
				row += "<td class='contactsTableFormColumn' data-formId='" + formColumns[j].formId + "' data-formSubmissionsCount='" + totalFormSubmissions + "'><span style='visibility:hidden; position:absolute;'>" + (formSubmissionsType == 0 ? totalFormSubmissions : rule.text) + "</span><input type='button' class='contactsTableFormColumnBtn' value='" + (formSubmissionsType == 0 ? totalFormSubmissions : rule.text) + "' style='color:#"+rule.textColour+"; background:#" + rule.colour + "'></td>";
			}	
		}	
	}
	return row;
}

function getFormColumnRowsToContactTable(contact) {
	var row = '';
	if (formColumns.length > 0) {
		for (var j = 0; j < formColumns.length; j++) {
			var totalFormSubmissions = contact.formSubmissionsCount[formColumns[j].formId] || 0;
			var customRules = formColumns[j].formSubmissionCustomRules;
			var formSubmissionsType = formColumns[j].formSubmissionsType;
			if (customRules) {
				var rule = findActiveRule(totalFormSubmissions, customRules);
				if(typeof rule.textColour === 'undefined'){
					rule.textColour = colourString(atheneumInstance.Theme.getColourProperty('contactRuleBackupTextColour', 'FFFFFF')).replaceAll('#', '');
				}
				row += "<td class='contactsTableFormColumn' data-formId='" + formColumns[j].formId + "' data-formSubmissionsCount='" + totalFormSubmissions + "'><span style='visibility:hidden; position:absolute;'>" + (formSubmissionsType == 0 ? totalFormSubmissions : rule.text) + "</span><input type='button' class='contactsTableFormColumnBtn' value='" + (formSubmissionsType == 0 ? totalFormSubmissions : rule.text) + "' style='color:#"+rule.textColour+"; background:#" + rule.colour + "'></td>";
			}	
		}	
	}
	return row;
}

function findActiveRule(formSubmissionsCount, customRules) {
	var rule = {
		colour : '',
		text : ''
	}
	for (var k = 0; k < customRules.length; k++) {
		if (customRules[k].operator == "EQUALS") {
			if (formSubmissionsCount == customRules[k].min) {
				rule.colour = customRules[k].colour;
				rule.text = customRules[k].value;
				break;
			}
		} else if (customRules[k].operator == "AT_LEAST") {
			if (formSubmissionsCount <= customRules[k].min) {
				rule.colour = customRules[k].colour;
				rule.text = customRules[k].value;
				break;
			}
		} else if (customRules[k].operator == "AT_MOST") {
			if (formSubmissionsCount >= customRules[k].max) {
				rule.colour = customRules[k].colour;
				rule.text = customRules[k].value;
				break;
			}	
		} else if (customRules[k].operator == "BETWEEN") {
			if (customRules[k].min <= formSubmissionsCount && formSubmissionsCount <= customRules[k].max) {
				rule.colour = customRules[k].colour;
				rule.text = customRules[k].value;
				break;
			}	
		}	
	}
	return rule;
}

function getFormColumnInfoById(formId) {
	if (formColumns.length > 0) {
		for (var j = 0; j < formColumns.length; j++) {
			if (formColumns[j].formId == formId) 
				return formColumns[j];
		}
	}
	return null;
}

function editContactTableFormColumnRows(contact) {
	var existedRows = $('#' + contact.id).find('.contactsTableFormColumn');
	for (var i=0; i<existedRows.length; i++) {
		var row = $(existedRows[i]);
		var formId = row.attr('data-formId');
		var newFormSubmissionsCount = contact.formSubmissionsCount[formId] || 0;
		var oldFormSubmissionsCount = row.attr('data-formSubmissionsCount');
		if (newFormSubmissionsCount == oldFormSubmissionsCount) {
			continue;
		}
		row.attr('data-formSubmissionsCount', newFormSubmissionsCount);
		var columnInfo = getFormColumnInfoById(formId);
		var customRules = columnInfo.formSubmissionCustomRules;
		var formSubmissionsType = columnInfo.formSubmissionsType;
		if (customRules) {
			var rule = findActiveRule(newFormSubmissionsCount, customRules);
			row.find('span').text((formSubmissionsType == 0 ? newFormSubmissionsCount : rule.text));
			row.find('input').val((formSubmissionsType == 0 ? newFormSubmissionsCount : rule.text)).css('background', '#' + rule.colour);
		}		
	}
}

function editContactsTable(contacts) {

	for (var i = 0; i < contacts.length; i++) {
		var existedRow = $('#' + contacts[i].id);

		if (existedRow.length > 0) {
			existedRow.find('.contactsTableExternalIdColumn').text(contacts[i].externalId || contacts[i].info.externalId || '&nbsp');
			existedRow.find('.contactsTableEmailColumn').text(contacts[i].email || contacts[i].info.email || '&nbsp');
			existedRow.find('.contactsTableFirstNameColumn').text(contacts[i].info.firstName);
			existedRow.find('.contactsTableLastNameColumn').text(contacts[i].info.lastName);
			existedRow.find('input.contactsTableTotalSubCountColumn')
				.attr('class', 'contactsTableTotalSubCountColumn ' + getTrafficLightClassForContactsScreen(contacts[i].totalFormSubmissions))
				.val(contacts[i].totalFormSubmissions);

				var isRepSubmitted = contacts[i].repSubmitted;
			existingRow.find('.contactsTableRepSubmittedColumn .atheneum-tick input')
			  .prop('checked' , isRepSubmitted);
			  existingRow.find('.contactsTableRepSubmittedColumn .atheneum-tick label')
			  .text(isRepSubmitted);


			existedRow.find('input.contactsTableStatusColumn')
				.attr('class', 'contactsTableStatusColumn ' + contacts[i].status)
				.val(atheneumInstance.Translation.getOrGetThemeKey('contactsTableStatusColumn ' + contacts[i].status, contacts[i].status));
			
			editContactTableFormColumnRows(contacts[i]);
			
			if (contacts[i].info.formSubmissionPdfUrl && existedRow.find('.contactsTableStatusInfoColumn.disabled').length > 0) {
				var url = JSON.stringify(contacts[i].info.formSubmissionPdfUrl);
				var pdfPreview = null;
				if (atheneumInstance.Theme.getBooleanProperty('showFormSubmissionPdfPopup', false)) {
					pdfPreview = 'window.open(' + url + ', "_blank", "toolbar=yes,scrollbars=yes,resizable=yes")';
				} else {
					pdfPreview = 'window.open(' + url + ')';
				}
				existedRow.find('.contactsTableStatusInfoColumn')
					.removeClass('disabled')
					.attr('onClick', pdfPreview);
			}

			if (contacts[i].info.formSubmissionPdfUrl && existedRow.find('.contactsTableDownloadSubmissionColumn.disabled').length > 0) {
				existedRow.find('.contactsTableDownloadSubmissionColumn')
					.removeClass('disabled')
					.attr('onClick', 'downloadFile(' + JSON.stringify(contacts[i].info.formSubmissionPdfUrl) + '); ');
			}
		} else {
			var rowClass = "even";
			if (i % 2 == 0) {
				rowClass = "odd";
			}
			var tableRow = "<tr class='" + rowClass + "' id='" + contacts[i].id + "'>";

			if (atheneumInstance.Theme.getBooleanProperty('showContactsEmail', true)) {
				tableRow += "<td class='contactsTableEmailColumn'>" + (contacts[i].email || contacts[i].info.email || '&nbsp') + "</td>";
			}
			
			if (atheneumInstance.Theme.getBooleanProperty('showContactsExternalId', true)) {
				tableRow += "<td class='contactsTableExternalIdColumn'>" + (contacts[i].externalId || contacts[i].info.externalId || '&nbsp') + "</td>";
			}

			if (atheneumInstance.Theme.getBooleanProperty('showContactsFirstName', true)) {
				tableRow += "<td class='contactsTableFirstNameColumn'>" + contacts[i].info.firstName + "</td>";
			}

			if (atheneumInstance.Theme.getBooleanProperty('showContactsLastName', true)) {
				tableRow += "<td class='contactsTableLastNameColumn'>" + contacts[i].info.lastName + "</td>";
			}

			if (atheneumInstance.Theme.getBooleanProperty('showContactsTotalSubCount', true)) {
				tableRow += "<td class='contactsTableTotalSubCountColumn'><span style='visibility:hidden; position:absolute;'>" + contacts[i].totalFormSubmissions + "</span><input type='button' class='contactsTableTotalSubCountColumn " + getTrafficLightClassForContactsScreen(contacts[i].totalFormSubmissions) + "' value='" + contacts[i].totalFormSubmissions + "'></td>";
			}

			if (atheneumInstance.Theme.getBooleanProperty('showContactsStatus', true)) {
				tableRow += "<td class='contactsTableStatusColumn'><span style='visibility:hidden; position:absolute;'>" + contacts[i].status + "</span><input type='button' class='contactsTableStatusColumn " + contacts[i].status + "' value='" + contacts[i].status + "'></td>";
			}

			tableRow += addFormColumnRowsToContactTable(contacts[i]);

			if (atheneumInstance.Theme.getBooleanProperty('showContactsStatusInfo', true)) {
				if (!contacts[i].info.formSubmissionPdfUrl) {
					tableRow += "<td><input type='button' class='contactsTableStatusInfoColumn disabled'></td>";
				} else {
					var url = JSON.stringify(contacts[i].info.formSubmissionPdfUrl);
					var pdfPreview = null;
					if (atheneumInstance.Theme.getBooleanProperty('showFormSubmissionPdfPopup', false)) {
						pdfPreview = 'window.open(' + url + ', "_blank", "toolbar=yes,scrollbars=yes,resizable=yes")';
					} else {
						pdfPreview = 'window.open(' + url + ')';
					}
					tableRow += "<td><input type='button' class='contactsTableStatusInfoColumn'"
						+ (contacts[i].info.formSubmissionPdfUrl ? " onclick='" + pdfPreview + "; '" : "")
						+ "></td>";
				}
			}

			if (atheneumInstance.Theme.getBooleanProperty('showContactsDownloadSubmission', true)) {
				if (!contacts[i].info.formSubmissionPdfUrl) {
					tableRow += "<td class='contactsTableDownloadSubmissionColumn'><input type='button' class='contactsTableDownloadSubmissionColumn disabled'></td>";
				} else {
					tableRow += "<td class='contactsTableDownloadSubmissionColumn'>"
						+ "<input type='button' class='contactsTableDownloadSubmissionColumn'"
						+ (contacts[i].info.formSubmissionPdfUrl ? " onclick='downloadFile(" + JSON.stringify(contacts[i].info.formSubmissionPdfUrl) + "); '" : "")
						+ "></td>";
				}
			}
			$('#contactsTable tbody').append(tableRow).trigger('update');
			$("#contactsTable").tablesorter();
		}
	}
	if (contactsTable)
		contactsTable.draw();    
}

var meetingsTable;
var atendTable;


function downloadFile(fileURL, element) {
	if (!fileURL) {
		return;
	}

	if (atheneumInstance.CrossPlatform.enabled) {
		var buttonRect = { x: 0, y: 0, width: 0, height: 0 };
		if (element && element.getBoundingClientRect) {
			buttonRect = element.getBoundingClientRect() || { x: 0, y: 0, width: 0, height: 0 };
		}

		var callbacks = {

			success: function () {

			},

			failure: function () {
				var notificationBody = atheneumInstance.Translation.getFormatted('notificationDownloadingFailed', '{0} failed to download', [fileURL]);
				atheneumInstance.UI.Notifications.showCustomNotification("download", notificationBody);
			},

			progress: function (percentage) {
				console.log("progress = " + percentage);
			}
		}
		
		atheneumInstance.CrossPlatform.shareDocument(fileURL,
			buttonRect.x,
			buttonRect.y,
			buttonRect.width,
			buttonRect.height,
			"application.pdf",
			"consentSubmission.pdf",
			callbacks);
		return;
    }

	var oReq = new XMLHttpRequest();
	oReq.open("GET", fileURL, true);
	oReq.responseType = "blob";

	oReq.onload = function (oEvent) {
		if (oReq.readyState == 4) {
			var blob = oReq.response;
			var fileName = fileURL.substring(fileURL.lastIndexOf('/') + 1);
			if (window.navigator.msSaveOrOpenBlob) {
				// IE11
				window.navigator.msSaveOrOpenBlob(blob, fileName);
			} else {
				// Google chome, Firefox, ....
				var url = (window.URL || window.webkitURL).createObjectURL(blob);
				var a = document.createElement('a');
				a.setAttribute('download', fileName);
				a.setAttribute('href', url);
				a.click();
			}
		}
	};
	oReq.send();
}

function showMeetingsTable(meetings) {

	$('#meetingAttendeesSection').hide();
	$('#meetingSection').css('display', 'block');
	$('#meetingSection').show();

	var tableHeader = "";

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingName', 'on')) {
		tableHeader += "<th  data-translation-rendered='true' data-translation-key='meetingScreenNameTitle'"
			+ " data-translation-default='Name' class='tableHeader meetingTableNameColumn'>"
			+ atheneumInstance.Translation.getOrGetThemeKey('meetingScreenNameTitle', 'Name');
		+ "</th>";
	}

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingDate', 'on')) {
		tableHeader += "<th data-translation-rendered='true' data-translation-key='meetingScreenDateTitle'"
			+ " data-translation-default='Date' class='tableHeader meetingTableDateColumn'>"
			+ atheneumInstance.Translation.getOrGetThemeKey('meetingScreenDateTitle', 'Date');
		+ "</th>";
	}

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingNumberOfAttendees', 'on')) {
		tableHeader += "<th data-translation-rendered='true' data-translation-key='meetingScreenNumberOfAttendeesTitle'"
			+ " data-translation-default='Number of attendees' class='tableHeader meetingTableNumberOfAttendeesColumn'>"
			+ atheneumInstance.Translation.getOrGetThemeKey('meetingScreenNumberOfAttendeesTitle', 'Number of attendees');
		+ "</th>";
	}

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingViewAttendeesButton', 'on')) {
		tableHeader += "<th class='tableHeader meetingTableViewColumn'>" + atheneumInstance.Translation.get('meetingScreenViewTitle', '') + "</th>";
	}
	if (atheneumInstance.Theme.getBooleanProperty('showMeetingEditButton', 'on')) {
		tableHeader += "<th class='tableHeader meetingTableEditColumn'>" + atheneumInstance.Translation.get('meetingScreenEditTitle', '') +"</th>";
	}

	if (meetingsTable)
		$('#meetingTable').DataTable().destroy(false);

	$('#meetingTable thead tr').html("");
	$('#meetingTable thead tr').append(tableHeader);

	$('#meetingTable tbody').remove();
	$('#meetingTable').append('<tbody></tbody>');

	for (var i = 0; i < meetings.length; i++) {
		var rowClass = "even";
		if (i % 2 == 0) {
			rowClass = "odd";
		}
		var tableRow = "<tr class='" + rowClass + "'>";

		var collection = atheneumInstance.Library.collections[meetings[i].name]

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingName', 'on')) {
			tableRow += "<td class='meetingTableNameColumn'>" + meetings[i].info.name + "</td>";
		}

		var date = null;
		var dateString = meetings[i].info.date || meetings[i].info.startDate;
		var reggie = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/;
		var dateArray = reggie.exec(dateString);
		if (dateArray != null) {
			var dateObject = new Date(
				(+dateArray[3]),
				(+dateArray[2]) - 1,
				(+dateArray[1]),
				(+dateArray[4]),
				(+dateArray[5])
			);
			date = new Date(dateObject);
		}

		if (date == null) {
			tableRow += "<td data-sort='-1' class='meetingTableDateColumn'></td>";
		}
		else {
			var day = (date.getDate() < 10) ? "0" + date.getDate() : date.getDate();
			var month = ((date.getMonth() + 1) < 10) ? "0" + (date.getMonth() + 1) : (date.getMonth() + 1);
			var year = date.getFullYear();
			var hours = (date.getHours() < 10) ? "0" + date.getHours() : date.getHours();
			var minutes = (date.getMinutes() < 10) ? "0" + date.getMinutes() : date.getMinutes();

			if (atheneumInstance.Theme.getBooleanProperty('showMeetingDate', 'on')) {
				tableRow += "<td data-sort='"+date.getTime()+"' class='meetingTableDateColumn'>" + date.toLocaleString() + "</td>";
			}
		}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingNumberOfAttendees', 'on')) {
			tableRow += "<td class='meetingTableNumberOfAttendeesColumn'>" + (meetings[i].participants?.length || 0) + "</td>";
		}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingViewAttendeesButton', 'on')) {
			tableRow += "<td><input type='button' class='btn salestoolkit-blue btn-primary meetingTableViewColumn' value='View Attendees' onclick='showMeetingAttendeesScreen(\"" + meetings[i].id + "\", true); '></td>";
		}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingEditButton', 'on')) {
			tableRow += "<td><input type='button' class='btn salestoolkit-blue btn-primary meetingTableEditColumn' value='Edit' onclick='editMeeting(\"" + meetings[i].id + "\", " + (meetings[i].collection == null ? 'null' : ('\"' + meetings[i].collection.id + '\"')) +"); '></td>";
		}

		$('#meetingTable tbody').append(tableRow);

	}


	var options = {
		"order": [[1, "desc"]],
		"pageLength": 10,
		"pagingType": "full_numbers",
		"paging": true,
		columnDefs: [
			{ "searchable": false, targets: [3,4] },
			{ "orderable": false, targets: [3,4] }
		],
		language: {
			"decimal": atheneumInstance.Translation.get("decimal", ""),
			"emptyTable": atheneumInstance.Translation.get("emptyTable", "No data available in table"),
			"info": atheneumInstance.Translation.get("info", "Presenting _START_ to _END_ of _TOTAL_ entries"),
			"infoEmpty": atheneumInstance.Translation.get("infoEmpty", "Showing 0 to 0 of 0 entries"),
			"infoFiltered": atheneumInstance.Translation.get("infoFiltered", "(filtered from _MAX_ total entries)"),
			"infoPostFix": atheneumInstance.Translation.get("infoPostFix", ""),
			"thousands": atheneumInstance.Translation.get("thousands", ","),
			"lengthMenu": atheneumInstance.Translation.get("lengthMenu", "Show _MENU_ entries"),
			"loadingRecords": atheneumInstance.Translation.get("loadingRecords", "Loading..."),
			"processing": atheneumInstance.Translation.get("processing", "Processing..."),
			"search": atheneumInstance.Translation.get("search", "Search") + ":",
			"zeroRecords": atheneumInstance.Translation.get("zeroRecords", "No matching records found"),
			"paginate": {
				"first": atheneumInstance.Translation.get("first", "<<"),
				"last": atheneumInstance.Translation.get("last", ">>"),
				"next": atheneumInstance.Translation.get("next", ">"),
				"previous": atheneumInstance.Translation.get("previous", "<")
			},
			"aria": {
				"sortAscending": atheneumInstance.Translation.get("sortAscending", ": activate to sort column ascending"),
				"sortDescending": atheneumInstance.Translation.get("sortDescending", ": activate to sort column descending")
			}
		}
	}

	

	meetingsTable = $('#meetingTable').DataTable(options);

	let input = $('#meetingTable_filter').find('input').get(0);
	
	if(typeof input !== 'undefined'){
		input.setAttribute('autocomplete', 'off');
		input.setAttribute('autocorrect', 'off');
		input.setAttribute('autocapitalize', 'off');
		input.setAttribute('spellcheck', false);
	}

}

function showOfflineMeetings() {

	$('#meetingAttendeesSection').hide();
	$('#meetingSection').css('display', 'block');
	$('#meetingSection').show();

	var tableHeader = "";

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingName', 'on')) {
		tableHeader += "<th  data-translation-rendered='true' data-translation-key='meetingScreenNameTitle'"
			+ " data-translation-default='Name' class='tableHeader meetingTableNameColumn'>"
			+ atheneumInstance.Translation.getOrGetThemeKey('meetingScreenNameTitle', 'Name');
		+ "</th>";
	}

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingDate', 'on')) {
		tableHeader += "<th data-translation-rendered='true' data-translation-key='meetingScreenDateTitle'"
			+ " data-translation-default='Date' class='tableHeader meetingTableDateColumn'>"
			+ atheneumInstance.Translation.getOrGetThemeKey('meetingScreenDateTitle', 'Date');
		+ "</th>";
	}

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingNumberOfAttendees', 'on')) {
		tableHeader += "<th data-translation-rendered='true' data-translation-key='meetingScreenNumberOfAttendeesTitle'"
			+ " data-translation-default='Number of attendees' class='tableHeader meetingTableNumberOfAttendeesColumn'>"
			+ atheneumInstance.Translation.getOrGetThemeKey('meetingScreenNumberOfAttendeesTitle', 'Number of attendees');
		+ "</th>";
	}

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingViewAttendeesButton', 'on')) {
		tableHeader += "<th class='tableHeader meetingTableViewColumn'>" + atheneumInstance.Translation.get('meetingScreenViewTitle', '') + "</th>";
	}
	if (atheneumInstance.Theme.getBooleanProperty('showMeetingEditButton', 'on')) {
		tableHeader += "<th class='tableHeader meetingTableEditColumn'>" + atheneumInstance.Translation.get('meetingScreenEditTitle', '') +"</th>";
	}

	if (meetingsTable)
		$('#meetingTable').DataTable().destroy(false);

	$('#meetingTable thead tr').html("");
	$('#meetingTable thead tr').append(tableHeader);

	$('#meetingTable tbody').remove();
	$('#meetingTable').append('<tbody></tbody>');


	var options = {
		"order": [[1, "desc"]],
		"pageLength": 10,
		"pagingType": "full_numbers",
		"paging": true,
		columnDefs: [
			{ "searchable": false, targets: [3,4] },
			{ "orderable": false, targets: [3,4] }
		],
		language: {
			"decimal": atheneumInstance.Translation.get("decimal", ""),
			"emptyTable": atheneumInstance.Translation.get("offlineTable", "No data available while offline, please check your internet connection and try again."),
			"info": atheneumInstance.Translation.get("info", "Presenting _START_ to _END_ of _TOTAL_ entries"),
			"infoEmpty": atheneumInstance.Translation.get("infoEmpty", "Showing 0 to 0 of 0 entries"),
			"infoFiltered": atheneumInstance.Translation.get("infoFiltered", "(filtered from _MAX_ total entries)"),
			"infoPostFix": atheneumInstance.Translation.get("infoPostFix", ""),
			"thousands": atheneumInstance.Translation.get("thousands", ","),
			"lengthMenu": atheneumInstance.Translation.get("lengthMenu", "Show _MENU_ entries"),
			"loadingRecords": atheneumInstance.Translation.get("loadingRecords", "Loading..."),
			"processing": atheneumInstance.Translation.get("processing", "Processing..."),
			"search": atheneumInstance.Translation.get("search", "Search") + ":",
			"zeroRecords": atheneumInstance.Translation.get("zeroRecords", "No matching records found"),
			"paginate": {
				"first": atheneumInstance.Translation.get("first", "<<"),
				"last": atheneumInstance.Translation.get("last", ">>"),
				"next": atheneumInstance.Translation.get("next", ">"),
				"previous": atheneumInstance.Translation.get("previous", "<")
			},
			"aria": {
				"sortAscending": atheneumInstance.Translation.get("sortAscending", ": activate to sort column ascending"),
				"sortDescending": atheneumInstance.Translation.get("sortDescending", ": activate to sort column descending")
			}
		}
	}

	

	meetingsTable = $('#meetingTable').DataTable(options);
}


function showMeetingAttendeesScreen(meetingId, clearTimeout = false) {
	if(clearTimeout)
		window.clearTimeout(meetingAttendeeTimeOut);

	atheneumInstance.API.getMeeting(meetingId, {
		success: function (json) {
			var participants = json.meetings.participants || [];
			var statusUpdate = participants.filter(function (participants) {
				return ((participants.remoteConsentStatus == 'PENDING') || (json.meetings.info.allowAdHocParticipants == 'true'))
			}).length > 0;
			if ($('#meetingAttendeesSection').is(':visible')) {
				editAttendeeTable(participants);
			} else {
				showMeetingAttendeeTable(participants, json.meetings.info.name);
			}

			if (statusUpdate) {
				meetingAttendeeTimeOut = setTimeout(function () {
					if ($('#meetingAttendeesSection:visible').length == 0) {
						return;
					}

					showMeetingAttendeesScreen(meetingId);
				}, 10000);
			}
		},
		failure: function (reason, httpStatus, errorCode) {
			Atheneum.Callbacks.logFailureDetails(reason, httpStatus, errorCode, 'Atheneum.API.getMeetings');
		}
	});
}

function editAttendeeTable(participants) {
	if (atendTable)
	{
		$('#meetingAttendeesTable').DataTable().destroy(false);
		$('#meetingAttendeesTable tbody').empty();
	}	

	for (var i = 0; i < participants.length; i++) {
		var existedRow = $('#' + participants[i].id);

		if (existedRow.length > 0) {
			existedRow.find('.meetingAttendeeTableConsentStatusColumn')
				.attr('class', '')
				.addClass('meetingAttendeeTableConsentStatusColumn ' + participants[i].remoteConsentStatus)
				.val(participants[i].remoteConsentStatus);


			// OLD VERSION - might be worth doing this as a backup if (participants[i].remoteConsentStatus == 'COMPLETE' && existedRow.find('.meetingAttendeeTableConsentStatusInfoColumn.disabled').length > 0) {
			//	existedRow.find('.meetingAttendeeTableConsentStatusInfoColumn')
			//		.removeClass('disabled')
			//		.attr('onClick', 'showConsentStatusInfo(' + JSON.stringify(participants[i].notificationText) + ', ' + JSON.stringify(participants[i].id) + '); ');
			//}

			if (participants[i].info.formSubmissionPdfUrl && existedRow.find('.meetingAttendeeTableConsentStatusInfoColumn.disabled').length > 0) {
				var url = JSON.stringify(participants[i].info.formSubmissionPdfUrl);
				var pdfPreview = null;
				if (atheneumInstance.Theme.getBooleanProperty('showFormSubmissionPdfPopup', false)) {
					pdfPreview = url + "?toolbar=yes,scrollbars=yes,resizable=yes";
				} else {
					pdfPreview = url;
				}
				existedRow.find('.meetingAttendeeTableConsentStatusInfoColumn')
					.removeClass('disabled')
					.find('a')
					.attr('href', pdfPreview);
			}
			if (participants[i].info.formSubmissionPdfUrl && existedRow.find('.meetingAttendeeTableDownloadSubmissionColumn.disabled').length > 0) {
				existedRow.find('.meetingAttendeeTableDownloadSubmissionColumn')
					.removeClass('disabled')
					.attr('onClick', 'downloadFile(' + JSON.stringify(participants[i].info.formSubmissionPdfUrl) + ', this); ');
			}


			continue;
		}

		var rowClass = "even";
		if (i % 2 == 0) {
			rowClass = "odd";
		}
		var tableRow = "<tr class='" + rowClass + "' id='" + participants[i].id + "'>";
		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeEmail', 'on')) {
			tableRow += "<td class='meetingAttendeeTablEmailColumn'>" + participants[i].info.email + "</td>";
		}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeFirstName', 'on')) {
			tableRow += "<td class='meetingAttendeeTableFirstNameColumn'>" + (participants[i].info.firstName || '') + "</td>";
		}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeLastName', 'on')) {
			tableRow += "<td class='meetingAttendeeTableLastNameColumn'>" + (participants[i].info.lastName || '') + "</td>";
		}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeAdHoc', 'on')) {
			tableRow += "<td class='meetingAttendeeTableAdhocColumn'><span class='hidden'>" + (participants[i].adHoc == true ? true : false) + "</span><input  class='ignore' onclick='return false;' type='checkbox' "+(participants[i].adHoc == true ? 'checked' : '')+" /></td>";
		}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeConsentStatus', 'on')) {
			tableRow += "<td><span style='visibility:hidden; position:absolute;'>" + participants[i].remoteConsentStatus +"</span><input type='button' class='meetingAttendeeTableConsentStatusColumn " + participants[i].remoteConsentStatus + "' value='" + participants[i].remoteConsentStatus + "'></td>";
		}

		//OLD if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeConsentStatusInfo', 'on')) {
		//	if (participants[i].remoteConsentStatus == 'PENDING' || typeof participants[i].notificationText === 'undefined') {
		//		tableRow += "<td class='tdCentred' style='text-align:center;'><input type='button' class='meetingAttendeeTableConsentStatusInfoColumn disabled'></td>";
		//	} else {
		//		tableRow += "<td class='tdCentred' style='text-align:center;'><input type='button' class='meetingAttendeeTableConsentStatusInfoColumn' onclick='showConsentStatusInfo(" + JSON.stringify(participants[i].notificationText) + ', ' + JSON.stringify(participants[i].id) + "); '></td>";
		//	}
		//}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeConsentStatusInfo', true)) {
			if (!participants[i].info.formSubmissionPdfUrl) {
				tableRow += "<td><input type='button' class='meetingAttendeeTableConsentStatusInfoColumn disabled'></td>";
			} else {
				var url = JSON.stringify(participants[i].info.formSubmissionPdfUrl);
				var pdfPreview = null;
				if (atheneumInstance.Theme.getBooleanProperty('showFormSubmissionPdfPopup', false)) {
					pdfPreview = url + "?toolbar=yes,scrollbars=yes,resizable=yes";
				} else {
					pdfPreview = url;
				}
				tableRow += "<td><a href=" + pdfPreview + " > <input type='button' class='meetingAttendeeTableConsentStatusInfoColumn'></a></td>";
			}
		}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeDownloadSubmission', true)) {
			if (!participants[i].info.formSubmissionPdfUrl) {
				tableRow += "<td><input type='button' class='meetingAttendeeTableDownloadSubmissionColumn disabled'></td>";
			} else {
				tableRow += "<td class='meetingAttendeeTableDownloadSubmissionColumn'>"
					+ "<input type='button' class='meetingAttendeeTableDownloadSubmissionColumn'"
					+ (participants[i].info.formSubmissionPdfUrl ? " onclick='downloadFile(" + JSON.stringify(participants[i].info.formSubmissionPdfUrl) + ", this); '" : "")
					+ "></td>";
			}
		}

		$('#meetingAttendeesTable tbody').append(tableRow);

	}

	var options = {
		"order": [[0, "desc"]],
		"pageLength": 10,
		"pagingType": "full_numbers",
		"paging": true,
		language: {
			"decimal": atheneumInstance.Translation.get("decimal", ""),
			"emptyTable": atheneumInstance.Translation.get("emptyTable", "No data available in table"),
			"info": atheneumInstance.Translation.get("info", "Presenting _START_ to _END_ of _TOTAL_ entries"),
			"infoEmpty": atheneumInstance.Translation.get("infoEmpty", "Showing 0 to 0 of 0 entries"),
			"infoFiltered": atheneumInstance.Translation.get("infoFiltered", "(filtered from _MAX_ total entries)"),
			"infoPostFix": atheneumInstance.Translation.get("infoPostFix", ""),
			"thousands": atheneumInstance.Translation.get("thousands", ","),
			"lengthMenu": atheneumInstance.Translation.get("lengthMenu", "Show _MENU_ entries"),
			"loadingRecords": atheneumInstance.Translation.get("loadingRecords", "Loading..."),
			"processing": atheneumInstance.Translation.get("processing", "Processing..."),
			"search": atheneumInstance.Translation.get("search", "Search") + ":",
			"zeroRecords": atheneumInstance.Translation.get("zeroRecords", "No matching records found"),
			"paginate": {
				"first": atheneumInstance.Translation.get("first", "<<"),
				"last": atheneumInstance.Translation.get("last", ">>"),
				"next": atheneumInstance.Translation.get("next", ">"),
				"previous": atheneumInstance.Translation.get("previous", "<")
			},
			"aria": {
				"sortAscending": atheneumInstance.Translation.get("sortAscending", ": activate to sort column ascending"),
				"sortDescending": atheneumInstance.Translation.get("sortDescending", ": activate to sort column descending")
			}
		}
	}

	atendTable = $('#meetingAttendeesTable').DataTable(options);
}

function showMeetingAttendeeTable(participants, meetingName) {
	$('#meetingSection').hide();
	$('#meetingAttendeesSection').css('display', 'block');
	$('#meetingAttendeesSection').show();

	var tableHeader = "";

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeEmail', 'on')) {
		tableHeader += "<th data-translation-rendered='true' data-translation-key='meetingAttendeeScreenEmail'"
			+ " data-translation-default='Email' class='tableHeader meetingAttendeeTableEmailColumn'>"
			+ atheneumInstance.Translation.getOrGetThemeKey('meetingAttendeeScreenEmail', 'Email Address');
		+ "</th>";
	}

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeFirstName', 'on')) {
		tableHeader += "<th data-translation-rendered='true' data-translation-key='meetingAttendeeScreenFirstName'"
			+ " data-translation-default='First Name' class='tableHeader meetingAttendeeTableFirstNameColumn'>"
			+ atheneumInstance.Translation.getOrGetThemeKey('meetingAttendeeScreenFirstName', 'First Name');
		+ "</th>";
	}

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeLastName', 'on')) {
		tableHeader += "<th data-translation-rendered='true' data-translation-key='meetingAttendeeScreenLastName'"
			+ " data-translation-default='Last Name' class='tableHeader meetingAttendeeTableLastNameColumn'>"
			+ atheneumInstance.Translation.getOrGetThemeKey('meetingAttendeeScreenLastName', 'Last Name');
		+ "</th>";
	}

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeAdHoc', 'on')) {
		tableHeader += "<th data-translation-rendered='true' data-translation-key='meetingAttendeeScreenAdHoc'"
			+ " data-translation-default='Ad hoc' class='tableHeader meetingAttendeeTableAdhocColumn'>"
			+ atheneumInstance.Translation.getOrGetThemeKey('meetingAttendeeScreenAdHoc', 'Ad hoc');
		+ "</th>";
	}

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeConsentStatus', 'on')) {
		tableHeader += "<th data-translation-rendered='true' data-translation-key='meetingAttendeeScreenConsentStatus'"
			+ " data-translation-default='Consent Status' class='tableHeader meetingAttendeeTableConsentStatusColumn'>"
			+ atheneumInstance.Translation.getOrGetThemeKey('meetingAttendeeScreenConsentStatus', 'Consent Status');
		+ "</th>";
	}

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeConsentStatusInfo', 'on')) {
		tableHeader += "<th class='tableHeader meetingAttendeeTableConsentStatusInfoColumn'></th>";
	}

	if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeDownloadSubmission', true)) {
		tableHeader += "<th class='tableHeader meetingAttendeeTableDownloadSubmissionColumn'></th>";
	}

	if (atendTable)
		$('#meetingAttendeesTable').DataTable().destroy(false);

	$('#meetingAttendeesTable thead tr').html("");
	$('#meetingAttendeesTable thead tr').append(tableHeader);

	$('#meetingAttendeesTable tbody').html("");

	participants.sort(compareParticipants);

	for (var i = 0; i < participants.length; i++) {
		var rowClass = "even";
		if (i % 2 == 0) {
			rowClass = "odd";
		}
		var tableRow = "<tr class='" + rowClass + "' id='" + participants[i].id + "'>";

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeEmail', 'on')) {
			tableRow += "<td class='meetingAttendeeTableEmailColumn'>" + participants[i].info.email + "</td>";
		}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeFirstName', 'on')) {
			tableRow += "<td class='meetingAttendeeTableFirstNameColumn'>" + (participants[i].info.firstName || '') + "</td>";
		}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeLastName', 'on')) {
			tableRow += "<td class='meetingAttendeeTableLastNameColumn'>" + (participants[i].info.lastName || '') + "</td>";
		}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeAdHoc', 'on')) {
			tableRow += "<td class='meetingAttendeeTableAdhocColumn'><span class='hidden'>" + (participants[i].adHoc == true ? true : false) + "</span><input class='ignore' onclick='return false;' type='checkbox' " + (participants[i].adHoc == true ? 'checked' : '') + " /></td>";
		}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeConsentStatus', 'on')) {
			tableRow += "<td><span style='visibility:hidden; position:absolute;'>" + participants[i].remoteConsentStatus +"</span><input type='button' class='meetingAttendeeTableConsentStatusColumn " + participants[i].remoteConsentStatus + "' value='" + participants[i].remoteConsentStatus + "'></td>";
		}

		//OLD VERSION if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeConsentStatusInfo', 'on')) {
		//	if (participants[i].remoteConsentStatus == 'PENDING' || typeof participants[i].notificationText === 'undefined') {
		//		tableRow += "<td class='tdCentred'><input type='button' class='meetingAttendeeTableConsentStatusInfoColumn disabled'></td>";
		//	} else {
		//		tableRow += "<td class='tdCentred'><input type='button' class='meetingAttendeeTableConsentStatusInfoColumn' onclick='showConsentStatusInfo(" + JSON.stringify(participants[i].notificationText) + ', ' + JSON.stringify(participants[i].id) + "); '></td>";
		//	}
		//}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeConsentStatusInfo', true)) {
			if (!participants[i].info.formSubmissionPdfUrl) {
				tableRow += "<td><input type='button' class='meetingAttendeeTableConsentStatusInfoColumn disabled'></td>";
			} else {
				var url = JSON.stringify(participants[i].info.formSubmissionPdfUrl);
				var pdfPreview = null;
				if (atheneumInstance.Theme.getBooleanProperty('showFormSubmissionPdfPopup', false)) {
					pdfPreview = url + "?toolbar=yes,scrollbars=yes,resizable=yes";
				} else {
					pdfPreview = url;
				}
				tableRow += "<td><a href=" + pdfPreview + " ><input type='button' class='meetingAttendeeTableConsentStatusInfoColumn'></a></td>";
			}
		}

		if (atheneumInstance.Theme.getBooleanProperty('showMeetingAttendeeDownloadSubmission', true)) {
			if (!participants[i].info.formSubmissionPdfUrl) {
				tableRow += "<td><input type='button' class='meetingAttendeeTableDownloadSubmissionColumn disabled'></td>";
			} else {
				tableRow += "<td class='meetingAttendeeTableDownloadSubmissionColumn'>"
					+ "<input type='button' class='meetingAttendeeTableDownloadSubmissionColumn'"
					+ (participants[i].info.formSubmissionPdfUrl ? " onclick='downloadFile(" + JSON.stringify(participants[i].info.formSubmissionPdfUrl) + ", this); '" : "")
					+ "></td>";
			}
		}

		$('#meetingAttendeesTable tbody').append(tableRow);
	}

	var options = {
		"order": [[0, "desc"]],
		"pageLength": 10,
		"pagingType": "full_numbers",
		"paging": true,
		language: {
			"decimal": atheneumInstance.Translation.get("decimal", ""),
			"emptyTable": atheneumInstance.Translation.get("emptyTable", "No data available in table"),
			"info": atheneumInstance.Translation.get("info", "Presenting _START_ to _END_ of _TOTAL_ entries"),
			"infoEmpty": atheneumInstance.Translation.get("infoEmpty", "Showing 0 to 0 of 0 entries"),
			"infoFiltered": atheneumInstance.Translation.get("infoFiltered", "(filtered from _MAX_ total entries)"),
			"infoPostFix": atheneumInstance.Translation.get("infoPostFix", ""),
			"thousands": atheneumInstance.Translation.get("thousands", ","),
			"lengthMenu": atheneumInstance.Translation.get("lengthMenu", "Show _MENU_ entries"),
			"loadingRecords": atheneumInstance.Translation.get("loadingRecords", "Loading..."),
			"processing": atheneumInstance.Translation.get("processing", "Processing..."),
			"search": atheneumInstance.Translation.get("search", "Search") + ":",
			"zeroRecords": atheneumInstance.Translation.get("zeroRecords", "No matching records found"),
			"paginate": {
				"first": atheneumInstance.Translation.get("first", "<<"),
				"last": atheneumInstance.Translation.get("last", ">>"),
				"next": atheneumInstance.Translation.get("next", ">"),
				"previous": atheneumInstance.Translation.get("previous", "<")
			},
			"aria": {
				"sortAscending": atheneumInstance.Translation.get("sortAscending", ": activate to sort column ascending"),
				"sortDescending": atheneumInstance.Translation.get("sortDescending", ": activate to sort column descending")
			}
		}
	}

	if (atendTable)
		$('#meetingAttendeesTable').DataTable().destroy(false);

	atendTable = $('#meetingAttendeesTable').DataTable(options);

	let input = $('#meetingAttendeesTable_filter').find('input').get(0);

	if(typeof input !== 'undefined'){
		input.setAttribute('autocomplete', 'off');
		input.setAttribute('autocorrect', 'off');
		input.setAttribute('autocapitalize', 'off');
		input.setAttribute('spellcheck', false);	
	}


}

function showAttendeePopup() {
	$("#addAttendeePopupTitle").text(atheneumInstance.Translation.get('addAttendeeTitle', 'Add Attendee'));
	$("#addAttendeePopup .save-btn").hide();
	$("#addAttendeePopup .add-btn").hide();
	$("#addAttendeePopup .add-btn").show();
	clearForm($("#addAttendeeForm"));
	$("#addAttendeePopup").modal('show');
}

function showEditAttendeePopup(idAttendee) {
	$("#addAttendeePopupTitle").text(atheneumInstance.Translation.get('editAttendeeTitle', 'Edit Attendee'));
	$("#addAttendeePopup .save-btn").hide();
	$("#addAttendeePopup .add-btn").hide();
	$("#addAttendeePopup .save-btn").show();
		

	for (var i = 0; i < attendeeList.length; i++) {
		if (attendeeList[i].index == idAttendee) {
			$('#addAttendeeForm').data('attendeeId', idAttendee);
			populateFormWithAttendeeData($('#addAttendeeForm'), attendeeList[i]);
		}
	}

	$("#addAttendeePopup").modal('show');
}

function populateFormWithAttendeeData($form, attendee) {
	for (fieldName in attendee) {
		if (!(attendee.hasOwnProperty(fieldName))) {
			continue;
		}

		$field = $form.find(
			'.atheneum-form-field input[name="' + fieldName + '"]'
			+ ', .atheneum-form-field select[name="' + fieldName + '"]'
			+ ', .atheneum-form-field textarea[name="' + fieldName + '"]'
		);

		if ($field.length == 0) {
			// field capitalization may not match, do a slower case-insensitive check	
			var matches = [];
			var $fields = $form.find('.atheneum-form-field input[name], .atheneum-form-field select[name], .atheneum-form-field textarea[name]');
			$fields.each(function () {
				if ($(this).attr('name').toLowerCase() == fieldName.toLowerCase()) {
					matches.push(this);
				}
			});
			$field = $(matches);
		}
		setFieldValue($field, attendee[fieldName]);
	}
	handleDependencies($form);
}

function checkForTitleBug(result){
	if(!SalesToolkit.Theme.getBooleanProperty('checkForTitleBug', false)){
		return result;
	}

	if(typeof result !== 'object')
		return result;

	//'{"language":"en","id":"b0765ffa-1c09-4153-bd5e-d781a9f925bb","firstName":"Dr.","lastName":"Smith","middleName":"John","emails":[],"phones":[],"jobs":[{"company":"Verteo BIOPHARMA","title":""}],"websites":[],"notes":"","addresses":[]}'
	if(!result.hasOwnProperty('firstName') || !result.hasOwnProperty('lastName')){
		return result;
	}

	let titleArr = SalesToolkit.Translation.get('listOfTitles', 'dr,dr,doctor,mr,ms,miss,mrs,prof,professor,mrx');
	titleArr = titleArr.split(',');

	let firstName = result.firstName.toLowerCase();
	firstName = firstName.replaceAll('.', '');

	if(titleArr.indexOf(firstName) < 0) 
		return result;

	if(result.hasOwnProperty('middleName') && result.middleName.trim() != ""){
		result.firstName = result.middleName;
	}else{
		result.firstName = result.lastName;
		if(result.hasOwnProperty('jobs') 
			&& result.jobs.length > 0 
			&& result.jobs[0].hasOwnProperty('title') 
			&& result.jobs[0].title.trim() != ""  
			&&  SalesToolkit.Theme.getBooleanProperty('tryUseTitleAsLastName', true)){
			result.lastName = result.jobs[0].title;
		}else{
			result.lastName = "";
		}
	}

	return result;
}

function populateFormFromScan($form, info) {
	
	trackAppClick($form, $form.attr('id'), 'trackingFilledFormFromScan', SalesToolkit.Translation.get('trackingFilledFormFromScan', 'trackingFilledFormFromScan'), info);
           
	for (fieldName in info) {
		if (!(info.hasOwnProperty(fieldName))) {
			continue;
		}

		if(typeof info[fieldName] === 'string')
		{

			let formFieldName = fieldName;
			if (fieldName === 'id') {
				formFieldName = 'externalId';
			}
			
			if(SalesToolkit.Theme.getStringProperty('overrideFieldName_'+formFieldName, '').length > 0){
				formFieldName = SalesToolkit.Theme.getStringProperty('overrideFieldName_'+formFieldName, '');
			}

			let $field = $form.find(
				'input[name="' + formFieldName + '"]'
				+ ', select[name="' + formFieldName + '"]'
				+ ', textarea[name="' + formFieldName + '"]'
			);

			if ($field.length > 0) {
				//Directly set
				setFieldValue($field, info[fieldName]);
			}
		}else{
			if(fieldName === 'emails'){
				var $fields = $form.find("input[data-type='EMAIL']");
				let address = info.emails[0]?.address;
				$fields.each(function () {
					setFieldValue($(this), address);
				});
			}else if(fieldName === 'phones'){
				var $fields = $form.find("input[data-type='PHONE']");
				if($fields.length == 0){
					$fields = $form.find(
						'input[name="phone"]'
					);
				}

				for(let i = 0; i<info.phones.length; i++){
					let phoneNo = info.phones[i]?.number;
					if(validatePhone(phoneNo)){
						$fields.each(function () {
							setFieldValue($(this), phoneNo);
						});

						break;
					}
				}
			}else if(Array.isArray(info[fieldName])){
				populateFromArray(info[fieldName], $form, fieldName);
			}else if(typeof info[fieldName] === 'object'){
				populateFromObj(info[fieldName], $form, fieldName);
			}
		}
		
	}
	handleDependencies($form);
}

function populateFromObj(obj, $form, parentFieldName = ""){
	for(fieldName in obj){
	
		if (!(obj.hasOwnProperty(fieldName))) {
			continue;
		}

		let formFieldName = fieldName;
		if(fieldName === 'id') {
			formFieldName = 'externalId';
		}

		if(parentFieldName.length > 0 && SalesToolkit.Theme.getBooleanProperty('useCompoundFieldNameMatching', true)){
			formFieldName = parentFieldName + formFieldName.charAt(0).toUpperCase() + formFieldName.slice(1);
		}

		if(SalesToolkit.Theme.getStringProperty('overrideFieldName_'+formFieldName, '').length > 0){
			formFieldName = SalesToolkit.Theme.getStringProperty('overrideFieldName_'+formFieldName, '');
		}

		if(typeof obj[fieldName] === 'string')
		{

			let $field = $form.find(
				'input[name="' + formFieldName + '"]'
				+ ', select[name="' + formFieldName + '"]'
				+ ', textarea[name="' + formFieldName + '"]'
			);

			$field = $field.not('.ignore');

			if ($field.length === 0 && formFieldName === 'email') {
				formFieldName = "to";
				$field = $form.find(
					'input[name="' + formFieldName + '"]'
					+ ', select[name="' + formFieldName + '"]'
					+ ', textarea[name="' + formFieldName + '"]'
				);
			}

			if ($field.length > 0) {
				//Directly set
				setFieldValue($field, obj[fieldName]);
			}
		}else if(Array.isArray(obj[fieldName])){
			populateFromArray(obj[fieldName], $form, fieldName);
		} else if (typeof obj[fieldName] === 'object'){
			populateFromObj(obj[fieldName], $form, fieldName);
		}
	}
}

function populateFromArray(arr, $form, parentFieldName = ""){
	let i;
	for(i = 0; i < arr.length; i++){
		let entry = arr[i];
		if(Array.isArray(entry)){
			populateFromArray(entry, $form, parentFieldName);
		}else if(typeof entry === 'object'){
			populateFromObj(entry, $form, parentFieldName);
		}
	}
}

function populateFormWithContact($form, contact, preventAlreadyCapturedPopup = false) {
	 
	
	if(!(contact instanceof Atheneum.Contact)){
		contact  = new Atheneum.Contact(contact);
	}

	trackAppClick($form, $form.attr('id'), 'trackingFilledFormFromContact', SalesToolkit.Translation.get('trackingFilledFormFromContact', 'trackingFilledFormFromContact'), { contactId : contact.id, info: contact.info });
   
	let info = contact.info;
	if(info == undefined)
		return;
	for (fieldName in info) {
		if (!(info.hasOwnProperty(fieldName))) {
			continue;
		}

		$field = $form.find(
			'input[name="' + fieldName + '"]'
			+ ', select[name="' + fieldName + '"]'
			+ ', textarea[name="' + fieldName + '"]'
		);

		if ($field.length == 0) {
			// field capitalization may not match, do a slower case-insensitive check	
			var matches = [];
			var $fields = $form.find('input[name], select[name], textarea[name]');
			$fields.each(function () {
				if ($(this).attr('name').toLowerCase() == fieldName.toLowerCase()) {
					matches.push(this);
				}
			});
			$field = $(matches);
		}
		setFieldValue($field, info[fieldName]);
	}

	var $emailField = $form.find("input[data-type='EMAIL']");
	if ($emailField.length > 0) {
		onFormContactSelect($form, contact, $emailField, preventAlreadyCapturedPopup);
	}
	

	handleDependencies($form);
}

$('#addAttendeePopup .save-btn').off('click').on('click', function () {

	var $form = $('#addAttendeeForm');

	
	if (validateForm($form)) {
		var index = $('#addAttendeeForm').data('attendeeId');
		getFormData($form, function(formData){
			formData['CONTACT_ID'] = $form.data('contact-id');
		
			for (fieldName in formData) {
				if (!(formData.hasOwnProperty(fieldName))) {
					continue;
				}
				$field = $form.find(
					'.atheneum-form-field input[name="' + fieldName + '"]'
					+ ', .atheneum-form-field select[name="' + fieldName + '"]'
					+ ', .atheneum-form-field textarea[name="' + fieldName + '"]'
				);

				if ($field.length == 0) {
					// field capitalization may not match, do a slower case-insensitive check	
					var matches = [];
					var $fields = $form.find('.atheneum-form-field input[name], .atheneum-form-field select[name], .atheneum-form-field textarea[name]');
					$fields.each(function () {
						if ($(this).attr('name').toLowerCase() == fieldName.toLowerCase()) {
							matches.push(this);
						}
					});
					$field = $(matches);
				}

				if($field.data('type') === 'CHECKBOX'){
					attendeeList[index][fieldName] = $field.is(':checked');
				}else{
					attendeeList[index][fieldName] = $field.val();
				}
				
				
			}

			clearForm($form);
			vPopup.create({
				title: '',
				message: 'Edited attendee'
			});

			$('#addAttendeePopup').modal('hide');
			showAttendeeTable();
		});
		
	}
});

$('#addAttendeePopup .close-btn').off('click').on('click', function () {
	$('#form-holder').activity(false);
	$('#addAttendeePopup').modal('hide');
	var $form = $('#addAttendeeForm');
	$form.find('.invalid,.previously-invalid').removeClass('invalid previously-invalid');
	showAttendeeTable();
});

$('#addAttendeePopup .add-btn').off().on('click', function () {
	var $form = $('#addAttendeeForm');
	if (validateForm($form)) {
		getFormData($form, function(formData){
			formData['CONTACT_ID'] = $form.data('contact-id');
			var $emailInput = $('#addAttendeeForm').find('input[type="email"]').first();
			var emailInputId = $emailInput.attr('id');

			if ($emailInput && emailInputId && attendeeList && attendeeList.length > 0 && attendeeList.find(function (object) { return object[emailInputId] == formData[emailInputId] })) {
				var $label = $('label[for="' + emailInputId + '"]');
				$emailInput.addClass('invalid');
				$label.addClass('invalid');

				atheneumInstance.UI.Notifications.showCustomNotification("info", atheneumInstance.Translation.getOrGetThemeKey('attendeeAlreadyExists', 'Attempted to add an attendee with the same email address as an existing one, please check and try again'));
				return;
			} else if ($emailInput) {
				var $label = $('label[for="' + emailInputId + '"]');
				$emailInput.removeClass('invalid');
				$label.removeClass('invalid');
			}

			formData["index"] = (attendeeList.length == 0 ? 0 : attendeeList[attendeeList.length - 1].index + 1);
			formData["adHoc"] = false;
			attendeeList.push(formData);
			clearForm($form);
			$('#addAttendeePopup').modal('hide');
			showAttendeeTable();
		});
		
	}
});


function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

function showAttendeeTable() {

	var elements = document.getElementsByClassName("attendeesTableWrapper");
	while (elements.length > 0) {
		elements[0].parentNode.removeChild(elements[0]);
	}

	if (attendeeList.length > 0) {

		var attendeesTableColumnsThemeKeyValue = atheneumInstance.Theme.getStringProperty('attendeesTableColumns', 'firstName,lastName,to,adHoc');
		var attendeesTableVisibleColumns = [];
		var attendeesTableColumnsPreTrim = attendeesTableColumnsThemeKeyValue.split(',');
		for (var b = 0; b < attendeesTableColumnsPreTrim.length; b++) {
			var attendeesTableColumn = attendeesTableColumnsPreTrim[b].trim();
			if (attendeesTableColumn.length == 0) {
				continue;
			}
			attendeesTableVisibleColumns.push(attendeesTableColumn);
		}

		var requiredAttendeeFormFields = [];
		var attendeeFormFields = $('#addAttendeeForm').find('input[name], select[name], textarea[name]').not('.ignore, .freeText');
		for (var i = 0; i < attendeeFormFields.length; i++) {
			if ((attendeesTableVisibleColumns.indexOf(attendeeFormFields[i].name) != -1)) { //attendeeFormFields[i].required &&
				requiredAttendeeFormFields.push(attendeeFormFields[i].name);
			}
		}

		var table = '<div class="attendeesTableWrapper"><div id="attendeesTable"></div></div>';
		let $section = (currentSection == null) ? $form : ($('#' + currentSection).length == 0) ? $form : $('#' + currentSection);
		$section.append(table);

		
		$('#attendeesTable').html("");
		
	let sortingProperty = SalesToolkit.Theme.getStringProperty('attendeeSortingProperty', 'firstName');
	let sortingDirection = SalesToolkit.Theme.getStringProperty('attendeeSortingDirection', 'asc');
		attendeeList.sort(function(a,b){
			let propertyA = a[sortingProperty] || '';
			let propertyB = b[sortingProperty] || '';

			if(typeof propertyA === 'string'){
				return sortingDirection == 'asc'? propertyA.localeCompare(propertyB) : propertyB.localeCompare(propertyA);
			}

			return sortingDirection == 'asc'? (propertyA-propertyB) : (propertyB-propertyA);

		});

		let remoteConsentForm = atheneumInstance.Forms.getFormsAssociatedWithCollectionOfType(null, 'REMOTE_CONSENT')[0];
		let widthLabel = SalesToolkit.Theme.getStringProperty('attendeeTableLabelWidth', '75px');
		
		for (var i = 0; i < attendeeList.length; i++) {
			var rowClass = "even";
			if (i % 2 == 0) {
				rowClass = "odd";
			}
			var tableRow = "<div class='attendeeRow " + rowClass + "' id=" + attendeeList[i].index + "><div class='infoWrapper'>";
			for (var k = 0; k < requiredAttendeeFormFields.length; k++) {
				let name = remoteConsentForm?.fields.find(x=> x.name === requiredAttendeeFormFields[k])?.label || capitalizeFirstLetter(requiredAttendeeFormFields[k]);
				if(name.endsWith('*'))
					name = name.substring(0, name.length - 1);

				let value = (typeof attendeeList[i][requiredAttendeeFormFields[k]] === 'undefined' ? '' : attendeeList[i][requiredAttendeeFormFields[k]]);
				var breakAtAt = SalesToolkit.Theme.getBooleanProperty('shouldBreakEmailsAtAt', true);

				if (breakAtAt && value.contains('@')) {
					value = value.replaceAll('@', '<wbr>@<wbr>');
				}

				var breakAtPlus = SalesToolkit.Theme.getBooleanProperty('shouldBreakEmailsAtPlus', true);
	
				if (value && breakAtPlus && value.contains('+')) {
					value = value.replaceAll('+', '<wbr>+<wbr>');
				}
	
				var breakAtFullStops = SalesToolkit.Theme.getBooleanProperty('shouldBreakEmailsAtFullStops', false);
	
				if (value && breakAtFullStops && value.contains('.')) {
					value = value.replaceAll('.', '<wbr>.<wbr>');
				}
				tableRow += "<div class='attendeeTableColumn'><span class='attendeeTableLabel' style='width:"+widthLabel+"'>"+name+":</span><span class='attendeeTableInfo'>" +  value + "</span></div>";
			}
			
			if (attendeesTableVisibleColumns.indexOf('adHoc') != -1) {
				let name = SalesToolkit.Translation.get('adHocLabel', 'Adhoc');
				tableRow += "<div class='attendeeTableColumn'><span class='attendeeTableLabel' style='width:"+widthLabel+"'>"+name+":</span><input class='ignore' onclick='return false;' type='checkbox' " + (attendeeList[i].adHoc == true ? 'checked' : '') + "/></div>";
			}

			tableRow += '</div>'
			tableRow += "<div class='buttonsWrapper'>";
			tableRow += "<div><input type='button' class='btn salestoolkit-blue btn-primary editAttendeeButton editAttendeeButtonColumn ignore' value='" + atheneumInstance.Translation.get('edit', 'Edit') + "' onclick='showEditAttendeePopup(" + attendeeList[i].index + "); '"
				+ "></div>";
			
			tableRow += "<div><input type='button' style='background-color: #b00 !important;  color: #fff!important;' class='btn salestoolkit-blue btn-primary removeAttendeeButton removeAttendeeButtonColumn ignore' value='" + atheneumInstance.Translation.get('remove', 'Remove') + "'"
				+ "></div>";
			
			tableRow += '</div>'
			
			tableRow += '</div>'
			$('#attendeesTable').append(tableRow);

		}

		$.tablesorter.defaults.widgets = ['zebra'];
		$("#attendeesTable").tablesorter({ theme: 'blue' });
		$('#attendeesTable .removeAttendeeButton').on('click', function (e) {
			e.preventDefault();
			var rowId = $(this).parents('.attendeeRow').attr('id');
			if ($('#' + rowId).length) {
				var index;
				for (var i = 0; i < attendeeList.length; ++i) {
					if (attendeeList[i].index == rowId) {
						index = i;
						break;
					}
				}
				attendeeList.splice(index, 1);
			}
			showAttendeeTable();
		});
	}
}
/*
function getBase64(file) {
	return new Promise((resolve, reject) => {
	    const reader = new FileReader();
	    reader.readAsDataURL(file);
	    reader.onload = () => resolve(reader.result);
	    reader.onerror = error => reject(error);
	});
}
*/


function editMeeting(mId, meetingCollectionId) {
	//open pre-populate create meeting form
	showFormScreen(atheneumInstance.Forms.getFormsAssociatedWithCollectionOfType(meetingCollectionId, 'CREATE_MEETING')[0].id, { meetingId: mId } );
}

function populateFormWithMeetingData($form, meetingData) {
	$('#titleSection').text(atheneumInstance.Translation.getOrGetThemeKey('editMeetingTitle', 'Edit ' + meetingData.info.name));
	var $formFields = $form.find('input[name], select[name], textarea[name]').not('.ignore, .freeText');
	for (var f = 0; f < $formFields.length; f++) {
		var $field = $formFields.eq(f);
		var fieldName = $field.attr('name');
		if ($field.attr('id') == 'name') {
			$field.val(meetingData.info.name);
			$formFields[f].dataset.defaultValue = meetingData.info.name;
		} else if ($field.attr('id') == 'date' || $field.attr('id') == 'startDate') {
			let format = $field.data('format') || 'ddMMyyyy HH:mm';
			var date;
			var dateString = meetingData.info.date || meetingData.info.startDate;
			var reggie = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/;
			var dateArray = reggie.exec(dateString);
			if (dateArray != null) {
				var dateObject = new Date(
					(+dateArray[3]),
					(+dateArray[2]) - 1,
					(+dateArray[1]),
					(+dateArray[4]),
					(+dateArray[5])
				);
				date = new Date(dateObject);
			}

			if (date) {
				$field[0].valueAsNumber = date.getTime() - (dateObject.getTimezoneOffset() * 1000 * 60) ;
				$formFields[f].dataset.defaultValue = meetingData.info.date || meetingData.info.startDate;
			}
		} 
		else if ($field.attr('id') == 'allowAdHocParticipants') {
			$field.prop('checked', meetingData.info.allowAdHocParticipants == 'true');
			$formFields[f].dataset.defaultValue = meetingData.info.allowAdHocParticipants == 'true';
		}
	}
	var participants = meetingData.participants || [];
	participants.sort(compareParticipants);
	attendeeList = [];
	for (var i = 0; i < participants.length; i++) {
		var attendeeObject = participants[i].info;
		attendeeObject["index"] = i;
		attendeeObject["meetingId"] = meetingData.id;
		attendeeObject["id"] = participants[i].id;
		attendeeObject["adHoc"] = participants[i].adHoc;
		attendeeList.push(attendeeObject);
	}
	attendeeListCloned = JSON.parse(JSON.stringify(attendeeList));
	showAttendeeTable();
}

function compareParticipants(a, b) {
	if (parseInt(a.info.order) < parseInt(b.info.order)) {
		return -1;
	}
	if (parseInt(a.info.order) > parseInt(b.info.order)) {
		return 1;
	}
	return 0;
}

//var attendeesCSVUpload = '';
//$('#attendeesCSVUpload').change(function(){
//	var file = document.getElementById("attendeesCSVUpload").files[0];
//	getBase64(file).then(data => {
//	  console.log(data);
//	  attendeesCSVUpload = data;
//	});
//});

function showMeetingBackButtonPopup() {
	vPopup.create({
		title: atheneumInstance.Translation.getOrGetThemeKey('meetingFormSaveTitle', 'Unsaved Changes!'),
		message: atheneumInstance.Translation.getOrGetThemeKey('meetingFormSaveMessage', 'Would you like to save the meeting or lose all changes?'),
		buttons: [
			{
				action: "SAVE",
				text: atheneumInstance.Translation.getOrGetThemeKey('meetingFormSaveYesButton', 'Save'),
				callback: function () {
					saveMeetingForm();
				}
			},
			{
				action: "CLOSE",
				text: atheneumInstance.Translation.getOrGetThemeKey('meetingFormSaveNoButton', 'Close'),
				callback: function () {
					showMeetingsScreen();
				}
			}
		]
	});
}

function showConsentStatusInfo(notificationText, participantsId) {
	if ($('.non-modal-notification[data-notification-type="CONSENT"][data-notification-subjectId="' + participantsId + '"]').length == 0) {
		atheneumInstance.UI.Notifications.showCustomNotification("consent", notificationText, undefined, undefined, participantsId);
	}
};

function meetingFormHasChanges($form, formState) {
	var result = false;
	var $formFields = $form.find('input[name], select[name], textarea[name]').not('.ignore, .freeText');
	for (var f = 0; f < $formFields.length; f++) {
		var el = $formFields[f];
		if (el.type == 'checkbox') {
			if ('defaultValue' in el.dataset && (el.dataset.defaultValue.toLowerCase() === 'true') !== el.checked) {
				return true;
			}
		} else if (formState == 'new' && el.dataset.type == 'DATE') {
			continue;
		} else if ('defaultValue' in el.dataset && el.dataset.defaultValue !== el.value) {
			return true;
		}
	}
	if (attendeeList.length != attendeeListCloned.length) {
		return true;
	}
	result = JSON.stringify(attendeeList) !== JSON.stringify(attendeeListCloned);

	return result;
}

function saveMeetingForm() {
	if (validateForm($('#form-holder'))) {
		var form = atheneumInstance.Forms.getFormsAssociatedWithCollectionOfType(null, 'CREATE_MEETING')[0];
		$('#form-holder').activity(true);
		$('#form-holder').data('activity')?.css('z-index', '1');
		getFormData($('#form-holder'), function(formData){
			formData.shareLink = true;
			let successPopupTitle = null;
			let successPopupMessage = null;

			if(typeof form === 'undefined' && typeof formId === 'string')
				form = atheneumInstance.Forms.formList[formId];

			let formProperties = form?.properties || { };

			if ($('#form-holder').data('type') == atheneumInstance.Forms.Types.CREATE_MEETING) {
				if (formProperties['allowAdHocMeetingWithoutParticipants'] === 'off' && (attendeeList.length == 0 && (formData.attendeesCSVUpload == '' || formData.attendeesCSVUpload == null))) {
					vPopup.create({
						title: atheneumInstance.Translation.getOrGetThemeKey('errorTitleMeeting', 'Error'),
						message: atheneumInstance.Translation.getOrGetThemeKey('errorMeeting', 'At least one attendee required')
					});
					$('#form-holder').activity(false);
					return false;
				}

				if(typeof meetingId === 'string'){
					formData.meetingId = meetingId;
				}
				
				formData.allowAdHocParticipants = $('#allowAdHocParticipants').is(':checked');
				if ((formData.attendeesCSVUpload == '' || formData.attendeesCSVUpload == null) && attendeeList.length != 0) {
					let tableRows = document.getElementById("attendeesTable").children;
					attendeeList.forEach(function (entry) {
						let i;
						for (i = 0; i < tableRows.length; i++) {
							if (entry['index'] == tableRows[i].id) {
								entry['order'] = i;
							}
						}
					});
					//in case if they delete all records from attendeeList and add a new once, we can get meetingId from cloned list
					if (attendeeListCloned.length > 0) {
						formData.meetingId = attendeeListCloned[0].meetingId;
					}
					formData.participants = attendeeList.map(function (item) {
						delete item.index;
						delete item.meetingId;
						delete item.adHoc;
						return item;
					});
					formData.email = attendeeList.map(function (val) {
						return val.email;
					}).join(',');
				}

				atheneumInstance.Forms.submitForm(form, formData, {
					success: function (json) {
						$('#form-holder').activity(false);
						showMeetingsScreen();
						// if remote consent requested, start polling for notifications every 10 seconds
						if ($('#form-holder').data('type') == atheneumInstance.Forms.Types.REMOTE_CONSENT
							|| $('#form-holder').data('type') == atheneumInstance.Forms.Types.CREATE_MEETING
							|| $('#form-holder input[data-type=REMOTE_CONSENT]:checked').length >= 1) {
							pollingForRemoteConsentNotif = true;
							prevNotifInterval = atheneumInstance.Atheneum.UI.Notifications.pollInterval;
							// set polling interval to 10 secs
							atheneumInstance.Atheneum.UI.Notifications.setPollInterval(remoteConsentNotifInterval || 10000);
							// start polling (0 is the initial delay)
							atheneumInstance.Atheneum.UI.Notifications.startPolling(0, notificationPollCallback)
						}
					},
					failure: function (reason, httpStatus, errorCode) {
						// for some reason the server won't accept the form
						// most likely, because there's something wrong with the form itself
						$('#form-holder').activity(false);

						var errorCodeHex = undefined;
						if (typeof errorCode == 'number') {
							errorCodeHex = errorCode.toString(16);
							while (errorCodeHex.length < 8) {
								errorCodeHex = '0' + errorCodeHex;
							}
						}
						vPopup.create({
							title: atheneumInstance.Translation.getOrGetThemeKey('errorTitle', atheneumInstance.Translation.getOrGetThemeKey('error', 'Error')),
							message: atheneumInstance.Translation.getOrGetThemeKey('error' + errorCodeHex, atheneumInstance.API.ErrorCodes.getName(errorCode))
						});
					},
				});
			}
		});
	}
}

/**
 * END MEETINGS
 *  **/

var contactsUpdatePollInterval = null;
function setContactsUpdatePollInterval(interval, immediate) {
	if (contactsUpdatePollInterval) {
		window.clearInterval(contactsUpdatePollInterval);
		contactsUpdatePollInterval = null;
	}
	contactsUpdatePollInterval = window.setInterval(contactsUpdatePollIntervalTriggered, interval);
	if (immediate) {
		contactsUpdatePollIntervalTriggered();
	}
}

setContactsUpdatePollInterval(10000);
function contactsUpdatePollIntervalTriggered() {
	if (!requestedContacts && !atheneumInstance.Proxy.enabled && atheneumInstance.Theme.getBooleanProperty('autoLoadContacts', true)) {
		requestedContacts = true;
		contactsLoaded = false;
		updateWhenContactsReady({
			success: function (json) {
				if (requestedContacts) {
					contactsLoaded = true;
				}
				if (json.contacts.length > 0 && window.location.href.indexOf('contacts.html') >= 0) {
					editContactsTable(json.contacts);
				}
			}
		});
	}
}

if (atheneumInstance.Theme.getBooleanProperty('disallowEmojisOnInputs', true)) {
	jQuery(document).ready(function ($) {
		// Regex taken from https://www.re1gextester.com/106421
		var RE_EMOJI = /(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])/g;
		var $doc = $(document);

		$doc.on('input', 'input', function (event) {
			var $elem = $(this);
			var content = $elem.val();
			if (RE_EMOJI.test(content)) {
				$elem.val(content.replace(RE_EMOJI, ''));
			}
		});

		$doc.on('input', 'textarea', function (event) {
			var $elem = $(this);
			var content = $elem.val();
			if (RE_EMOJI.test(content)) {
				$elem.val(content.replace(RE_EMOJI, ''));
			}
		});
	});
}


function humanFileSize(bytes, si=false, dp=1) {
	const thresh = si ? 1000 : 1024;
  
	if (Math.abs(bytes) < thresh) {
	  return bytes + ' B';
	}
  
	const units = si 
	  ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] 
	  : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
	let u = -1;
	const r = 10**dp;
  
	do {
	  bytes /= thresh;
	  ++u;
	} while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);
  
  
	return bytes.toFixed(dp) + ' ' + units[u];
  }